import MaterialReactTable from 'material-react-table'
import React, { useEffect, useMemo, useState } from 'react'
import { FormGroup, Modal, ModalBody, ModalFooter, ModalHeader, Input, Button, Container, Label, Spinner, Card, CardHeader, CardBody, Row } from 'reactstrap'
import oikosApi from "../../services/oikos";
import qs from 'qs';
import Select from '../../components/Template/Input/Select';
import { selectValues } from '../../utils/fc';
import ModalConfirmacao from '../../components/Modals/ModalConfirmacao/ModalConfirmacao';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import currencyFormatter from '../../utils/currencyFormatter';
import "./Orcamentacao.css"; // we'll create this file below
import MaskedInput from '../../components/Template/Input/MaskedInput';
import { notifyError } from '../../utils/notify';

function Orcamentacao() {
  const [emBranco, setEmBranco] = useState(false);
  const [servicoCompostoMode, setServicoCompostoMode] = useState(false);
  const [isModalWarningOpen, setIsModalWarningOpen] = useState(false);
  const [modelosPropostas, setModelosPropostas] = useState([]);
  const [modelosServicos, setModelosServicos] = useState([]);
  const [macroatividades, setMacroatividades] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [prodsProp, setProdsProp] = useState([]);
  const [propItens, setPropItens] = useState([]);
  const [eventosPagamentoProp, setEventosPagamentoProp] = useState([]);
  const [selectedMacroatividades, setSelectedMacroatividades] = useState([]);
  const [selectedProdsProp, setSelectedProdsProp] = useState([]);
  const [selectedEpsProp, setSelectedEpsProp] = useState([]);
  const [servicosCompostos, setServicosCompostos] = useState([]);
  const [composicaoDeServicos, setComposicaoDeServicos] = useState([]);
  const [propItensShowed, setPropItensShowed] = useState([]);
  const [modalMacroatividadeOpen, setModalMacroatividadeOpen] = useState(false);
  const [isEditingMacroatividade, setIsEditingMacroatividade] = useState(false);
  const [isEditingProdProp, setIsEditingProdProp] = useState(false);
  const [isEditingEventoPagamentoProp, setIsEditingEventoPagamentoProp] = useState(false);
  const [modalAddServicoOpen, setModalAddServicoOpen] = useState(false);
  const [modalEditServicoOpen, setModalEditServicoOpen] = useState(false);
  const [modalProdPropOpen, setModalProdPropOpen] = useState(false);
  const [modalEpOpen, setModalEpOpen] = useState(false)
  const [modalPropItemOpen, setModalPropItemOpen] = useState(false);
  const [modalPropItemEditOpen, setModalPropItemEditOpen] = useState(false);
  const [modalPropItemDeleteOpen, setModalPropItemDeleteOpen] = useState(false);
  const [modalPropItemToMacroatividadeOpen, setModalPropItemToMacroatividadeOpen] = useState(false);
  const [modalEditPropItemMacroatividadeOpen, setModalEditPropItemMacroatividadeOpen] = useState(false);
  const [macroatividadeData, setMacroatividadeData] = useState({});
  const [prodPropData, setProdPropData] = useState({});
  const [propItemData, setPropItemData] = useState({});
  const [eventoPagamentoPropData, setEventoPagamentoPropData] = useState({});
  const [modeloServicoData, setModeloServicoData] = useState({});
  const [propostaData, setPropostaData] = useState({});
  const [negociacao, setNegociacao] = useState({});
  const [negociacaoData, setNegociacaoData] = useState({});
  const [originalPropostaData, setOriginalPropostaData] = useState({});
  const [isLoadingSelected, setIsLoadingSelected] = useState(false);
  const [isSavingProposta, setIsSavingProposta] = useState(false);
  const [isSavingNegociacao, setIsSavingNegociacao] = useState(false);
  const [isLoadingEditServico, setIsLoadingEditServico] = useState(0);
  const [isLoadingShowPropItens, setIsLoadingShowPropItens] = useState(false);
  const [isLoadingServicos, setIsLoadingServicos] = useState(false);
  const [isSubmitEntityLoading, setIsSubmitEntityLoading] = useState(false)
  const [activeId, setActiveId] = useState('');
  const [macroatividadeDetails, setMacroatividadeDetails] = useState({});
  const [loadingMacroatividadeRows, setLoadingMacroatividadeRows] = useState([]);
  const [produtoDetails, setProdutoDetails] = useState({});
  const [loadingProdutoRows, setLoadingProdutoRows] = useState([]);
  const [eventoPagamentoDetails, setEventoPagamentoDetails] = useState({});
  const [loadingEventoPagamentoRows, setLoadingEventoPagamentoRows] = useState([]);
  const [modeloServicoOriginal, setModeloServicoOriginal] = useState({})
  const [selectedModeloProposta, setSelectedModeloProposta] = useState({});
  const [pjs, setPjs] = useState([]);
  const [modelosPropostaByServicoId, setModelosPropostaByServicoId] = useState([]);
  const [isLoadingModelosPropostaByServicoId, setIsLoadingModelosPropostaByServicoId] = useState(false);
  const [isLoadingModelosPropostas, setIsLoadingModelosPropostas] = useState(false);
  const [entitySelected, setEntitySelected] = useState(
    {
      showEPs: false,
      showMacroatividades: true,
      showProdutos: false,
      showRecursosHumanos: false,
      showLogistica: false,
      showEquipamentos: false,
      showDespesasGerais: false,
      showSubcontratacoes: false,
      showReceitas: false
    }
  );

  const [visaoGeralPercentuais, setVisaoGeralPercentuais] = useState({
    comissao: 0,
    custoFinanceiro: 0,
    taxaAdm: 0,
    remuneracaoEmpresa: 0,
  });

  const [itemGrSelected, setItemGrSelected] = useState(
    {
      showRecursosHumanos: true,
      showLogistica: false,
      showEquipamentos: false,
      showDespesasGerais: false,
      showSubcontratacoes: false,
      showReceitas: false
    }
  );

  const [entitySelectedInsideMacroatividades, setEntitySelectedInsideMacroatividades] = useState(
    {
      showRecursosHumanos: true,
      showLogistica: false,
      showEquipamentos: false,
      showDespesasGerais: false,
      showSubcontratacoes: false,
      showReceitas: false
    }
  );

  const parseNumericValue = (value) => {
    if (value === null || value === undefined) return null;

    const raw = String(value).trim();
    if (!raw) return null;

    const cleaned = raw.replace("%", "").replace(/\s/g, "");

    // Handles both pt-BR (`1.234,56`) and unmasked (`1234.56`) shapes
    let normalized = cleaned;
    const hasComma = normalized.includes(",");
    const hasDot = normalized.includes(".");

    if (hasComma && hasDot) {
      normalized = normalized.replace(/\./g, "").replace(",", ".");
    } else if (hasComma && !hasDot) {
      normalized = normalized.replace(",", ".");
    }

    normalized = normalized.replace(/[^\d.-]/g, "");
    const num = Number(normalized);
    return Number.isFinite(num) ? num : null;
  }

  const formatPercent = (value) => {
    const num = parseNumericValue(value);
    if (num === null) return "Sem Valor";

    const formatted = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(num);

    return `${formatted}%`;
  }

  const visaoGeralTotal = useMemo(() => {
    const macroatividadesArr = selectedMacroatividades || [];

    return macroatividadesArr.reduce((macroAcc, macroatividade) => {
      const propItensArr = macroatividade?.propItens || [];

      const macroTotal = propItensArr.reduce((itemAcc, propItem) => {
        const qtd = parseNumericValue(propItem?.relacaoMacroatividadePropItem_propItemQtd) || 0;
        const refVlr = parseNumericValue(propItem?.propItem_refVlr) || 0;
        return itemAcc + (refVlr * qtd);
      }, 0);

      return macroAcc + macroTotal;
    }, 0);
  }, [selectedMacroatividades]);

  const visaoGeralPercentualTotal = useMemo(() => {
    const { comissao, custoFinanceiro, taxaAdm, remuneracaoEmpresa } = visaoGeralPercentuais || {};
    return (
      (parseNumericValue(comissao) || 0) +
      (parseNumericValue(custoFinanceiro) || 0) +
      (parseNumericValue(taxaAdm) || 0) +
      (parseNumericValue(remuneracaoEmpresa) || 0)
    );
  }, [visaoGeralPercentuais]);

  const visaoGeralValorFinal = useMemo(() => {
    const base = parseNumericValue(visaoGeralTotal) || 0;
    const pct = parseNumericValue(visaoGeralPercentualTotal) || 0;
    return base * (1 + pct / 100);
  }, [visaoGeralTotal, visaoGeralPercentualTotal]);

  const columnsModelo = [
    {
      header: ' ',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <>
          {/* <Button onClick={async () => {
            const propPropItens = await fetchPropPropItemByPropId(row.original.prop_id);
            if (row.original.composicaoModeloServico_id) {
              setIsLoadingSelected(true);
              setServicoCompostoMode(true);
              const modelosSecundarios = await getModelosServicosIdByComposicaoServicosModelosId(row.original.composicaoModeloServico_id);
              const modelosSecundariosFormatted = modelosSecundarios.map(ms => {return {modeloServico_id: ms.modeloServico_id, modeloServico_secundario: true, servicoComposto: true}})
              await getEntidadesDosModelosByComposicaoModeloServicoId(row.original.composicaoModeloServico_id);
              await fetchServicosCompostos(row.original.composicaoModeloServico_id);

              setPropostaData({
                ...propostaData,
                propItens: propPropItens,
                modeloServico_ids: [...modelosSecundariosFormatted, {composicaoModeloServico_id: row.original.composicaoModeloServico_id, modeloServico_primario: true, servicoComposto: true}],
              })
              setIsLoadingSelected(false);
            } else {
              setServicoCompostoMode(false);
              setIsLoadingSelected(true);
              const modelosServ = await getModelosServicosByPropId(row.original.prop_id);
              setPropostaData({
                ...propostaData,
                propItens: propPropItens,
                modeloServico_ids: [...modelosServ],
              })
              setIsLoadingSelected(false);

            }
          }}>
            Utilizar
          </Button> */}
          <input type="checkbox"
            checked={selectedModeloProposta.prop_id === row.original.prop_id}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedModeloProposta(row.original);
              } else {
                setSelectedModeloProposta({});
              }
            }}
          />
        </>
      ),
    },
    {
      accessorKey: 'prop_id',
      header: 'ID',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.prop_id) {
          return row.prop_id;
        } else {
          return 'Sem ID';
        }
      },
    },
    {
      accessorKey: 'prop_nome',
      header: 'Nome',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.prop_nome) {
          return row.prop_nome;
        } else {
          return 'Sem Nome';
        }
      },
    },
  ]

  const columnsSelectedMacroatividades = [
    {
      accessorKey: 'macroatividade_nome',
      header: 'Nome',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.macroatividade_nome) {
          return row.macroatividade_nome;
        } else {
          return 'Sem Nome';
        }
      },
    },
    {
      accessorKey: 'modeloServico_nome',
      header: 'Serviço',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.modeloServico_nome) {
          return row.modeloServico_nome;
        } else {
          return 'Sem serviço';
        }
      },
    },
    {
      header: 'Ações',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <>
          <Button
          onClick={async () => {
            setIsEditingMacroatividade(true);
            const macroatividadeId = row.original.macroatividade_id;
            const macroatividadeValue = row.original.value;
            console.log(row.original);
            // Load propItens for this macroatividade
            let propItens = [];
            propItens = row.original.propItens;
            /* if(!row.original.relacaoServicoMacroatividade_id) {
            } else {
              propItens = await getPropItemsByMacroatividadeId(macroatividadeId, row.original.relacaoServicoMacroatividade_id);
            } */

            // Format propItens for the select component
            console.log('propItens', propItens)
            const formattedPropItens = propItens.map(pi => ({
              value: pi.propItem_id,
              label: `${pi.propItem_desc} (${pi.unidade_label})`,
              propItem_id: pi.propItem_id,
              propItem_desc: pi.propItem_desc,
              relacaoMacroatividadePropItem_propItemQtd: pi.relacaoMacroatividadePropItem_propItemQtd,
              ...pi
            }));
            // Set macroatividadeData with the row data and propItens
            setMacroatividadeData({
              ...row.original,
              macroatividade_id: macroatividadeId,
              value: macroatividadeValue,
              propItens: formattedPropItens,
              relacaoServicoMacroatividade_tempoEstimadoExecucaoDias: row.original.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias || 0
            });
            setModalMacroatividadeOpen(true);
          }}
          >
            Editar
          </Button>
        </>
      ),
    }
  ]

  const columnsSelectedPropPropItens = [
    {
      accessorKey: 'propItem_desc',
      header: 'Descrição',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propItem_desc) {
          return row.propItem_desc + ` (${row.unidade_label})`;
        } else {
          return 'Sem descrição';
        }
      },
    },
    {
      header: 'Quantidade total',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.relacaoPropPropItem_propItemQtd) {
          return row.relacaoPropPropItem_propItemQtd;
        } else {
          return 'Sem quantidade';
        }
      },
    },
    {
      header: 'Quantidade utilizada',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (selectedMacroatividades.filter(sm => sm.propItens.filter(pi => pi.propItem_id === row.propItem_id).length > 0).length > 0) {
          let total = 0;
          for (let index = 0; index < selectedMacroatividades.filter(sm => sm.propItens.filter(pi => pi.propItem_id === row.propItem_id).length > 0).length; index++) {
            const element = selectedMacroatividades.filter(sm => sm.propItens.filter(pi => pi.propItem_id === row.propItem_id).length > 0)[index].propItens.find(pi => pi.propItem_id === row.propItem_id).relacaoMacroatividadePropItem_propItemQtd;
            total = total + Number(element);
          }
          return total;
        } else {
          return 0;
        }
      },
    },
    /* {
      header: 'Valor ref p/ proposta',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (selectedMacroatividades.filter(sm => sm.propItens && sm.propItens.filter(pi => pi.propItem_id === row.propItem_id).length > 0).length > 0) {
          let total = 0;
          for (let index = 0; index < selectedMacroatividades.filter(sm => sm.propItens.filter(pi => pi.propItem_id === row.propItem_id).length > 0).length; index++) {
            const element = Number(selectedMacroatividades.filter(sm => sm.propItens.filter(pi => pi.propItem_id === row.propItem_id).length > 0)[index].propItens.find(pi => pi.propItem_id === row.propItem_id).relacaoMacroatividadePropItem_vlr) * Number(selectedMacroatividades.filter(sm => sm.propItens.filter(pi => pi.propItem_id === row.propItem_id).length > 0)[index].propItens.find(pi => pi.propItem_id === row.propItem_id).relacaoMacroatividadePropItem_propItemQtd);
            total = total + Number(element);
          }
          return currencyFormatter.format(total);
        } else {
          return 'Sem valor';
        }
      },
    }, */
    {
      header: 'Valor de referência',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propItem_refVlr) {
          return currencyFormatter.format(row.propItem_refVlr * row.relacaoPropPropItem_propItemQtd);
        } else {
          return 'Sem valor';
        }
      },
    },
    {
      header: ' ',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <>
          <Button onClick={() => {
            setPropItemData(row.original);
            setModalPropItemEditOpen(true)
          }}>
            Editar
          </Button>
        </>
      ),
    }
  ]

  const columnsSelectedMacroatividadesPropItens = [
    {
      accessorKey: 'propItem_desc',
      header: 'Descrição',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propItem_desc) {
          return row.propItem_desc + ` (${row.unidade_label})`;
        } else {
          return 'Sem descrição';
        }
      },
    },
    {
      header: 'Quantidade',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.relacaoMacroatividadePropItem_propItemQtd) {
          return row.relacaoMacroatividadePropItem_propItemQtd;
        } else {
          return 'Sem quantidade';
        }
      },
    },
    {
      header: 'Tempo estimado execução (dias)',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias) {
          return row.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias;
        } else {
          return 'Sem tempo estimado';
        }
      },
    },
    /* {
      header: 'Valor ref p/ proposta',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.relacaoMacroatividadePropItem_vlr) {
          return currencyFormatter.format(row.relacaoMacroatividadePropItem_vlr);
        } else {
          return 'Sem valor';
        }
      },
    }, */
    {
      header: 'Valor de referência',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propItem_refVlr) {
          return currencyFormatter.format(row.propItem_refVlr);
        } else {
          return 'Sem valor';
        }
      },
    },
    {
      header: ' ',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <>
          <Button
            onClick={() => {
              setModalEditPropItemMacroatividadeOpen(true);
              console.log('row.original', row.original)
              console.log('macroatividadeData', macroatividadeData)
              if (row.original.relacaoMacroatividadePropItem_id) {
                setPropItemData(macroatividadeData.propItens.find(pi => pi.relacaoMacroatividadePropItem_id === row.original.relacaoMacroatividadePropItem_id));
              } else {
                setPropItemData(macroatividadeData.propItens.find(pi => pi.value === row.original.value));
              }
              //setMacroatividadeData(selectedMacroatividades.find(m => m.macroatividade_id === row.original.macroatividade_id));
            }}
          >
            Editar
          </Button>
        </>
      ),
    },
  ]

  const columnsSelectedProdsProp = [
    {
      accessorKey: 'prodProp_nome',
      header: 'Nome',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.prodProp_nome) {
          return row.prodProp_nome;
        } else {
          return 'Sem Nome';
        }
      },
    },
    {
      accessorKey: 'modeloServico_nome',
      header: 'Serviço',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.modeloServico_nome) {
          return row.modeloServico_nome;
        } else if (modeloServicoData && modeloServicoData.modeloServico_nome) {
          return modeloServicoData.modeloServico_nome;
        } else {
          return 'Sem serviço';
        }
      },
    },
    /* {
      header: ' ',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <>
          <Button
            onClick={async () => {
              setIsEditingProdProp(true);
              const prodPropId = row.original.prodProp_id;
              const prodPropValue = row.original.value;
              console.log(row.original)

              setProdPropData({
                ...row.original,
                prodProp_id: prodPropId,
                value: prodPropValue,
              });
              setModalProdPropOpen(true);
            }}
          >
            Editar
          </Button>
        </>
      ),
    } */
  ]

  const columnsSelectedEventosPagamentoProp = [
    {
      accessorKey: 'eventoPagamentoProp_nome',
      header: 'Nome',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.eventoPagamentoProp_nome) {
          return row.eventoPagamentoProp_nome;
        } else {
          return 'Sem Nome';
        }
      },
    },
    {
      accessorKey: 'modeloServico_nome',
      header: 'Serviço',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.modeloServico_nome) {
          return row.modeloServico_nome;
        } else if (modeloServicoData && modeloServicoData.modeloServico_nome) {
          return modeloServicoData.modeloServico_nome;
        } else {
          return 'Sem serviço';
        }
      },
    },
    {
      accessorKey: 'relacaoServicoEventoPagamentoProp_vlr',
      header: 'Valor (%)',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => formatPercent(row.original.relacaoServicoEventoPagamentoProp_vlr),
    },
    {
      header: ' ',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <>
          <Button
            onClick={() => {
              const original = row.original || {};
              setEventoPagamentoPropData({
                ...original,
                eventoPagamentoProp_id: original.eventoPagamentoProp_id ?? original.value,
                eventoPagamentoProp_nome: original.eventoPagamentoProp_nome ?? original.label,
              });
              setIsEditingEventoPagamentoProp(true);
              setModalEpOpen(true);
            }}
          >
            Editar
          </Button>
        </>
      ),
    }
  ]

  const TABS = [
    {
      id: "tab-1",
      label: "Negociação",
      subtitle: "Defina o nome da negociação",
      content: (
        <Tabs>
          <TabList>
            <Tab>Criar proposta escolhendo modelos de serviço</Tab>
            <Tab>Criar proposta escolhendo modelo de proposta</Tab>
          </TabList>
          <TabPanel>
            <div>
              <FormGroup>
                <span>Cliente</span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={pjs}
                  value={pjs.find(pj => pj.value === negociacaoData.pj_id) || null}
                  onChange={async (e) => {
                    setNegociacaoData({
                      ...negociacaoData,
                      pj_id: e ? e.value : null,
                    })
                    console.log(modelosPropostas)
                  }}
                />
              </FormGroup>

              <FormGroup>
                <span>Serviço Principal</span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={servicos.filter(s => negociacaoData.servicos_secundarios ? !negociacaoData.servicos_secundarios.some(ss => ss.value === s.value) : true) || []}
                  value={servicos.find(s => s.value === negociacaoData.servico_principal) || null}
                  onChange={async (e) => {
                    setNegociacaoData({
                      ...negociacaoData,
                      servico_principal: e ? e.value : null,
                    })

                    if (e) {
                      const modelosPropostaByServicoIdArray = await fetchModelosPropostaByServicoId(e.value, true);
                      setModelosPropostaByServicoId([...modelosPropostaByServicoId.filter(mp => !mp.principal), ...modelosPropostaByServicoIdArray]);
                    } else {
                      setModelosPropostaByServicoId([...modelosPropostaByServicoId.filter(mp => !mp.principal)]);
                    }
                  }}
                />
              </FormGroup>

              <FormGroup>
                <span onClick={() => console.log(propostaData, negociacaoData, selectedMacroatividades, selectedEpsProp, selectedProdsProp)}>Modelo de serviço principal</span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={modelosServicos?.filter(ms => ms.servico_id === negociacaoData.servico_principal) || []}
                  value={modelosServicos?.find(ms => ms.value === propostaData.modeloServico_ids?.find(ms => ms.modeloServico_principal)?.modeloServico_id) || null}
                  onChange={async (e) => {
                    setIsLoadingServicos(true);
                    const modeloServico_idsCopy = propostaData.modeloServico_ids ? propostaData.modeloServico_ids.filter(ms => !ms.modeloServico_principal) : [];

                    setNegociacaoData({
                      ...negociacaoData,
                      modeloServico_principal: e ? e : null,
                    })

                    if (e) {
                      e = {...e, modeloServico_principal: true}

                      const selectedMacroatividadesCopy = [];
                      const selectedProdPropCopy = [];
                      const selectedEpsPropCopy = [];
                      const ms = e;
                      const selectedMacroatividadesFromModeloServico = selectedMacroatividades.filter(sma => sma.modeloServico_id === ms.value)
                      const selectedEPsFromModeloServico = selectedEpsProp.filter(sep => sep.modeloServico_id === ms.value)
                      const selectedProdsPropFromModeloServico = selectedProdsProp.filter(sep => sep.modeloServico_id === ms.value);

                      if (selectedMacroatividadesFromModeloServico.length === 0) {
                        const macroatividadesByModeloServico = await getMacroatividadesByModeloServicoId(ms.value);

                        if (selectedMacroatividades.length > 0) {
                          const selectedMacroatividadesCopy = [];

                          for (let i = 0; i < macroatividadesByModeloServico.length; i++) {
                            const rsm = macroatividadesByModeloServico[i];
                            if (selectedMacroatividades.find(sm => sm.macroatividade_id === rsm.macroatividade_id)) {
                              continue;
                            } else {
                              selectedMacroatividadesCopy.push(rsm);
                            }
                          }
                          setSelectedMacroatividades(prevState => [...prevState, ...selectedMacroatividadesCopy]);
                        } else {
                          setSelectedMacroatividades(prevState => [...prevState, ...macroatividadesByModeloServico]);
                        }
                      } else {
                        for (let index = 0; index < selectedMacroatividadesFromModeloServico.length; index++) {
                          const element = selectedMacroatividadesFromModeloServico[index];

                          selectedMacroatividadesCopy.push(element);
                        }
                        setSelectedMacroatividades([...selectedMacroatividadesCopy]);
                      }

                      if (selectedEPsFromModeloServico.length === 0) {
                        const epsPropByModeloServicoId = await getEPsPropByModeloServicoId(ms.value);
                        if (selectedEpsProp.length > 0) {
                          const selectedEpsPropCopy = [];
                          for (let i = 0; i < epsPropByModeloServicoId.length; i++) {
                            const rsep = epsPropByModeloServicoId[i];
                            if (selectedEpsProp.find(sep => sep.eventoPagamentoProp_id === rsep.eventoPagamentoProp_id)) {
                              continue;
                            } else {
                              selectedEpsPropCopy.push(rsep);
                            }
                          }
                          setSelectedEpsProp(prevState => [...prevState, ...selectedEpsPropCopy]);
                        } else {
                          setSelectedEpsProp(prevState => [...prevState, ...epsPropByModeloServicoId]);
                        }
                      } else {
                        for (let index = 0; index < selectedEPsFromModeloServico.length; index++) {
                          const element = selectedEPsFromModeloServico[index];
                          selectedEpsPropCopy.push(element);
                        }
                        setSelectedEpsProp([...selectedEpsPropCopy]);
                      }

                      if (selectedProdsPropFromModeloServico.length === 0) {
                        const prodsPropByModeloServicoId = await getProdsPropByModeloServicoId(ms.value);
                        if (selectedProdsProp.length > 0) {
                          const selectedProdsPropCopy = [];
                          for (let i = 0; i < prodsPropByModeloServicoId.length; i++) {
                            const rspp = prodsPropByModeloServicoId[i];
                            if (selectedProdsProp.find(sep => sep.prodProp_id === rspp.prodProp_id)) {
                              continue;
                            } else {
                              selectedProdsPropCopy.push(rspp);
                            }
                          }
                          setSelectedProdsProp(prevState => [...prevState, ...selectedProdsPropCopy]);
                        } else {
                          setSelectedProdsProp(prevState => [...prevState, ...prodsPropByModeloServicoId]);
                        }
                      } else {
                        for (let index = 0; index < selectedProdsPropFromModeloServico.length; index++) {
                          const element = selectedProdsPropFromModeloServico[index];

                          selectedProdPropCopy.push(element);
                        }
                        setSelectedProdsProp([...selectedProdPropCopy]);
                      }

                      setPropostaData({
                        ...propostaData,
                        modeloServico_ids: [...modeloServico_idsCopy, {...e}],
                      })

                    } else {

                      if (modeloServico_idsCopy.length > 0) {
                        const selectedMacroatividadesCopy = [];
                        const selectedProdsPropCopy = [];
                        const selectedEpsPropCopy = [];
                        for (let index = 0; index < modeloServico_idsCopy.length; index++) {
                          const element = modeloServico_idsCopy[index];
                          selectedMacroatividadesCopy.push(selectedMacroatividades.filter(m => m.modeloServico_id === element.modeloServico_id));
                          selectedProdsPropCopy.push(selectedProdsProp.filter(m => m.modeloServico_id === element.modeloServico_id));
                          selectedEpsPropCopy.push(selectedEpsProp.filter(m => m.modeloServico_id === element.modeloServico_id));
                        }
                        setSelectedMacroatividades(...selectedMacroatividadesCopy);
                        setSelectedProdsProp(...selectedProdsPropCopy);
                        setSelectedEpsProp(...selectedEpsPropCopy);
                      } else {
                        setSelectedMacroatividades([]);
                        setSelectedProdsProp([]);
                        setSelectedEpsProp([]);
                      }

                      setPropostaData({
                        ...propostaData,
                        modeloServico_ids: [...modeloServico_idsCopy],
                      })
                    }
                    setIsLoadingServicos(false);
                  }}
                />
              </FormGroup>

              <FormGroup>
                <span>Serviços Secundários</span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  isMulti
                  options={servicos.filter(s => s.value !== negociacaoData.servico_principal) || []}
                  value={servicos.filter(s => negociacaoData.servicos_secundarios?.some(ss => ss.value === s.value)) || null}
                  onChange={async (selectedOp, actionMeta) => {

                    setNegociacaoData({
                      ...negociacaoData,
                      servicos_secundarios: selectedOp ? selectedOp : null,
                    })

                    const { action, option, removedValue } = actionMeta;

                    // When selecting → duplicate with new value
                    if (action === 'select-option') {
                      const modelosPropostaByServicoIdArray = await fetchModelosPropostaByServicoId(option.value, false);
                      console.log(modelosPropostaByServicoId)
                      const unique = [...new Map([...modelosPropostaByServicoIdArray, ...modelosPropostaByServicoId.filter(mp => mp.principal)].map(item => [item.prop_id, item])).values()];
                      setModelosPropostaByServicoId(unique);
                    }

                    // When removing / clearing → trust react-select
                    if (action === "remove-value" || action === "pop-value") {

                      let modelosPropostaByServicoIdArray = modelosPropostaByServicoId.filter(mp => mp.principal);
                      if (selectedOp && selectedOp.length > 0) {
                        console.log(selectedOp)
                        for (let index = 0; index < selectedOp.length; index++) {
                          const fetchedModelosPropostaByServicoId = await fetchModelosPropostaByServicoId(selectedOp[index].value, false);
                          modelosPropostaByServicoIdArray = [...modelosPropostaByServicoIdArray, ...fetchedModelosPropostaByServicoId];
                        }
                        const unique = [...new Map([...modelosPropostaByServicoIdArray].map(item => [item.prop_id, item])).values()];
                        setModelosPropostaByServicoId(unique);
                      } else {
                        setModelosPropostaByServicoId(modelosPropostaByServicoIdArray);
                      }
                    }

                    if (action === "clear") {
                      setModelosPropostaByServicoId(modelosPropostaByServicoId.filter(mp => mp.servico_id === negociacaoData.servico_principal) || []); // Keep only modelosPropostas of the main service
                    }
                  }}
                />
              </FormGroup>

              <FormGroup>
                <span>Modelo de serviço secundário</span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  isMulti
                  options={modelosServicos?.filter(ms => negociacaoData.servicos_secundarios?.some(ss => ss.servico_id === ms.servico_id)) || []}
                  value={propostaData.modelosServico_ids?.filter(ms => ms.modeloServico_secundario) || null}
                  onChange={async (selectedOptions, actionMeta) => {
                    setIsLoadingServicos(true);

                    const { action, option, removedValue } = actionMeta;

                    const formattedModeloServicosSecundarios = propostaData.modelosServico_secundario || [];
                    const selectedMacroatividadesCopy = [];
                    const selectedProdPropCopy = [];
                    const selectedEpsPropCopy = [];

                    // When selecting → duplicate with new value
                    if (action === 'select-option') {

                      const selectedMacroatividadesFromModeloServico = selectedMacroatividades.filter(sma => sma.modeloServico_id === option.value)
                      const selectedEPsFromModeloServico = selectedEpsProp.filter(sep => sep.modeloServico_id === option.value)
                      const selectedProdsPropFromModeloServico = selectedProdsProp.filter(sep => sep.modeloServico_id === option.value)

                      formattedModeloServicosSecundarios.push({...option, modeloServico_secundario: true});

                      if (selectedMacroatividadesFromModeloServico.length === 0) {
                        const macroatividadesByModeloServico = await getMacroatividadesByModeloServicoId(option.value);

                        if (macroatividadesByModeloServico.length > 0) {
                          const selectedMacroatividadesCopy = [];

                          for (let i = 0; i < macroatividadesByModeloServico.length; i++) {
                            const rsm = macroatividadesByModeloServico[i];
                            if (selectedMacroatividades.find(sm => sm.macroatividade_id === rsm.macroatividade_id)) {
                              continue;
                            } else {
                              selectedMacroatividadesCopy.push(rsm);
                            }
                          }
                          console.log('1', [...selectedMacroatividades, ...selectedMacroatividadesCopy]);
                          setSelectedMacroatividades(prevState => [...prevState, ...selectedMacroatividadesCopy]);
                        } else {
                          console.log('2', [...selectedMacroatividades, ...macroatividadesByModeloServico]);
                          setSelectedMacroatividades(prevState => [...prevState, ...macroatividadesByModeloServico]);
                        }
                      } else {
                        for (let index = 0; index < selectedMacroatividadesFromModeloServico.length; index++) {
                          const element = selectedMacroatividadesFromModeloServico[index];

                          selectedMacroatividadesCopy.push(element);
                        }
                        console.log('3', selectedMacroatividadesCopy);
                        setSelectedMacroatividades(selectedMacroatividadesCopy);
                      }

                      if (selectedEPsFromModeloServico.length === 0) {
                        const epsPropByModeloServicoId = await getEPsPropByModeloServicoId(option.value);
                        if (epsPropByModeloServicoId.length > 0) {
                          const selectedEpsPropCopy = [];
                          for (let i = 0; i < epsPropByModeloServicoId.length; i++) {
                            const rsep = epsPropByModeloServicoId[i];
                            if (selectedEpsProp.find(sep => sep.eventoPagamentoProp_id === rsep.eventoPagamentoProp_id)) {
                              continue;
                            } else {
                              selectedEpsPropCopy.push(rsep);
                            }
                          }
                          console.log('1', [...selectedEpsProp, ...selectedEpsPropCopy]);
                          setSelectedEpsProp(prevState => [...prevState, ...selectedEpsPropCopy]);
                        } else {
                          console.log('2', [...selectedEpsProp, ...epsPropByModeloServicoId]);
                          setSelectedEpsProp(prevState => [...prevState, ...epsPropByModeloServicoId]);
                        }
                      } else {
                        for (let index = 0; index < selectedEPsFromModeloServico.length; index++) {
                          const element = selectedEPsFromModeloServico[index];

                          selectedEpsPropCopy.push(element);
                        }
                        console.log('3', selectedEpsPropCopy);
                        setSelectedEpsProp([...selectedEpsPropCopy]);
                      }

                      if (selectedProdsPropFromModeloServico.length === 0) {
                        const prodsPropByModeloServicoId = await getProdsPropByModeloServicoId(option.value);
                        if (prodsPropByModeloServicoId.length > 0) {
                          const selectedProdsPropCopy = [];
                          for (let i = 0; i < prodsPropByModeloServicoId.length; i++) {
                            const rspp = prodsPropByModeloServicoId[i];
                            if (selectedProdsProp.find(sep => sep.prodProp_id === rspp.prodProp_id)) {
                              continue;
                            } else {
                              selectedProdsPropCopy.push(rspp);
                            }
                          }
                          console.log('1', [...selectedProdsProp, ...selectedProdsPropCopy]);
                          setSelectedProdsProp(prevState => [...prevState, ...selectedProdsPropCopy]);
                        } else {
                          console.log('2', [...selectedProdsProp, ...prodsPropByModeloServicoId]);
                          setSelectedProdsProp(prevState => [...prevState, ...prodsPropByModeloServicoId]);
                        }
                      } else {
                        for (let index = 0; index < selectedProdsPropFromModeloServico.length; index++) {
                          const element = selectedProdsPropFromModeloServico[index];

                          selectedProdPropCopy.push(element);
                        }
                        console.log('3', selectedProdPropCopy);
                        setSelectedProdsProp([...selectedProdPropCopy]);
                      }

                      setPropostaData({
                        ...propostaData,
                        modeloServico_ids: [...(propostaData.modelosServico_ids?.map(ms => { return {...ms, modeloServico_secundario: true}}) || []), option],
                      })
                    }

                    // When removing / clearing → trust react-select
                    if (action === "remove-value" || action === "pop-value") {

                      const selectedMacroatividadesFromModeloServico = selectedMacroatividades.filter(sma => sma.modeloServico_id !== removedValue.value)
                      const selectedEPsFromModeloServico = selectedEpsProp.filter(sep => sep.modeloServico_id !== removedValue.value)
                      const selectedProdsPropFromModeloServico = selectedProdsProp.filter(sep => sep.modeloServico_id !== removedValue.value)

                      setSelectedMacroatividades([...selectedMacroatividadesFromModeloServico]);
                      setSelectedEpsProp([...selectedEPsFromModeloServico]);
                      setSelectedProdsProp([...selectedProdsPropFromModeloServico]);
                      setPropostaData({
                        ...propostaData,
                        modeloServico_ids: negociacaoData.modelosServico_secundarios.filter(ms => ms.value !== removedValue.value).map(ms => { return {...ms, modeloServico_secundario: true}}),
                      });
                    }

                    if (action === "clear") {

                      if (propostaData.modeloServico_principal) {
                        setSelectedMacroatividades(selectedMacroatividades.filter(m => m.modeloServico_id === propostaData.modeloServico_principal.modeloServico_id));
                        setSelectedProdsProp(selectedProdsProp.filter(m => m.modeloServico_id === propostaData.modeloServico_principal.modeloServico_id));
                        setSelectedEpsProp(selectedEpsProp.filter(m => m.modeloServico_id === propostaData.modeloServico_principal.modeloServico_id));
                      } else {
                        setSelectedMacroatividades([]);
                        setSelectedProdsProp([]);
                        setSelectedEpsProp([]);
                      }

                      setPropostaData({
                        ...propostaData,
                        modeloServico_ids: negociacaoData.modeloServico_principal ? [negociacaoData.modeloServico_principal] : [],
                      })
                    }

                    setIsLoadingServicos(false);
                  }}
                />
              </FormGroup>

              <FormGroup>
                <Label for="negociacao-nome">Nome da negociacao</Label>
                <Input
                  id="negociacao-nome"
                  type="text"
                  value={negociacaoData.negociacao_nome || ''}
                  onChange={(e) =>
                    setNegociacaoData({
                      ...negociacaoData,
                      negociacao_nome: e.target.value,
                    })
                  }
                />
              </FormGroup>

              {
                isLoadingServicos && <Spinner />
              }
              <br />
              {!isSavingNegociacao ? <Button
                color="primary"
                onClick={async () => {
                  setIsSavingNegociacao(true)
                  if (!negociacaoData.negociacao_nome || negociacaoData.negociacao_nome.trim() === '') {
                    notifyError('Adicione um nome para a proposta')
                    setIsSavingNegociacao(false)
                    return
                  }
                  const res = await oikosApi.post('/', {
                    action: 'insert',
                    table: 'negociacao',
                    data: {
                      negociacao_nome: negociacaoData.negociacao_nome,
                      pj_id: negociacaoData.pj_id,
                      servico_id: negociacaoData.servico_id,
                    }
                  });
                  setNegociacao({
                    ...res.data[0],
                  })
                  setNegociacaoData({});
                  setIsSavingNegociacao(false);
                  setActiveId("tab-2");
                }}
              >
                Criar proposta sem modelo
              </Button> : <Spinner/>}
              {!isSavingNegociacao ? <Button
                color="primary"
                onClick={async () => {
                  setIsSavingNegociacao(true)
                  if (!negociacaoData.negociacao_nome || negociacaoData.negociacao_nome.trim() === '') {
                    notifyError('Adicione um nome para a proposta')
                    setIsSavingNegociacao(false)
                    return
                  }
                  const res = await oikosApi.post('/', {
                    action: 'insert',
                    table: 'negociacao',
                    data: {
                      negociacao_nome: negociacaoData.negociacao_nome,
                      pj_id: negociacaoData.pj_id,
                      servico_id: negociacaoData.servico_id,
                    }
                  });
                  setNegociacao({
                    ...res.data[0],
                  })
                  setNegociacaoData({});
                  setIsSavingNegociacao(false);
                  setActiveId("tab-2");
                }}
              >
                Criar proposta com o modelo selecionado
              </Button> : <Spinner/>}
            </div>
          </TabPanel>
          <TabPanel>
            <div>
              <FormGroup>
                <span>Cliente</span>
                <div style={{zIndex: 4, position: 'relative'}}>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    options={pjs}
                    value={pjs.find(pj => pj.value === negociacaoData.pj_id) || null}
                    onChange={async (e) => {
                      setNegociacaoData({
                        ...negociacaoData,
                        pj_id: e ? e.value : null,
                      })
                      console.log(modelosPropostas)
                    }}
                  />
                </div>
              </FormGroup>

              <FormGroup>
                <span>Serviço Principal</span>
                <div style={{zIndex: 3, position: 'relative'}}>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    options={servicos.filter(s => negociacaoData.servicos_secundarios ? !negociacaoData.servicos_secundarios.some(ss => ss.value === s.value) : true) || []}
                    value={servicos.find(s => s.value === negociacaoData.servico_principal) || null}
                    onChange={async (e) => {
                      setNegociacaoData({
                        ...negociacaoData,
                        servico_principal: e ? e.value : null,
                      })

                      if (e) {
                        const modelosPropostaByServicoIdArray = await fetchModelosPropostaByServicoId(e.value, true);
                        setModelosPropostaByServicoId([...modelosPropostaByServicoId.filter(mp => !mp.principal), ...modelosPropostaByServicoIdArray]);
                      } else {
                        setModelosPropostaByServicoId([...modelosPropostaByServicoId.filter(mp => !mp.principal)]);
                      }
                    }}
                  />
                </div>
              </FormGroup>

              <FormGroup>
                <span>Serviços Secundários</span>
                <div style={{zIndex: 2, position: 'relative'}}>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    isMulti
                    options={servicos.filter(s => s.value !== negociacaoData.servico_principal) || []}
                    value={servicos.filter(s => negociacaoData.servicos_secundarios?.some(ss => ss.value === s.value)) || null}
                    onChange={async (selectedOp, actionMeta) => {
                      setNegociacaoData({
                        ...negociacaoData,
                        servicos_secundarios: selectedOp ? selectedOp : null,
                      })

                      const { action, option, removedValue } = actionMeta;

                      // When selecting → duplicate with new value
                      if (action === 'select-option') {
                        const modelosPropostaByServicoIdArray = await fetchModelosPropostaByServicoId(option.value, false);
                        console.log(modelosPropostaByServicoId)
                        const unique = [...new Map([...modelosPropostaByServicoIdArray, ...modelosPropostaByServicoId.filter(mp => mp.principal)].map(item => [item.prop_id, item])).values()];
                        setModelosPropostaByServicoId(unique);
                      }

                      // When removing / clearing → trust react-select
                      if (action === "remove-value" || action === "pop-value") {

                        let modelosPropostaByServicoIdArray = modelosPropostaByServicoId.filter(mp => mp.principal);
                        if (selectedOp && selectedOp.length > 0) {
                          console.log(selectedOp)
                          for (let index = 0; index < selectedOp.length; index++) {
                            const fetchedModelosPropostaByServicoId = await fetchModelosPropostaByServicoId(selectedOp[index].value, false);
                            modelosPropostaByServicoIdArray = [...modelosPropostaByServicoIdArray, ...fetchedModelosPropostaByServicoId];
                          }
                          const unique = [...new Map([...modelosPropostaByServicoIdArray].map(item => [item.prop_id, item])).values()];
                          setModelosPropostaByServicoId(unique);
                        } else {
                          setModelosPropostaByServicoId(modelosPropostaByServicoIdArray);
                        }
                      }

                      if (action === "clear") {
                        setModelosPropostaByServicoId(modelosPropostaByServicoId.filter(mp => mp.servico_id === negociacaoData.servico_principal) || []); // Keep only modelosPropostas of the main service
                      }
                    }}
                  />
                </div>
              </FormGroup>

              <FormGroup>
                <Label for="negociacao-nome">Nome da negociacao</Label>
                <Input
                  id="negociacao-nome"
                  type="text"
                  value={negociacaoData.negociacao_nome || ''}
                  onChange={(e) =>
                    setNegociacaoData({
                      ...negociacaoData,
                      negociacao_nome: e.target.value,
                    })
                  }
                />
              </FormGroup>

              <br />
              <div className='d-flex'>
                <div style={{marginRight: "20px"}}>
                  {
                    isLoadingModelosPropostas ? <Spinner/> :
                    !isLoadingModelosPropostas && modelosPropostas.filter(mp => mp.pj_id === negociacaoData.pj_id).length === 0 ? <span style={{marginTop: "10px"}}>Não há modelos de proposta cadastrados para o cliente selecionado</span> :
                    <>
                      <MaterialReactTable
                        columns={columnsModelo}
                        data={modelosPropostas.filter(mp => mp.pj_id === negociacaoData.pj_id)}
                        initialState={{
                          density: 'compact',
                          expanded: {}, //expand all groups by default
                          pagination: { pageIndex: 0, pageSize: 10 },
                          sorting: [], //sort by state by default,
                        }}
                        enableColumnResizing={true}
                        enableGrouping={false}
                        enableGlobalFilter={true}
                        enableFilters={true}
                        getRowId={(row) => String(row.prop_id)}
                        enablePagination={(modelosPropostas.filter(mp => mp.pj_id === negociacaoData.pj_id).length > 10)}
                        muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                        muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                        muiTablePaginationProps={{
                          sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                          labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                          rowsPerPageOptions: [10, 50, 100],
                        }}
                        positionPagination='bottom'
                        muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                        enableDensityToggle={false}
                        enableColumnFilters={false}
                        muiTableHeadCellProps={{
                          sx: {
                            '.MuiSvgIcon-root': {fontSize: "18px"},
                            fontSize: '12px',
                            fontWeight: 'normal', // Remove bold text in the header
                            padding: '8px', // Adjust padding to reduce white space
                          },
                        }}
                      />
                    </>
                  }
                </div>
              {
                isLoadingModelosPropostaByServicoId ? <Spinner/> :
                !isLoadingModelosPropostaByServicoId && modelosPropostaByServicoId.length === 0 ? <span style={{marginTop: "10px"}}>Não há modelos de proposta cadastrados para o serviço selecionado</span> :
                <>
                  <MaterialReactTable
                    columns={columnsModelo}
                    data={modelosPropostaByServicoId}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    getRowId={(row) => String(row.prop_id)}
                    enablePagination={(modelosPropostaByServicoId.length > 10)}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </>
              }
              </div><br />
              {!isSavingNegociacao ? <Button
                color="primary"
                onClick={async () => {
                  setIsSavingNegociacao(true)
                  if (!negociacaoData.negociacao_nome || negociacaoData.negociacao_nome.trim() === '') {
                    notifyError('Adicione um nome para a proposta')
                    setIsSavingNegociacao(false)
                    return
                  }
                  const res = await oikosApi.post('/', {
                    action: 'insert',
                    table: 'negociacao',
                    data: {
                      negociacao_nome: negociacaoData.negociacao_nome,
                      pj_id: negociacaoData.pj_id,
                      servico_id: negociacaoData.servico_id,
                    }
                  });
                  setNegociacao({
                    ...res.data[0],
                  })
                  setNegociacaoData({});
                  setIsSavingNegociacao(false);
                  setActiveId("tab-2");
                }}
              >
                Criar proposta sem modelo
              </Button> : <Spinner/>}
              {!isSavingNegociacao ? <Button
                color="primary"
                onClick={async () => {
                  setIsSavingNegociacao(true)
                  if (!negociacaoData.negociacao_nome || negociacaoData.negociacao_nome.trim() === '') {
                    notifyError('Adicione um nome para a proposta')
                    setIsSavingNegociacao(false)
                    return
                  }
                  const res = await oikosApi.post('/', {
                    action: 'insert',
                    table: 'negociacao',
                    data: {
                      negociacao_nome: negociacaoData.negociacao_nome,
                      pj_id: negociacaoData.pj_id,
                      servico_id: negociacaoData.servico_id,
                    }
                  });
                  setNegociacao({
                    ...res.data[0],
                  })
                  setNegociacaoData({});
                  setIsSavingNegociacao(false);
                  setActiveId("tab-2");
                }}
              >
                Criar proposta com o modelo selecionado
              </Button> : <Spinner/>}
            </div>
          </TabPanel>
        </Tabs>
      ),
    },
    {
      id: "tab-2",
      label: "Identificação",
      subtitle: "Defina o nome da proposta",
      content: (
        <div>
          { !isLoadingSelected && Object.keys(negociacao).length > 0 ?
            <>
              <FormGroup>
                <Label for="proposta-nome">Nome da proposta</Label>
                <Input
                  id="proposta-nome"
                  type="text"
                  value={propostaData.prop_nome || ''}
                  onChange={(e) =>
                    setPropostaData({
                      ...propostaData,
                      prop_nome: e.target.value,
                    })
                  }
                />
              </FormGroup>
              {!isSavingProposta ? <Button
                color="primary"
                onClick={async () => {
                  setIsSavingProposta(true)
                  if (!propostaData.prop_nome || propostaData.prop_nome.trim() === '') {
                    notifyError('Adicione um nome para a proposta')
                    setIsSavingProposta(false)
                    return
                  }
                  const res = await oikosApi.post('/', {
                    action: 'insert',
                    table: 'prop',
                    data: {
                      prop_nome: propostaData.prop_nome,
                      propStatus_id: 2,
                      negociacao_id: negociacao.negociacao_id
                    }
                  });
                  /* const res = await oikosApi.get(`/?${qs.stringify({
                    action: 'get',
                    table: 'prop',
                    data: {
                      prop_id: 58,
                    },
                  })}`) */
                  const propPropItens = await fetchPropPropItemByPropId(res.data[0].prop_id);
                  const modelosServ = await getModelosServicosByPropId(res.data[0].prop_id);
                  setOriginalPropostaData({
                    ...res.data[0],
                    propItens: propPropItens,
                    modeloServico_ids: [...modelosServ],
                  })
                  setPropostaData({
                    ...propostaData,
                    propItens: [],
                    modeloServico_ids: []
                  })
                  setIsSavingProposta(false);
                  setActiveId("tab-3");
                }}
              >
                Começar Orçamentação
              </Button> : <Spinner/>}
            </> : <span>Você ainda não iniciou uma negociação</span>
          }
        </div>
      ),
    },
    {
      id: "tab-3",
      label: "Propostas",
      subtitle: "Carregar um modelo de proposta",
      content: (
        <div>
          {
            !isLoadingSelected && Object.keys(propostaData).length > 0 ?
            <>
              <MaterialReactTable
                columns={columnsModelo}
                data={modelosPropostas}
                initialState={{
                  density: 'compact',
                  expanded: {}, //expand all groups by default
                  pagination: { pageIndex: 0, pageSize: 10 },
                  sorting: [], //sort by state by default,
                }}
                enableColumnResizing={true}
                enableGrouping={false}
                enableGlobalFilter={true}
                enableFilters={true}
                getRowId={(row) => String(row.prop_id)}
                enablePagination={(modelosPropostas.length > 10)}
                muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                muiTablePaginationProps={{
                  sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                  labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                  rowsPerPageOptions: [10, 50, 100],
                }}
                positionPagination='bottom'
                muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                enableDensityToggle={false}
                enableColumnFilters={false}
                muiTableHeadCellProps={{
                  sx: {
                    '.MuiSvgIcon-root': {fontSize: "18px"},
                    fontSize: '12px',
                    fontWeight: 'normal', // Remove bold text in the header
                    padding: '8px', // Adjust padding to reduce white space
                  },
                }}
              />
            </> : <span>Você ainda não iniciou uma proposta</span>
          }
        </div>
      ),
    },
    {
      id: "tab-4",
      label: "Recursos",
      subtitle: "Selecione recursos para compor a proposta",
      content: (
        <div>
          {!isLoadingSelected && Object.keys(propostaData).length > 0 ?
            <>
              <h4>Banco de recursos:</h4>
                <Button onClick={() => {handleShowItemGr('showRecursosHumanos')}}>Recursos Humanos</Button>
                <Button onClick={() => {handleShowItemGr('showLogistica')}}>Logística</Button>
                <Button onClick={() => {handleShowItemGr('showDespesasGerais')}}>Despesas Gerais</Button>
                <Button onClick={() => {handleShowItemGr('showEquipamentos')}}>Equipamentos</Button>
                <Button onClick={() => {handleShowItemGr('showSubcontratacoes')}}>Subcontratações</Button>
                <Button onClick={() => {handleShowItemGr('showReceitas')}}>Receitas</Button>
              {
                itemGrSelected.showRecursosHumanos && !isLoadingSelected &&
                <>
                  <div className="d-flex justify-content-between">
                    <h4>Recursos Humanos:</h4>
                    <Button
                      size="sm"
                      color="link"
                      className="ml-2 px-0"
                      onClick={(e)=>{
                        setPropItemData({propItemGr_id: 1, propItemGr_label: 'Recurso Humano'});
                        setModalPropItemOpen(true);
                      }}
                    >
                      Adicionar recursos humanos
                    </Button>
                  </div>
                  <MaterialReactTable
                    columns={columnsSelectedPropPropItens}
                    data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 1) : []}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 1).length > 10)}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Recursos humanos por página</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </>
              }
              {
                itemGrSelected.showLogistica && !isLoadingSelected &&
                <>
                  <div className="d-flex justify-content-between">
                    <h4>Logística:</h4>
                    <Button
                      size="sm"
                      color="link"
                      className="ml-2 px-0"
                      onClick={(e)=>{
                        setPropItemData({propItemGr_id: 4, propItemGr_label: 'Logística'});
                        setModalPropItemOpen(true);
                      }}
                    >
                      Adicionar logística
                    </Button>
                  </div>
                  <MaterialReactTable
                    columns={columnsSelectedPropPropItens}
                    data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 4) : []}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 4).length > 10)}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Logística por página</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </>
              }
              {
                itemGrSelected.showDespesasGerais && !isLoadingSelected &&
                <>
                  <div className="d-flex justify-content-between">
                    <h4>Despesas Gerais:</h4>
                    <Button
                      size="sm"
                      color="link"
                      className="ml-2 px-0"
                      onClick={(e)=>{
                        setPropItemData({propItemGr_id: 3, propItemGr_label: 'Despesas gerais'});
                        setModalPropItemOpen(true);
                      }}
                    >
                      Adicionar despesas gerais
                    </Button>
                  </div>
                  <MaterialReactTable
                    columns={columnsSelectedPropPropItens}
                    data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 3) : []}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 3).length > 10)}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Despesas Gerais por página</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </>
              }
              {
                itemGrSelected.showEquipamentos && !isLoadingSelected &&
                <>
                  <div className="d-flex justify-content-between">
                    <h4>Equipamentos:</h4>
                    <Button
                      size="sm"
                      color="link"
                      className="ml-2 px-0"
                      onClick={(e)=>{
                        setPropItemData({propItemGr_id: 2, propItemGr_label: 'Equipamentos'});
                        setModalPropItemOpen(true);
                      }}
                    >
                      Adicionar equipamentos
                    </Button>
                  </div>
                  <MaterialReactTable
                    columns={columnsSelectedPropPropItens}
                    data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 2) : []}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 2).length > 10)}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Equipamentos por página</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </>
              }
              {
                itemGrSelected.showSubcontratacoes && !isLoadingSelected &&
                <>
                  <div className="d-flex justify-content-between">
                    <h4>Subcontratações:</h4>
                    <Button
                      size="sm"
                      color="link"
                      className="ml-2 px-0"
                      onClick={(e)=>{
                        setPropItemData({propItemGr_id: 5, propItemGr_label: 'Subcontratações'});
                        setModalPropItemOpen(true);
                      }}
                    >
                      Adicionar subcontratações
                    </Button>
                  </div>
                  <MaterialReactTable
                    columns={columnsSelectedPropPropItens}
                    data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 5) : []}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 5).length > 10)}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Subcontratações por página</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </>
              }
              {
                itemGrSelected.showReceitas && !isLoadingSelected &&
                <>
                  <div className="d-flex justify-content-between">
                    <h4>Receitas:</h4>
                    <Button
                      size="sm"
                      color="link"
                      className="ml-2 px-0"
                      onClick={(e)=>{
                        setPropItemData({propItemGr_id: 6, propItemGr_label: 'Receitas'});
                        setModalPropItemOpen(true);
                      }}
                    >
                      Adicionar receitas
                    </Button>
                  </div>
                  <MaterialReactTable
                    columns={columnsSelectedPropPropItens}
                    data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 6) : []}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 6).length > 10)}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Receitas por página</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </>
              }
            </> :
            <span>Você ainda não iniciou uma proposta</span>
          }
        </div>
      ),
    },
    {
      id: "tab-5",
      label: "Serviços",
      subtitle: "Selecione recursos para compor a proposta",
      content: (
        <div>
          {
            !isLoadingSelected && Object.keys(propostaData).length > 0 ?
            <>
              {
                !isLoadingSelected &&
                <div className='d-flex justify-content-between align-items-center'>
                  <div>
                    <h4>Serviços</h4>
                    <Button onClick={()=>{
                      if (selectedMacroatividades.length > 0 || selectedProdsProp.length > 0 || selectedEpsProp.length > 0) {
                        setIsModalWarningOpen(true);
                      } else {
                        setServicoCompostoMode(true);
                      }
                    }}
                    >
                      Serviço Composto
                    </Button>
                    <Button onClick={()=>{
                      if (selectedMacroatividades.length > 0 || selectedProdsProp.length > 0 || selectedEpsProp.length > 0) {
                        setIsModalWarningOpen(true);
                      } else {
                        setServicoCompostoMode(false);
                      }
                      }}
                    >
                      Serviço Principal
                    </Button>
                  </div>
                  <Button
                    size="sm"
                    color="link"
                    className="ml-2 px-0"
                    onClick={(e)=>{
                      e.preventDefault();
                      setModalAddServicoOpen(true)
                    }}
                  >
                    Criar modelo de serviço
                  </Button>
                </div>
              }
              {
                (servicoCompostoMode && !isLoadingSelected) ?
                <>
                  <br />
                  <Label>Composição de serviços</Label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    options={servicosCompostos}
                    value={(servicosCompostos.length > 0 && propostaData.modeloServico_ids && propostaData.modeloServico_ids.length > 0) ? servicosCompostos.find(option => option.value === propostaData.modeloServico_ids.find(ms => ms.modeloServico_primario && ms.servicoComposto)?.composicaoModeloServico_id) : null}
                    onChange={async (e) => {
                      setIsLoadingSelected(true);
                      if (e) {
                        await fetchServicosCompostos(e.value);
                        await getMacroatividadeByComposicaoServicoId(e.value);
                        await getProdPropByComposicaoServicoId(e.value);
                        await getEPsPropByComposicaoServicoId(e.value);
                      } else {
                        setComposicaoDeServicos([]);
                        setPropostaData({...propostaData, modeloServico_ids: [...propostaData.modeloServico_ids.filter(ms => !ms.modeloServico_primario && ms.servicoComposto)]})
                      }
                      setIsLoadingSelected(false);
                    }}
                  />
                  {
                    propostaData && propostaData.modeloServico_ids &&
                    <>
                      <Label>Serviço Secundário</Label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isClearable={true}
                        isSearchable={true}
                        isMulti
                        options={composicaoDeServicos}
                        value={[...propostaData.modeloServico_ids.filter(ms => ms.servicoComposto && !ms.modeloServico_primario).map(ms => modelosServicos.find(option => option.value === ms.modeloServico_id))]}
                        onChange={async (e) => {
                          setIsLoadingSelected(true);
                          if (e) {
                            const modeloServicoPrimario = propostaData.modeloServico_ids ? propostaData.modeloServico_ids.filter(ms => ms.modeloServico_primario) : [];
                            const formattedModeloServicosSecundarios = [];
                            const selectedMacroatividadesCopy = [];
                            const selectedProdPropCopy = [];
                            const selectedEpsPropCopy = [];
                            for (let i = 0; i < e.length; i++) {
                              const ms = e[i];
                              const selectedMacroatividadesFromModeloServico = selectedMacroatividades.filter(sma => sma.modeloServico_id === ms.value)
                              const selectedEPsFromModeloServico = selectedEpsProp.filter(sep => sep.modeloServico_id === ms.value)
                              const selectedProdsPropFromModeloServico = selectedProdsProp.filter(sep => sep.modeloServico_id === ms.value)

                              formattedModeloServicosSecundarios.push({modeloServico_id: ms.value, modeloServico_secundario: true, servicoComposto: true});

                              if (selectedMacroatividadesFromModeloServico.length === 0) {
                                const macroatividadesByModeloServico = await getMacroatividadesByModeloServicoId(ms.value);

                                if (selectedMacroatividades.length > 0) {
                                  const selectedMacroatividadesCopy = [];

                                  for (let i = 0; i < macroatividadesByModeloServico.length; i++) {
                                    const rsm = macroatividadesByModeloServico[i];
                                    if (selectedMacroatividades.find(sm => sm.macroatividade_id === rsm.macroatividade_id)) {
                                      continue;
                                    } else {
                                      selectedMacroatividadesCopy.push(rsm);
                                    }
                                  }
                                  setSelectedMacroatividades(prevState => [...prevState, ...selectedMacroatividadesCopy]);
                                } else {
                                  setSelectedMacroatividades(prevState => [...prevState, ...macroatividadesByModeloServico]);
                                }
                              } else {
                                for (let index = 0; index < selectedMacroatividadesFromModeloServico.length; index++) {
                                  const element = selectedMacroatividadesFromModeloServico[index];

                                  selectedMacroatividadesCopy.push(element);
                                }
                                setSelectedMacroatividades([...selectedMacroatividadesCopy]);
                              }

                              if (selectedEPsFromModeloServico.length === 0) {
                                const epsPropByModeloServicoId = await getEPsPropByModeloServicoId(ms.value);
                                if (selectedEpsProp.length > 0) {
                                  const selectedEpsPropCopy = [];
                                  for (let i = 0; i < epsPropByModeloServicoId.length; i++) {
                                    const rsep = epsPropByModeloServicoId[i];
                                    if (selectedEpsProp.find(sep => sep.eventoPagamentoProp_id === rsep.eventoPagamentoProp_id)) {
                                      continue;
                                    } else {
                                      selectedEpsPropCopy.push(rsep);
                                    }
                                  }
                                  setSelectedEpsProp(prevState => [...prevState, ...selectedEpsPropCopy]);
                                } else {
                                  setSelectedEpsProp(prevState => [...prevState, ...epsPropByModeloServicoId]);
                                }
                              } else {
                                for (let index = 0; index < selectedEPsFromModeloServico.length; index++) {
                                  const element = selectedEPsFromModeloServico[index];

                                  selectedEpsPropCopy.push(element);
                                }
                                setSelectedEpsProp([...selectedEpsPropCopy]);
                              }

                              if (selectedProdsPropFromModeloServico.length === 0) {
                                const prodsPropByModeloServicoId = await getProdsPropByModeloServicoId(ms.value);
                                if (selectedProdsProp.length > 0) {
                                  const selectedProdsPropCopy = [];
                                  for (let i = 0; i < prodsPropByModeloServicoId.length; i++) {
                                    const rspp = prodsPropByModeloServicoId[i];
                                    if (selectedProdsProp.find(sep => sep.prodProp_id === rspp.prodProp_id)) {
                                      continue;
                                    } else {
                                      selectedProdsPropCopy.push(rspp);
                                    }
                                  }
                                  setSelectedProdsProp(prevState => [...prevState, ...selectedProdsPropCopy]);
                                } else {
                                  setSelectedProdsProp(prevState => [...prevState, ...prodsPropByModeloServicoId]);
                                }
                              } else {
                                for (let index = 0; index < selectedProdsPropFromModeloServico.length; index++) {
                                  const element = selectedProdsPropFromModeloServico[index];

                                  selectedProdPropCopy.push(element);
                                }
                                setSelectedProdsProp([...selectedProdPropCopy]);
                              }
                            }
                            setPropostaData({
                              ...propostaData,
                              modeloServico_ids: [...modeloServicoPrimario, ...formattedModeloServicosSecundarios],
                            })
                          } else {
                            const modeloServicoPrimario = propostaData.modeloServico_ids ? propostaData.modeloServico_ids.filter(ms => ms.modeloServico_primario) : [];
                            setSelectedMacroatividades([]);
                            setSelectedProdsProp([]);
                            setSelectedEpsProp([]);
                            setPropostaData({
                              ...propostaData,
                              modeloServico_ids: [...modeloServicoPrimario],
                            })
                          }
                          setIsLoadingSelected(false);
                        }}
                      />
                    </>
                  }
                </> : (!servicoCompostoMode && !isLoadingSelected) &&
                <>
                  <br />
                  <Label>Serviço Principal</Label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    options={(modelosServicos && propostaData.modeloServico_ids) ? modelosServicos.filter(ms => ms.value !== modelosServicos.find(option => option.value === propostaData.modeloServico_ids.find(ms => !ms.modeloServico_primario)?.modeloServico_id)?.value) : []}
                    value={
                      (modelosServicos.length > 0 && propostaData.modeloServico_ids && propostaData.modeloServico_ids.length > 0) ?
                      modelosServicos.find(option => option.value === propostaData.modeloServico_ids.find(ms => ms.modeloServico_primario && !ms.servicoComposto)?.modeloServico_id) :
                      null
                    }
                    onChange={async (e) => {
                      setIsLoadingSelected(true);
                      const modeloServico_idsCopy = propostaData.modeloServico_ids ? propostaData.modeloServico_ids.filter(ms => !ms.modeloServico_primario) : [];
                      let relacaoPropServico_id = null;

                      if (e) {
                        const res = await oikosApi.get((
                          `/?${qs.stringify({
                            action: 'get',
                            table: 'relacaoPropServico',
                            data: {
                              prop_id: originalPropostaData.prop_id,
                              modeloServico_id: e.value,
                            }
                          })}`
                        ))

                        const resArrayDeServicosPrimariosDaProposta = await oikosApi.get((
                          `/?${qs.stringify({
                            action: 'get',
                            table: 'relacaoPropServico',
                            data: {
                              prop_id: originalPropostaData.prop_id,
                              relacaoPropServico_servicoPrincipal: 1,
                            }
                          })}`
                        ));

                        const arrayDeServicosPrimariosDaProposta = resArrayDeServicosPrimariosDaProposta.data

                        for (let index = 0; index < arrayDeServicosPrimariosDaProposta.length; index++) {
                          const element = arrayDeServicosPrimariosDaProposta[index];

                          const resPost = await oikosApi.post(
                            '/',
                            {
                              action: 'update',
                              table: 'relacaoPropServico',
                              data: {
                                relacaoPropServico_id: element.relacaoPropServico_id,
                                relacaoPropServico_ativo: 0
                              }
                            }
                          )
                        }

                        if(res.data.length === 0) {
                          const resPost = await oikosApi.post(
                            '/',
                            {
                              action: 'insert',
                              table: 'relacaoPropServico',
                              data: {
                                prop_id: originalPropostaData.prop_id,
                                modeloServico_id: e.value,
                                servico_id: e.servico_id,
                                relacaoPropServico_servicoPrincipal: 1
                              }
                            }
                          )

                          relacaoPropServico_id = resPost.data[0].relacaoPropServico_id
                        } else {
                          if (res.data.length > 1) {
                            setIsLoadingSelected(false);
                            return notifyError('Há mais de um serviço principal para esta proposta. Corrija no banco de dados');
                          }
                          if (Number(res.data[0].relacaoPropServico_ativo) === 0) {
                            const resPost = await oikosApi.post(
                              '/',
                              {
                                action: 'update',
                                table: 'relacaoPropServico',
                                data: {
                                  relacaoPropServico_id: res.data[0].relacaoPropServico_id,
                                  prop_id: originalPropostaData.prop_id,
                                  modeloServico_id: e.value,
                                  servico_id: e.servico_id,
                                  relacaoPropServico_servicoPrincipal: 1,
                                  relacaoPropServico_ativo: 1
                                }
                              }
                            )
                            relacaoPropServico_id = res.data[0].relacaoPropServico_id;
                          } else if (Number(res.data[0].relacaoPropServico_servicoPrincipal) === 0) {
                            const resPost = await oikosApi.post(
                              '/',
                              {
                                action: 'update',
                                table: 'relacaoPropServico',
                                data: {
                                  relacaoPropServico_id: res.data[0].relacaoPropServico_id,
                                  prop_id: originalPropostaData.prop_id,
                                  modeloServico_id: e.value,
                                  servico_id: e.servico_id,
                                  relacaoPropServico_servicoPrincipal: 1,
                                  relacaoPropServico_ativo: 1
                                }
                              }
                            )
                            relacaoPropServico_id = res.data[0].relacaoPropServico_id;
                          } else {
                            relacaoPropServico_id = res.data[0].relacaoPropServico_id;
                          }
                        }

                        const selectedMacroatividadesCopy = [];
                        const selectedProdPropCopy = [];
                        const selectedEpsPropCopy = [];
                        const ms = e;
                        const selectedMacroatividadesFromModeloServico = selectedMacroatividades.filter(sma => sma.modeloServico_id === ms.value)
                        const selectedEPsFromModeloServico = selectedEpsProp.filter(sep => sep.modeloServico_id === ms.value)
                        const selectedProdsPropFromModeloServico = selectedProdsProp.filter(sep => sep.modeloServico_id === ms.value);

                        if (selectedMacroatividadesFromModeloServico.length === 0) {
                          const macroatividadesByModeloServico = await getMacroatividadesByModeloServicoId(ms.value);

                          if (selectedMacroatividades.length > 0) {
                            const selectedMacroatividadesCopy = [];

                            for (let i = 0; i < macroatividadesByModeloServico.length; i++) {
                              const rsm = macroatividadesByModeloServico[i];
                              if (selectedMacroatividades.find(sm => sm.macroatividade_id === rsm.macroatividade_id)) {
                                continue;
                              } else {
                                selectedMacroatividadesCopy.push(rsm);
                              }
                            }
                            setSelectedMacroatividades(prevState => [...prevState, ...selectedMacroatividadesCopy]);
                          } else {
                            setSelectedMacroatividades(prevState => [...prevState, ...macroatividadesByModeloServico]);
                          }
                        } else {
                          for (let index = 0; index < selectedMacroatividadesFromModeloServico.length; index++) {
                            const element = selectedMacroatividadesFromModeloServico[index];

                            selectedMacroatividadesCopy.push(element);
                          }
                          setSelectedMacroatividades([...selectedMacroatividadesCopy]);
                        }

                        if (selectedEPsFromModeloServico.length === 0) {
                          const epsPropByModeloServicoId = await getEPsPropByModeloServicoId(ms.value);
                          if (selectedEpsProp.length > 0) {
                            const selectedEpsPropCopy = [];
                            for (let i = 0; i < epsPropByModeloServicoId.length; i++) {
                              const rsep = epsPropByModeloServicoId[i];
                              if (selectedEpsProp.find(sep => sep.eventoPagamentoProp_id === rsep.eventoPagamentoProp_id)) {
                                continue;
                              } else {
                                selectedEpsPropCopy.push(rsep);
                              }
                            }
                            setSelectedEpsProp(prevState => [...prevState, ...selectedEpsPropCopy]);
                          } else {
                            setSelectedEpsProp(prevState => [...prevState, ...epsPropByModeloServicoId]);
                          }
                        } else {
                          for (let index = 0; index < selectedEPsFromModeloServico.length; index++) {
                            const element = selectedEPsFromModeloServico[index];
                            selectedEpsPropCopy.push(element);
                          }
                          setSelectedEpsProp([...selectedEpsPropCopy]);
                        }

                        if (selectedProdsPropFromModeloServico.length === 0) {
                          const prodsPropByModeloServicoId = await getProdsPropByModeloServicoId(ms.value);
                          if (selectedProdsProp.length > 0) {
                            const selectedProdsPropCopy = [];
                            for (let i = 0; i < prodsPropByModeloServicoId.length; i++) {
                              const rspp = prodsPropByModeloServicoId[i];
                              if (selectedProdsProp.find(sep => sep.prodProp_id === rspp.prodProp_id)) {
                                continue;
                              } else {
                                selectedProdsPropCopy.push(rspp);
                              }
                            }
                            setSelectedProdsProp(prevState => [...prevState, ...selectedProdsPropCopy]);
                          } else {
                            setSelectedProdsProp(prevState => [...prevState, ...prodsPropByModeloServicoId]);
                          }
                        } else {
                          for (let index = 0; index < selectedProdsPropFromModeloServico.length; index++) {
                            const element = selectedProdsPropFromModeloServico[index];

                            selectedProdPropCopy.push(element);
                          }
                          setSelectedProdsProp([...selectedProdPropCopy]);
                        }

                        setPropostaData({
                          ...propostaData,
                          modeloServico_ids: e ? [...modeloServico_idsCopy, {modeloServico_id: e.value, modeloServico_primario: true, relacaoPropServico_id: relacaoPropServico_id}] : [...modeloServico_idsCopy],
                        })
                      } else {
                        const modeloServico_idsCopy = propostaData.modeloServico_ids ? propostaData.modeloServico_ids.filter(ms => !ms.modeloServico_primario) : [];

                        const selectedModeloPrincipal = propostaData.modeloServico_ids.find(ms => ms.modeloServico_primario);
                        console.log('selectedModeloPrincipal', selectedModeloPrincipal);

                        if (selectedModeloPrincipal) {
                          const res = await oikosApi.get((
                            `/?${qs.stringify({
                              action: 'get',
                              table: 'relacaoPropServico',
                              data: {
                                prop_id: originalPropostaData.prop_id,
                                modeloServico_id: selectedModeloPrincipal.modeloServico_id,
                                relacaoPropServico_ativo: 1,
                              }
                            })}`
                          ))

                          console.log('res', res);

                          if (res.data.length > 0) {
                            const resPost = await oikosApi.post(
                              '/',
                              {
                                action: 'update',
                                table: 'relacaoPropServico',
                                data: {
                                  relacaoPropServico_id: res.data[0].relacaoPropServico_id,
                                  prop_id: originalPropostaData.prop_id,
                                  modeloServico_id: selectedModeloPrincipal.value,
                                  servico_id: selectedModeloPrincipal.servico_id,
                                  relacaoPropServico_ativo: 0,
                                }
                              }
                            )
                          }
                        }

                        if (modeloServico_idsCopy.length > 0) {
                          const selectedMacroatividadesCopy = [];
                          const selectedProdsPropCopy = [];
                          const selectedEpsPropCopy = [];
                          for (let index = 0; index < modeloServico_idsCopy.length; index++) {
                            const element = modeloServico_idsCopy[index];
                            selectedMacroatividadesCopy.push(selectedMacroatividades.filter(m => m.modeloServico_id === element.modeloServico_id));
                            selectedProdsPropCopy.push(selectedProdsProp.filter(m => m.modeloServico_id === element.modeloServico_id));
                            selectedEpsPropCopy.push(selectedEpsProp.filter(m => m.modeloServico_id === element.modeloServico_id));
                          }
                          setSelectedMacroatividades(...selectedMacroatividadesCopy);
                          setSelectedProdsProp(...selectedProdsPropCopy);
                          setSelectedEpsProp(...selectedEpsPropCopy);
                        } else {
                          setSelectedMacroatividades([]);
                          setSelectedProdsProp([]);
                          setSelectedEpsProp([]);
                        }
                        setPropostaData({
                          ...propostaData,
                          modeloServico_ids: [...modeloServico_idsCopy],
                        })
                      }
                      setIsLoadingSelected(false);
                    }}
                  />

                  {
                    propostaData && propostaData.modeloServico_ids &&
                    <>
                      <Label>Serviço Secundário</Label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isClearable={true}
                        isSearchable={true}
                        isMulti
                        value={[...propostaData.modeloServico_ids.filter(ms => !ms.servicoComposto && !ms.modeloServico_primario).map(ms => modelosServicos.find(option => option.value === ms.modeloServico_id))]}
                        options={modelosServicos.filter(ms => ms.value !== modelosServicos.find(option => option.value === propostaData.modeloServico_ids.find(ms => ms.modeloServico_primario)?.modeloServico_id)?.value)}
                        onChange={async (e, actionMeta) => {
                          setIsLoadingSelected(true);

                          const { action, option, removedValue } = actionMeta;
                          let lastAdded = null;
                          let lastRemoved = null;
                          let relacaoPropServico_id = null;

                          const updateOptionOnPropostaData = async () => {
                            if (action === "select-option") {

                              const res = await oikosApi.get((
                                `/?${qs.stringify({
                                  action: 'get',
                                  table: 'relacaoPropServico',
                                  data: {
                                    prop_id: originalPropostaData.prop_id,
                                    modeloServico_id: option.value,
                                  }
                                })}`
                              ));

                              if (res.data.length === 0) {
                                const resPost = await oikosApi.post(
                                  '/',
                                  {
                                    action: 'insert',
                                    table: 'relacaoPropServico',
                                    data: {
                                      prop_id: originalPropostaData.prop_id,
                                      modeloServico_id: option.value,
                                      servico_id: option.servico_id,
                                    }
                                  }
                                )
                                return resPost.data[0].relacaoPropServico_id;
                              } else {
                                const element = res.data[0];
                                if (Number(element.relacaoPropServico_ativo) === 0 || Number(element.relacaoPropServico_servicoPrincipal) === 1) {
                                  const resPost = await oikosApi.post(
                                    '/',
                                    {
                                      action: 'update',
                                      table: 'relacaoPropServico',
                                      data: {
                                        relacaoPropServico_id: element.relacaoPropServico_id,
                                        prop_id: originalPropostaData.prop_id,
                                        modeloServico_id: option.value,
                                        servico_id: option.servico_id,
                                        relacaoPropServico_servicoPrincipal: 0,
                                        relacaoPropServico_ativo: 1
                                      }
                                    }
                                  )
                                  return element.relacaoPropServico_id
                                } else {
                                  return element.relacaoPropServico_id;
                                }
                              }


                            } else if (action === "remove-value" || action === "pop-value") {

                              const res = await oikosApi.get((
                                `/?${qs.stringify({
                                  action: 'get',
                                  table: 'relacaoPropServico',
                                  data: {
                                    prop_id: originalPropostaData.prop_id,
                                    modeloServico_id: removedValue.value,
                                  }
                                })}`
                              ));

                              const element = res.data[0];

                              if (Number(element.relacaoPropServico_ativo) === 1 || Number(element.relacaoPropServico_servicoPrincipal) === 1) {
                                const resPost = await oikosApi.post(
                                  '/',
                                  {
                                    action: 'update',
                                    table: 'relacaoPropServico',
                                    data: {
                                      relacaoPropServico_id: element.relacaoPropServico_id,
                                      prop_id: originalPropostaData.prop_id,
                                      modeloServico_id: removedValue.value,
                                      servico_id: removedValue.servico_id,
                                      relacaoPropServico_servicoPrincipal: 0,
                                      relacaoPropServico_ativo: 0
                                    }
                                  }
                                )
                                return element.relacaoPropServico_id
                              } else {
                                return element.relacaoPropServico_id;
                              }
                            } else if (action === "clear") {
                              const modelosServicosSecundarios = propostaData.modeloServico_ids ? propostaData.modeloServico_ids.filter(ms => !ms.modeloServico_primario) : [];
                              const returnRelacaoPropServico = [];

                              for (let index = 0; index < modelosServicosSecundarios.length; index++) {
                                const element = modelosServicosSecundarios[index];
                                const resPost = await oikosApi.post(
                                  '/',
                                  {
                                    action: 'update',
                                    table: 'relacaoPropServico',
                                    data: {
                                      relacaoPropServico_id: element.relacaoPropServico_id,
                                      prop_id: originalPropostaData.prop_id,
                                      modeloServico_id: element.value,
                                      servico_id: element.servico_id,
                                      relacaoPropServico_servicoPrincipal: 0,
                                      relacaoPropServico_ativo: 0
                                    }
                                  }
                                )
                                returnRelacaoPropServico.push({modeloServico_id: element.value, modeloServico_secundario: true, relacaoPropServico_id: element.relacaoPropServico_id})
                              }
                              return returnRelacaoPropServico;
                            }
                          }

                          const applySelectedOptions = async (selectedOptions) => {
                            if (!selectedOptions || selectedOptions.length === 0) {
                              return;
                            }

                            const modeloServicoPrimario = propostaData.modeloServico_ids ? propostaData.modeloServico_ids.filter(ms => ms.modeloServico_primario) : [];
                            const formattedModeloServicosSecundarios = propostaData.modeloServico_ids ? propostaData.modeloServico_ids.filter(ms => !ms.modeloServico_primario) : [];
                            const selectedMacroatividadesCopy = [];
                            const selectedProdPropCopy = [];
                            const selectedEpsPropCopy = [];
                            let relacaoPropServico_id = null;
                            let arrayRelacaoPropServico = [];

                            if (action === "select-option") {
                              relacaoPropServico_id = await updateOptionOnPropostaData();
                              const selectedMacroatividadesFromModeloServico = selectedMacroatividades.filter(sma => sma.modeloServico_id === option.value)
                              const selectedEPsFromModeloServico = selectedEpsProp.filter(sep => sep.modeloServico_id === option.value)
                              const selectedProdsPropFromModeloServico = selectedProdsProp.filter(sep => sep.modeloServico_id === option.value)

                              formattedModeloServicosSecundarios.push({modeloServico_id: option.value, modeloServico_secundario: true, relacaoPropServico_id: relacaoPropServico_id});


                              if (selectedMacroatividadesFromModeloServico.length === 0) {
                                const macroatividadesByModeloServico = await getMacroatividadesByModeloServicoId(option.value);

                                if (macroatividadesByModeloServico.length > 0) {
                                  const selectedMacroatividadesCopy = [];

                                  for (let i = 0; i < macroatividadesByModeloServico.length; i++) {
                                    const rsm = macroatividadesByModeloServico[i];
                                    if (selectedMacroatividades.find(sm => sm.macroatividade_id === rsm.macroatividade_id)) {
                                      continue;
                                    } else {
                                      selectedMacroatividadesCopy.push(rsm);
                                    }
                                  }
                                  console.log('1', [...selectedMacroatividades, ...selectedMacroatividadesCopy]);
                                  setSelectedMacroatividades(prevState => [...prevState, ...selectedMacroatividadesCopy]);
                                } else {
                                  console.log('2', [...selectedMacroatividades, ...macroatividadesByModeloServico]);
                                  setSelectedMacroatividades(prevState => [...prevState, ...macroatividadesByModeloServico]);
                                }
                              } else {
                                for (let index = 0; index < selectedMacroatividadesFromModeloServico.length; index++) {
                                  const element = selectedMacroatividadesFromModeloServico[index];

                                  selectedMacroatividadesCopy.push(element);
                                }
                                console.log('3', selectedMacroatividadesCopy);
                                setSelectedMacroatividades(selectedMacroatividadesCopy);
                              }

                              if (selectedEPsFromModeloServico.length === 0) {
                                const epsPropByModeloServicoId = await getEPsPropByModeloServicoId(option.value);
                                if (epsPropByModeloServicoId.length > 0) {
                                  const selectedEpsPropCopy = [];
                                  for (let i = 0; i < epsPropByModeloServicoId.length; i++) {
                                    const rsep = epsPropByModeloServicoId[i];
                                    if (selectedEpsProp.find(sep => sep.eventoPagamentoProp_id === rsep.eventoPagamentoProp_id)) {
                                      continue;
                                    } else {
                                      selectedEpsPropCopy.push(rsep);
                                    }
                                  }
                                  console.log('1', [...selectedEpsProp, ...selectedEpsPropCopy]);
                                  setSelectedEpsProp(prevState => [...prevState, ...selectedEpsPropCopy]);
                                } else {
                                  console.log('2', [...selectedEpsProp, ...epsPropByModeloServicoId]);
                                  setSelectedEpsProp(prevState => [...prevState, ...epsPropByModeloServicoId]);
                                }
                              } else {
                                for (let index = 0; index < selectedEPsFromModeloServico.length; index++) {
                                  const element = selectedEPsFromModeloServico[index];

                                  selectedEpsPropCopy.push(element);
                                }
                                console.log('3', selectedEpsPropCopy);
                                setSelectedEpsProp([...selectedEpsPropCopy]);
                              }

                              if (selectedProdsPropFromModeloServico.length === 0) {
                                const prodsPropByModeloServicoId = await getProdsPropByModeloServicoId(option.value);
                                if (prodsPropByModeloServicoId.length > 0) {
                                  const selectedProdsPropCopy = [];
                                  for (let i = 0; i < prodsPropByModeloServicoId.length; i++) {
                                    const rspp = prodsPropByModeloServicoId[i];
                                    if (selectedProdsProp.find(sep => sep.prodProp_id === rspp.prodProp_id)) {
                                      continue;
                                    } else {
                                      selectedProdsPropCopy.push(rspp);
                                    }
                                  }
                                  console.log('1', [...selectedProdsProp, ...selectedProdsPropCopy]);
                                  setSelectedProdsProp(prevState => [...prevState, ...selectedProdsPropCopy]);
                                } else {
                                  console.log('2', [...selectedProdsProp, ...prodsPropByModeloServicoId]);
                                  setSelectedProdsProp(prevState => [...prevState, ...prodsPropByModeloServicoId]);
                                }
                              } else {
                                for (let index = 0; index < selectedProdsPropFromModeloServico.length; index++) {
                                  const element = selectedProdsPropFromModeloServico[index];

                                  selectedProdPropCopy.push(element);
                                }
                                console.log('3', selectedProdPropCopy);
                                setSelectedProdsProp([...selectedProdPropCopy]);
                              }

                              setPropostaData({
                                ...propostaData,
                                modeloServico_ids: [...modeloServicoPrimario, ...formattedModeloServicosSecundarios],
                              })
                            } else if (action === "remove-value" || action === "pop-value") {
                              relacaoPropServico_id = await updateOptionOnPropostaData();
                              const selectedMacroatividadesFromModeloServico = selectedMacroatividades.filter(sma => sma.modeloServico_id !== removedValue.value)
                              const selectedEPsFromModeloServico = selectedEpsProp.filter(sep => sep.modeloServico_id !== removedValue.value)
                              const selectedProdsPropFromModeloServico = selectedProdsProp.filter(sep => sep.modeloServico_id !== removedValue.value)

                              const formattedModeloServicosSecundariosFiltered = formattedModeloServicosSecundarios.filter(ms => ms.relacaoPropServico_id !== relacaoPropServico_id);


                              setSelectedMacroatividades([...selectedMacroatividadesFromModeloServico]);
                              setSelectedEpsProp([...selectedEPsFromModeloServico]);
                              setSelectedProdsProp([...selectedProdsPropFromModeloServico]);
                              setPropostaData({
                                ...propostaData,
                                modeloServico_ids: [...modeloServicoPrimario, ...formattedModeloServicosSecundariosFiltered],
                              })

                            } else if (action === "clear") {
                              arrayRelacaoPropServico = await updateOptionOnPropostaData();
                            }
                          };

                          const resetToModeloServicoPrimario = () => {
                            const modeloServicoPrimario = propostaData.modeloServico_ids ? propostaData.modeloServico_ids.filter(ms => ms.modeloServico_primario) : [];
                            if (modeloServicoPrimario.length > 0) {
                              setSelectedMacroatividades(selectedMacroatividades.filter(m => m.modeloServico_id === modeloServicoPrimario[0].modeloServico_id));
                              setSelectedProdsProp(selectedProdsProp.filter(m => m.modeloServico_id === modeloServicoPrimario[0].modeloServico_id));
                              setSelectedEpsProp(selectedEpsProp.filter(m => m.modeloServico_id === modeloServicoPrimario[0].modeloServico_id));
                            } else {
                              setSelectedMacroatividades([]);
                              setSelectedProdsProp([]);
                              setSelectedEpsProp([]);
                            }

                            setPropostaData({
                              ...propostaData,
                              modeloServico_ids: [...modeloServicoPrimario],
                            })
                          };

                          if (action === "clear") {
                            await updateOptionOnPropostaData();
                            resetToModeloServicoPrimario();
                          } else if (action === "remove-value" || action === "pop-value" || action === "select-option") {
                            if (e && e.length > 0) {
                              await applySelectedOptions(e);
                            } else {
                              await updateOptionOnPropostaData();
                              resetToModeloServicoPrimario();
                            }
                          } else {
                            if (e && e.length > 0) {
                              await updateOptionOnPropostaData();
                              await applySelectedOptions(e);
                            } else {
                              await updateOptionOnPropostaData();
                              resetToModeloServicoPrimario();
                            }
                          }

                          setIsLoadingSelected(false);
                        }}
                      />
                    </>
                  }
                </>
              }
              {
                propostaData.modeloServico_ids && propostaData.modeloServico_ids.length > 0 && propostaData.modeloServico_ids.filter(ms => !ms.composicaoModeloServico_id).length > 0 && !isLoadingSelected &&
                (
                  <>
                    {propostaData.modeloServico_ids.map((ms, index) => {
                      if (!ms.composicaoModeloServico_id) {
                        return (
                          <Card className={index === 0 ? "mt-4" : ""}>
                            <CardHeader>
                              <div className='d-flex justify-content-between'>
                                <strong>{modelosServicos.find(modelo => modelo.value === ms.modeloServico_id)?.label}</strong>
                                <div>
                                  {
                                  isLoadingEditServico === ms.modeloServico_id ? <Spinner /> : <Button onClick={async () => {
                                    const modeloS = modelosServicos.find(modelo => modelo.value === ms.modeloServico_id);
                                    setIsLoadingEditServico(modeloS.modeloServico_id);
                                    const macroatividades = await getMacroatividadesByModeloServicoId(modeloS.modeloServico_id);
                                    for (let index = 0; index < macroatividades.length; index++) {
                                      const macroatividade = macroatividades[index];

                                      if (macroatividade.produtos?.length) {
                                        macroatividades[index].produtos = Array.from(
                                          new Map(
                                            macroatividades[index].produtos.map(m => [
                                              m.relacaoProdPropMacroatividade_id ?? m.relacaoServicoProdProp_id,
                                              m
                                            ])
                                          ).values()
                                        );
                                      }

                                      if (macroatividade.eventosPagamento?.length) {
                                        macroatividades[index].eventosPagamento = Array.from(
                                          new Map(
                                            macroatividades[index].eventosPagamento.map(m => [
                                              m.relacaoEventoPagamentoPropMacroatividade_id ?? m.relacaoServicoEventoPagamentoProp_id,
                                              m
                                            ])
                                          ).values()
                                        );
                                      }

                                    }

                                    setSelectedMacroatividades(
                                      [
                                        ...selectedMacroatividades.filter(sm => sm.modeloServico_id !== modeloS.modeloServico_id),
                                        ...macroatividades
                                      ]
                                    );

                                    const eps = await getEPsPropByModeloServicoId(modeloS.modeloServico_id);
                                    for (let index = 0; index < eps.length; index++) {
                                      const ep = eps[index];

                                      if (ep.produtos?.length) {
                                        eps[index].produtos = Array.from(
                                          new Map(
                                            eps[index].produtos.map(m => [
                                              m.relacaoProdProp_idEventoPagamentoProp ?? m.relacaoServicoProdProp_id,
                                              m
                                            ])
                                          ).values()
                                        );
                                      }

                                      if (ep.macroatividades?.length) {
                                        eps[index].macroatividades = Array.from(
                                          new Map(
                                            eps[index].macroatividades.map(m => [
                                              m.relacaoEventoPagamentoPropMacroatividade_id ?? m.relacaoServicoMacroatividade_id,
                                              m
                                            ])
                                          ).values()
                                        );
                                      }

                                    }
                                    setSelectedEpsProp(
                                      [
                                        ...selectedEpsProp.filter(sm => sm.modeloServico_id !== modeloS.modeloServico_id),
                                        ...eps
                                      ]
                                    );

                                    const produtos = await getProdsPropByModeloServicoId(modeloS.modeloServico_id);
                                    for (let index = 0; index < produtos.length; index++) {
                                      const produto = produtos[index];

                                      if (produto.eventosPagamento?.length) {
                                        produtos[index].eventosPagamento = Array.from(
                                          new Map(
                                            produtos[index].eventosPagamento.map(m => [
                                              m.relacaoProdProp_idEventoPagamentoProp ?? m.relacaoServicoEventoPagamentoProp_id,
                                              m
                                            ])
                                          ).values()
                                        );
                                      }

                                      if (produto.macroatividades?.length) {
                                        produtos[index].macroatividades = Array.from(
                                          new Map(
                                            produtos[index].macroatividades.map(m => [
                                              m.relacaoProdPropMacroatividade_id ?? m.relacaoServicoMacroatividade_id,
                                              m
                                            ])
                                          ).values()
                                        );
                                      }

                                    }
                                    setSelectedProdsProp(
                                      [
                                        ...selectedProdsProp.filter(sm => sm.modeloServico_id !== modeloS.modeloServico_id),
                                        ...produtos
                                      ]
                                    );

                                    modeloS['macroatividades'] = macroatividades;
                                    modeloS['eventosPagamento'] = eps;
                                    modeloS['produtos'] = produtos;

                                    console.log('modeloS', modeloS);

                                    setModeloServicoOriginal(modeloS);
                                    setModeloServicoData(modeloS);
                                    setIsLoadingEditServico(0);
                                    setModalEditServicoOpen(true);
                                  }}>
                                    Editar
                                  </Button>
                                  }
                                  <Button
                                    onClick={() => {
                                      setPropostaData({
                                        modeloServico_ids: propostaData.modeloServico_ids.filter(msObj => msObj.modeloServico_id !== ms.modeloServico_id )
                                      })
                                    }}
                                  >
                                    Deletar
                                  </Button>
                                </div>
                              </div>
                            </CardHeader>
                            <CardBody>
                              <div className='d-flex'>
                                <div className="d-flex flex-column mr-5">
                                  <p style={{fontWeight: 'bold'}}>Macroatividades</p>
                                  {selectedMacroatividades.filter(sm => sm.modeloServico_id === ms.modeloServico_id).map(sm => {
                                    return (
                                      <>
                                        <p>{sm.macroatividade_nome}</p>
                                      </>

                                  )
                                  })}
                                </div>
                                <div className="d-flex flex-column mr-5">
                                  <p style={{fontWeight: 'bold'}}>Produtos</p>
                                  {selectedProdsProp.filter(sp => sp.modeloServico_id === ms.modeloServico_id).map(sp => {
                                    return (
                                    <p>{sp.prodProp_nome}</p>
                                  )
                                  })}
                                </div>
                                <div className="d-flex flex-column">
                                  <p style={{fontWeight: 'bold'}}>Eventos de pagamento</p>
                                  {selectedEpsProp.filter(sep => sep.modeloServico_id === ms.modeloServico_id).map(sep => {
                                    return (
                                    <p>{sep.eventoPagamentoProp_nome}</p>
                                  )
                                  })}
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        )
                      }
                    })}
                  </>
                )
              }
            </> : <span>Você ainda não iniciou uma proposta</span>
          }
        </div>
      ),
    },
    {
      id: "tab-6",
      label: "Entidades",
      subtitle: "Selecione macroatividades, produtos e eventos de pagamento",
      content: (
        <div>
          {isLoadingSelected && <Spinner color="primary" />}
          {
            !isLoadingSelected &&
            <>
              {selectedMacroatividades.length > 0 && <Button onClick={() => {handleShowEntity('showMacroatividades')}}>Macroatividades</Button>}
              {selectedProdsProp.length > 0 && <Button onClick={() => {handleShowEntity('showProdutos')}}>Produtos</Button>}
              {selectedEpsProp.length > 0 && <Button onClick={() => {handleShowEntity('showEPs')}}>Eventos de pagamento</Button>}
            </>
          }

          {
            entitySelected.showMacroatividades && selectedMacroatividades.length > 0 && !isLoadingSelected &&
            <>
              <div className='d-flex justify-content-between align-items-center'>
                <h4>Macroatividades:</h4>
                <Button
                  size="sm"
                  color="link"
                  className="ml-2 px-0"
                  onClick={(e)=>{
                    setModalMacroatividadeOpen(true);
                  }}
                >
                  Adicionar macroatividade
                </Button>
              </div>
              <MaterialReactTable
                columns={columnsSelectedMacroatividades}
                data={selectedMacroatividades}
                initialState={{
                  density: 'compact',
                  expanded: {}, //expand all groups by default
                  pagination: { pageIndex: 0, pageSize: 10 },
                  sorting: [], //sort by state by default,
                }}
                enableColumnResizing={true}
                enableGrouping={false}
                enableGlobalFilter={true}
                enableFilters={true}
                renderDetailPanel={({row}) => {

                  return (
                    <>
                      <div className="d-flex">
                        {selectedMacroatividades.length > 0 && <Button onClick={() => {handleShowEntityInsideMacroatividade('showRecursosHumanos')}}>Recursos Humanos</Button>}
                        {selectedMacroatividades.length > 0 && <Button onClick={() => {handleShowEntityInsideMacroatividade('showLogistica')}}>Logística</Button>}
                        {selectedMacroatividades.length > 0 && <Button onClick={() => {handleShowEntityInsideMacroatividade('showDespesasGerais')}}>Despesas Gerais</Button>}
                        {selectedMacroatividades.length > 0 && <Button onClick={() => {handleShowEntityInsideMacroatividade('showEquipamentos')}}>Equipamentos</Button>}
                        {selectedMacroatividades.length > 0 && <Button onClick={() => {handleShowEntityInsideMacroatividade('showSubcontratacoes')}}>Subcontratações</Button>}
                        {selectedMacroatividades.length > 0 && <Button onClick={() => {handleShowEntityInsideMacroatividade('showReceitas')}}>Receitas</Button>}
                      </div>
                      {row.original.propItens && row.original.propItens.length > 0 && entitySelectedInsideMacroatividades.showRecursosHumanos &&
                        <>
                          <div className='d-flex flex-column mr-4'>
                            <div className="d-flex justify-content-between">
                              <h6>Recursos Humanos:</h6>
                              <Button
                                size="sm"
                                color="link"
                                className="ml-2 px-0"
                                onClick={(e)=>{
                                  setPropItemData({propItemGr_id: 1, propItemGr_label: 'Recurso Humano'});
                                  setMacroatividadeData(row.original);
                                  setModalPropItemToMacroatividadeOpen(true);
                                }}
                              >
                                Adicionar recurso humano
                              </Button>
                            </div>
                            <MaterialReactTable
                              columns={columnsSelectedMacroatividadesPropItens}
                              data={row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 1).length > 0 ? row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 1) : []}
                              initialState={{
                                density: 'compact',
                                expanded: {}, //expand all groups by default
                                pagination: { pageIndex: 0, pageSize: 10 },
                                sorting: [], //sort by state by default,
                              }}
                              enableColumnResizing={true}
                              enableGrouping={false}
                              enableGlobalFilter={true}
                              enableFilters={true}
                              renderDetailPanel={({row}) => {
                                return (
                                  <>
                                  </>
                                )
                              }}
                              enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 1).length > 10)}
                              muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                              muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                              muiTablePaginationProps={{
                                sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                                labelRowsPerPage: <span style={{fontSize: "12px"}}>Recursos Humanos por página</span>,
                                rowsPerPageOptions: [10, 50, 100],
                              }}
                              positionPagination='bottom'
                              muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                              enableDensityToggle={false}
                              enableColumnFilters={false}
                              muiTableHeadCellProps={{
                                sx: {
                                  '.MuiSvgIcon-root': {fontSize: "18px"},
                                  fontSize: '12px',
                                  fontWeight: 'normal', // Remove bold text in the header
                                  padding: '8px', // Adjust padding to reduce white space
                                },
                              }}
                            />
                          </div>
                        </>
                      }
                      {row.original.propItens && row.original.propItens.length > 0 && entitySelectedInsideMacroatividades.showLogistica &&
                        <>
                          <div className='d-flex flex-column mr-4'>
                            <div className="d-flex justify-content-between">
                              <h6>Logística:</h6>
                              <Button
                                size="sm"
                                color="link"
                                className="ml-2 px-0"
                                onClick={(e)=>{
                                  setPropItemData({propItemGr_id: 4, propItemGr_label: 'Logística'});
                                  setMacroatividadeData(row.original);
                                  setModalPropItemToMacroatividadeOpen(true);
                                }}
                              >
                                Adicionar logística
                              </Button>
                            </div>
                            <MaterialReactTable
                              columns={columnsSelectedMacroatividadesPropItens}
                              data={row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 4).length > 0 ? row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 4) : []}
                              initialState={{
                                density: 'compact',
                                expanded: {}, //expand all groups by default
                                pagination: { pageIndex: 0, pageSize: 10 },
                                sorting: [], //sort by state by default,
                              }}
                              enableColumnResizing={true}
                              enableGrouping={false}
                              enableGlobalFilter={true}
                              enableFilters={true}
                              renderDetailPanel={({row}) => {
                                return (
                                  <>
                                  </>
                                )
                              }}
                              enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 4).length > 10)}
                              muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                              muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                              muiTablePaginationProps={{
                                sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                                labelRowsPerPage: <span style={{fontSize: "12px"}}>Logística por página</span>,
                                rowsPerPageOptions: [10, 50, 100],
                              }}
                              positionPagination='bottom'
                              muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                              enableDensityToggle={false}
                              enableColumnFilters={false}
                              muiTableHeadCellProps={{
                                sx: {
                                  '.MuiSvgIcon-root': {fontSize: "18px"},
                                  fontSize: '12px',
                                  fontWeight: 'normal', // Remove bold text in the header
                                  padding: '8px', // Adjust padding to reduce white space
                                },
                              }}
                            />
                          </div>
                        </>
                      }
                      {row.original.propItens && row.original.propItens.length > 0 && entitySelectedInsideMacroatividades.showDespesasGerais &&
                        <>
                          <div className='d-flex flex-column mr-4'>
                            <div className="d-flex justify-content-between">
                              <h6>Despesas Gerais:</h6>
                              <Button
                                size="sm"
                                color="link"
                                className="ml-2 px-0"
                                onClick={(e)=>{
                                  setPropItemData({propItemGr_id: 3, propItemGr_label: 'Despesa Geral'});
                                  setMacroatividadeData(row.original);
                                  setModalPropItemToMacroatividadeOpen(true);
                                }}
                              >
                                Adicionar despesa geral
                              </Button>
                            </div>
                            <MaterialReactTable
                              columns={columnsSelectedMacroatividadesPropItens}
                              data={row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 3).length > 0 ? row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 3) : []}
                              initialState={{
                                density: 'compact',
                                expanded: {}, //expand all groups by default
                                pagination: { pageIndex: 0, pageSize: 10 },
                                sorting: [], //sort by state by default,
                              }}
                              enableColumnResizing={true}
                              enableGrouping={false}
                              enableGlobalFilter={true}
                              enableFilters={true}
                              renderDetailPanel={({row}) => {
                                return (
                                  <>
                                  </>
                                )
                              }}
                              enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 3).length > 10)}
                              muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                              muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                              muiTablePaginationProps={{
                                sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                                labelRowsPerPage: <span style={{fontSize: "12px"}}>Despesas gerais por página</span>,
                                rowsPerPageOptions: [10, 50, 100],
                              }}
                              positionPagination='bottom'
                              muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                              enableDensityToggle={false}
                              enableColumnFilters={false}
                              muiTableHeadCellProps={{
                                sx: {
                                  '.MuiSvgIcon-root': {fontSize: "18px"},
                                  fontSize: '12px',
                                  fontWeight: 'normal', // Remove bold text in the header
                                  padding: '8px', // Adjust padding to reduce white space
                                },
                              }}
                            />
                          </div>
                        </>
                      }
                      {row.original.propItens && row.original.propItens.length > 0 && entitySelectedInsideMacroatividades.showEquipamentos &&
                        <>
                          <div className='d-flex flex-column mr-4'>
                            <div className="d-flex justify-content-between">
                              <h6>Equipamentos:</h6>
                              <Button
                                size="sm"
                                color="link"
                                className="ml-2 px-0"
                                onClick={(e)=>{
                                  setPropItemData({propItemGr_id: 2, propItemGr_label: 'Equipamento'});
                                  setMacroatividadeData(row.original);
                                  setModalPropItemToMacroatividadeOpen(true);
                                }}
                              >
                                Adicionar equipamento
                              </Button>
                            </div>
                            <MaterialReactTable
                              columns={columnsSelectedMacroatividadesPropItens}
                              data={row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 2).length > 0 ? row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 2) : []}
                              initialState={{
                                density: 'compact',
                                expanded: {}, //expand all groups by default
                                pagination: { pageIndex: 0, pageSize: 10 },
                                sorting: [], //sort by state by default,
                              }}
                              enableColumnResizing={true}
                              enableGrouping={false}
                              enableGlobalFilter={true}
                              enableFilters={true}
                              renderDetailPanel={({row}) => {
                                return (
                                  <>
                                  </>
                                )
                              }}
                              enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 2).length > 10)}
                              muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                              muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                              muiTablePaginationProps={{
                                sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                                labelRowsPerPage: <span style={{fontSize: "12px"}}>Equipamentos por página</span>,
                                rowsPerPageOptions: [10, 50, 100],
                              }}
                              positionPagination='bottom'
                              muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                              enableDensityToggle={false}
                              enableColumnFilters={false}
                              muiTableHeadCellProps={{
                                sx: {
                                  '.MuiSvgIcon-root': {fontSize: "18px"},
                                  fontSize: '12px',
                                  fontWeight: 'normal', // Remove bold text in the header
                                  padding: '8px', // Adjust padding to reduce white space
                                },
                              }}
                            />
                          </div>
                        </>
                      }
                      {row.original.propItens && row.original.propItens.length > 0 && entitySelectedInsideMacroatividades.showSubcontratacoes &&
                        <>
                          <div className='d-flex flex-column mr-4'>
                            <div className="d-flex justify-content-between">
                              <h6>Subcontratações:</h6>
                              <Button
                                size="sm"
                                color="link"
                                className="ml-2 px-0"
                                onClick={(e)=>{
                                  setPropItemData({propItemGr_id: 5, propItemGr_label: 'Subcontratação'});
                                  setMacroatividadeData(row.original);
                                  setModalPropItemToMacroatividadeOpen(true);
                                }}
                              >
                                Adicionar subcontratação
                              </Button>
                            </div>
                            <MaterialReactTable
                              columns={columnsSelectedMacroatividadesPropItens}
                              data={row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 5).length > 0 ? row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 5) : []}
                              initialState={{
                                density: 'compact',
                                expanded: {}, //expand all groups by default
                                pagination: { pageIndex: 0, pageSize: 10 },
                                sorting: [], //sort by state by default,
                              }}
                              enableColumnResizing={true}
                              enableGrouping={false}
                              enableGlobalFilter={true}
                              enableFilters={true}
                              renderDetailPanel={({row}) => {
                                return (
                                  <>
                                  </>
                                )
                              }}
                              enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 5).length > 10)}
                              muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                              muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                              muiTablePaginationProps={{
                                sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                                labelRowsPerPage: <span style={{fontSize: "12px"}}>Logística por página</span>,
                                rowsPerPageOptions: [10, 50, 100],
                              }}
                              positionPagination='bottom'
                              muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                              enableDensityToggle={false}
                              enableColumnFilters={false}
                              muiTableHeadCellProps={{
                                sx: {
                                  '.MuiSvgIcon-root': {fontSize: "18px"},
                                  fontSize: '12px',
                                  fontWeight: 'normal', // Remove bold text in the header
                                  padding: '8px', // Adjust padding to reduce white space
                                },
                              }}
                            />
                          </div>
                        </>
                      }
                      {row.original.propItens && row.original.propItens.length > 0 && entitySelectedInsideMacroatividades.showReceitas &&
                        <>
                          <div className='d-flex flex-column mr-4'>
                            <div className="d-flex justify-content-between">
                              <h6>Receitas:</h6>
                              <Button
                                size="sm"
                                color="link"
                                className="ml-2 px-0"
                                onClick={(e)=>{
                                  setPropItemData({propItemGr_id: 6, propItemGr_label: 'Receita'});
                                  setMacroatividadeData(row.original);
                                  setModalPropItemToMacroatividadeOpen(true);
                                }}
                              >
                                Adicionar receita
                              </Button>
                            </div>
                            <MaterialReactTable
                              columns={columnsSelectedMacroatividadesPropItens}
                              data={row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 6).length > 0 ? row.original.propItens.filter(pi => Number(pi.propItemGr_id) === 6) : []}
                              initialState={{
                                density: 'compact',
                                expanded: {}, //expand all groups by default
                                pagination: { pageIndex: 0, pageSize: 10 },
                                sorting: [], //sort by state by default,
                              }}
                              enableColumnResizing={true}
                              enableGrouping={false}
                              enableGlobalFilter={true}
                              enableFilters={true}
                              renderDetailPanel={({row}) => {
                                return (
                                  <>
                                  </>
                                )
                              }}
                              enablePagination={(selectedMacroatividades.flatMap(sm => sm.propItens || []).filter(pi => Number(pi.propItemGr_id) === 6).length > 10)}
                              muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                              muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                              muiTablePaginationProps={{
                                sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                                labelRowsPerPage: <span style={{fontSize: "12px"}}>Logística por página</span>,
                                rowsPerPageOptions: [10, 50, 100],
                              }}
                              positionPagination='bottom'
                              muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                              enableDensityToggle={false}
                              enableColumnFilters={false}
                              muiTableHeadCellProps={{
                                sx: {
                                  '.MuiSvgIcon-root': {fontSize: "18px"},
                                  fontSize: '12px',
                                  fontWeight: 'normal', // Remove bold text in the header
                                  padding: '8px', // Adjust padding to reduce white space
                                },
                              }}
                            />
                          </div>
                        </>
                      }
                    </>
                  )
                }}
                enablePagination={(selectedMacroatividades.length > 10)}
                muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                muiTablePaginationProps={{
                  sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                  labelRowsPerPage: <span style={{fontSize: "12px"}}>Macroatividades por página</span>,
                  rowsPerPageOptions: [10, 50, 100],
                }}
                positionPagination='bottom'
                muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                enableDensityToggle={false}
                enableColumnFilters={false}
                muiTableHeadCellProps={{
                  sx: {
                    '.MuiSvgIcon-root': {fontSize: "18px"},
                    fontSize: '12px',
                    fontWeight: 'normal', // Remove bold text in the header
                    padding: '8px', // Adjust padding to reduce white space
                  },
                }}
              />
            </>
          }
          {
            entitySelected.showProdutos && selectedProdsProp.length > 0 && !isLoadingSelected &&
            <>
              <div className='d-flex justify-content-between align-items-center'>
                <h4>Produtos:</h4>
                <Button
                  size="sm"
                  color="link"
                  className="ml-2 px-0"
                  onClick={(e)=>{
                    setModalProdPropOpen(true)
                  }}
                >
                  Adicionar produto
                </Button>
              </div>
              <MaterialReactTable
                columns={columnsSelectedProdsProp}
                data={selectedProdsProp}
                initialState={{
                  density: 'compact',
                  expanded: {}, //expand all groups by default
                  pagination: { pageIndex: 0, pageSize: 10 },
                  sorting: [], //sort by state by default,
                }}
                enableColumnResizing={true}
                enableGrouping={false}
                enableGlobalFilter={true}
                enableFilters={true}
                enablePagination={(columnsSelectedProdsProp.length > 10)}
                muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                renderDetailPanel={({row}) => {
                  return (
                    <>
                      {row.original.macroatividades &&
                      <>
                      <h6>Macroatividades:</h6>
                      {row.original.macroatividades.map(p => <p>{p.macroatividade_nome}</p>)}
                      </>
                      }
                      {row.original.eventosPagamento &&
                      <>
                      <h6>Eventos de pagamento:</h6>
                      {row.original.eventosPagamento.map(ep => <p>{ep.eventoPagamentoProp_nome}</p>)}
                      </>
                      }
                    </>
                  )
                }}
                muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                muiTablePaginationProps={{
                  sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                  labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                  rowsPerPageOptions: [10, 50, 100],
                }}
                positionPagination='bottom'
                muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                enableDensityToggle={false}
                enableColumnFilters={false}
                muiTableHeadCellProps={{
                  sx: {
                    '.MuiSvgIcon-root': {fontSize: "18px"},
                    fontSize: '12px',
                    fontWeight: 'normal', // Remove bold text in the header
                    padding: '8px', // Adjust padding to reduce white space
                  },
                }}
              />
            </>
          }
          {
            entitySelected.showEPs && selectedEpsProp.length > 0 && !isLoadingSelected &&
            <>
              <div className='d-flex justify-content-between align-items-center'>
                <h4>Eventos de pagamento:</h4>
                <Button
                  size="sm"
                  color="link"
                  className="ml-2 px-0"
                  onClick={(e)=>{
                    setIsEditingEventoPagamentoProp(false);
                    setEventoPagamentoPropData({});
                    setModalEpOpen(true);
                  }}
                >
                  Adicionar evento de pagamento
                </Button>
              </div>
              <MaterialReactTable
                columns={columnsSelectedEventosPagamentoProp}
                data={selectedEpsProp}
                initialState={{
                  density: 'compact',
                  expanded: {}, //expand all groups by default
                  pagination: { pageIndex: 0, pageSize: 10 },
                  sorting: [], //sort by state by default,
                }}
                enableColumnResizing={true}
                enableGrouping={false}
                enableGlobalFilter={true}
                enableFilters={true}
                enablePagination={(columnsSelectedProdsProp.length > 10)}
                muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                renderDetailPanel={({row}) => {
                  return (
                    <>
                      {row.original.macroatividades &&
                      <>
                      <h6>Macroatividades:</h6>
                      {row.original.macroatividades.map(p => <p>{p.macroatividade_nome}</p>)}
                      </>
                      }
                      {row.original.produtos &&
                      <>
                      <h6>Produtos:</h6>
                      {row.original.produtos.map(ep => <p>{ep.prodProp_nome}</p>)}
                      </>
                      }
                    </>
                  )
                }}
                muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                muiTablePaginationProps={{
                  sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                  labelRowsPerPage: <span style={{fontSize: "12px"}}>Eventos por página</span>,
                  rowsPerPageOptions: [10, 50, 100],
                }}
                positionPagination='bottom'
                muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                enableDensityToggle={false}
                enableColumnFilters={false}
                muiTableHeadCellProps={{
                  sx: {
                    '.MuiSvgIcon-root': {fontSize: "18px"},
                    fontSize: '12px',
                    fontWeight: 'normal', // Remove bold text in the header
                    padding: '8px', // Adjust padding to reduce white space
                  },
                }}
              />
            </>
          }
        </div>
      ),
    },
    {
      id: "tab-7",
      label: "Visão geral",
      subtitle: "Resumo dos itens",
      content: (
        <div>
          <Card>
            <CardHeader>
              Total de itens selecionados
            </CardHeader>
            <CardBody>
              <Row className="gy-3">
                <div className="col-12">
                  <div>
                    <small>Total (base)</small>
                    <h3 style={{ margin: 0 }}>
                      {currencyFormatter.format(visaoGeralTotal || 0)}
                    </h3>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>Comissão (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.comissao ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          comissao: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>Custo financeiro (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.custoFinanceiro ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          custoFinanceiro: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>Taxa ADM (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.taxaAdm ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          taxaAdm: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>Remuneração da empresa (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.remuneracaoEmpresa ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          remuneracaoEmpresa: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-end">
                    <div>
                      <small>Total de percentuais</small>
                      <div style={{ fontWeight: 600 }}>
                        {formatPercent(visaoGeralPercentualTotal)}
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <small>Valor final</small>
                      <h3 style={{ margin: 0 }}>
                        {currencyFormatter.format(visaoGeralValorFinal || 0)}
                      </h3>
                    </div>
                  </div>
                </div>
              </Row>
              <small>
                Soma de (valor de referência × quantidade) em todas as macroatividades selecionadas.
              </small>
            </CardBody>
          </Card>
        </div>
      ),
    },
  ];

  const activeTab = TABS.find((tab) => tab.id === activeId);

  const fetchPropPropItemByPropId = async (propId) => {
    console.log('fetching prop prop item by prop id', propId)
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoPropPropItem',
        data: {
          prop_id: propId,
        },
        fields: {
          "(SELECT propItem_desc FROM propItem WHERE propItem.propItem_id = relacaoPropPropItem.propItem_id)": "propItem_desc",
          "(SELECT propItemGr_id FROM propItem WHERE propItem.propItem_id = relacaoPropPropItem.propItem_id)": "propItemGr_id",
          "(SELECT propItemGr_label FROM propItem WHERE propItem.propItem_id = relacaoPropPropItem.propItem_id)": "propItemGr_label",
          "(SELECT propItem_refVlr FROM propItem WHERE propItem.propItem_id = relacaoPropPropItem.propItem_id)": "propItem_refVlr",
          "(SELECT unidade_label FROM propItem WHERE propItem.propItem_id = relacaoPropPropItem.propItem_id)": "unidade_label",
        }
      })}`
    )


    return res.data;
  }

  const fetchModelosPropostas = async () => {
    setIsLoadingModelosPropostas(true);
    setModelosPropostas([]);

    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'prop',
        data: {
          prop_ativo: 1,
          prop_modelo: 1,
        },
        fields: {
          '(SELECT pj_id from negociacao WHERE negociacao.negociacao_id = prop.negociacao_id)': "pj_id"
        }
      })}`
    )

    setModelosPropostas(res.data)
    setIsLoadingModelosPropostas(false);
  }

  const fetchModelosPropostaByServicoId = async (servicoId, principal) => {
    setIsLoadingModelosPropostaByServicoId(true);

    console.log(servicoId);

    const modelosPropostaByServicoIdArray = [];

    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoPropServico',
        data: {
          servico_id: servicoId,
          relacaoPropServico_ativo: 1,
        },
      })}`
    )

    console.log(res);

    for (let index = 0; index < res.data.length; index++) {
      const relacaoPropServico = res.data[index];

      const resProp = await oikosApi.get(
        `/?${qs.stringify({
          action: 'get',
          table: 'prop',
          data: {
            prop_id: relacaoPropServico.prop_id,
            prop_ativo: 1,
          },
        })}`
      )

      console.log(resProp);

      if (resProp.data.length > 0) {
        modelosPropostaByServicoIdArray.push({...resProp.data[0], ...relacaoPropServico});
      }
    }

    setIsLoadingModelosPropostaByServicoId(false);

    if (principal) {
      return modelosPropostaByServicoIdArray.map(mp => { return {...mp, principal: true} });
    } else {
      return modelosPropostaByServicoIdArray.map(mp => { return {...mp, principal: false} });
    }
  }

  const fetchPjs = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'pj',
        data: {
          pj_ativo: 1,
        },
        fields: {
          pj_id: 'value',
          pj_razaosocial: 'label',
        }
      })}`
    )

    setPjs(res.data)
  }

  const fetchItensOrcamentarios = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'propItem',
        data: {
          propItem_ativo: 1,
        },
        fields: {
          propItem_id : "value",
          "(CONCAT(propItem_desc, ' (', unidade_label, ')'))": 'label'
        }
      })}`
    )

    setPropItens(res.data)
  }

  const fetchSelectServicos = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'modeloServico',
        data: {
          modeloServico_ativo: 1,
        },
        fields: {
          modeloServico_id: 'value',
          modeloServico_nome: 'label',
        }
      })}`
    )

    setModelosServicos(res.data)
  }

  const fetchSelectServicosCompostos = async () => {
    const res = await selectValues('composicaoModeloServico', 'composicaoModeloServico_id', 'composicaoModeloServico_nome', {composicaoModeloServico_ativo: 1});

    setServicosCompostos(res)
  }

  const fetchMacroatividades = async () => {
    let res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'macroatividade',
        data: {
          macroatividade_ativo: 1,
        },
        fields: {
          macroatividade_id: 'value',
          macroatividade_nome: 'label',
        }
      })}`
    )

    console.log(res)

    res.data = res.data.map(m => { return {...m, value: `${m.value}-${Date.now()}`}})

    for (let index = 0; index < res.data.length; index++) {
      const macro = res.data[index];

      let resPropItemFromMacro = await oikosApi.get(
        `/?${qs.stringify({
          action: 'get',
          table: 'relacaoMacroatividadePropItem',
          data: {
            relacaoMacroatividadePropItem_ativo: 1,
            macroatividade_id: macro.macroatividade_id,
          },
          fields: {
            "(SELECT propItem_desc FROM propItem WHERE propItem.propItem_id = relacaoMacroatividadePropItem.propItem_id)": "label",
            "(SELECT propItem_desc FROM propItem WHERE propItem.propItem_id = relacaoMacroatividadePropItem.propItem_id)": "propItem_desc",
            propItem_id: "value",
            "(SELECT propItem_refVlr FROM propItem WHERE propItem.propItem_id = relacaoMacroatividadePropItem.propItem_id)": "propItem_refVlr",
            "(SELECT propItemGr_id FROM propItem WHERE propItem.propItem_id = relacaoMacroatividadePropItem.propItem_id)": "propItemGr_id",
            "(SELECT unidade_label FROM propItem WHERE propItem.propItem_id = relacaoMacroatividadePropItem.propItem_id)": "unidade_label",
          }
        })}`
      )

      resPropItemFromMacro.data = resPropItemFromMacro.data.filter(rmpi => !rmpi.relacaoServicoMacroatividade_id);

      res.data[index] = {...res.data[index], propItens: resPropItemFromMacro.data}
    }

    setMacroatividades(res.data);
  }

  const fetchServicos = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'servico',
        data: {
          servico_ativo: 1,
        },
        fields: {
          servico_id: 'value',
          servico_nome: 'label'
        }
      })}`
    )

    setServicos([...res.data]);
  }

  const fetchEventosPagamento = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'eventoPagamentoProp',
        data: {
          eventoPagamentoProp_ativo: 1,
        },
        fields: {
          eventoPagamentoProp_id: 'value',
          eventoPagamentoProp_nome: 'label'
        }
      })}`
    )

    setEventosPagamentoProp(res.data);
  }

  const fetchProdsProp = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'prodProp',
        data: {
          prodProp_ativo: 1,
        },
        fields: {
          prodProp_id: 'value',
          prodProp_nome: 'label'
        }
      })}`
    )

    setProdsProp(res.data);
  }

  const fetchServicosCompostos = async (composicaoModeloServicoId) => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoComposicaoModeloServicoModeloServico',
        data: {
          composicaoModeloServico_id: composicaoModeloServicoId,
        }
      })}`
    )

    const formattedModeloServicosSecundarios = [];
    const selectServicosCompostosSecundarios = [];
    for (let i = 0; i < res.data.length; i++) {
      const ms = res.data[i];
      const alreadyExists = propostaData.modeloServico_ids?.find(m => m.modeloServico_id === ms.modeloServico_id);
      if (alreadyExists) {
        continue;
      }
      selectServicosCompostosSecundarios.push({value: ms.modeloServico_id, label: modelosServicos.find(m => m.value === ms.modeloServico_id).label});
      formattedModeloServicosSecundarios.push({modeloServico_id: ms.modeloServico_id, modeloServico_secundario: true, servicoComposto: true});
    }
    setComposicaoDeServicos(selectServicosCompostosSecundarios);
    setPropostaData({
      ...propostaData,
      modeloServico_ids: [{composicaoModeloServico_id: composicaoModeloServicoId, modeloServico_primario: true, servicoComposto: true}, ...formattedModeloServicosSecundarios]
    })
  }

  const getModelosServicosByPropId = async (propId) => {

    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoPropServico',
        data: {
          prop_id: propId,
          relacaoPropServico_ativo: 1
        }
      })}`
    )
    let selectedMacroatividadesCopy = [];
    let selectedProdPropCopy = [];
    let selectedEpsPropCopy = [];

    for (let index = 0; index < res.data.length; index++) {
      const element = res.data[index];

      if (element.relacaoPropServico_servicoPrincipal) {
        const rps = element;
        const selectedMacroatividadesFromModeloServico = selectedMacroatividades.filter(sma => sma.modeloServico_id === rps.modeloServico_id)
        const selectedEPsFromModeloServico = selectedEpsProp.filter(sep => sep.modeloServico_id === rps.modeloServico_id)
        const selectedProdsPropFromModeloServico = selectedProdsProp.filter(sep => sep.modeloServico_id === rps.modeloServico_id)

        const macroatividadesByModeloServico = await getMacroatividadesByModeloServicoIdForModeloProposta(rps.modeloServico_id, rps.relacaoPropServico_id);
        for (let i = 0; i < macroatividadesByModeloServico.length; i++) {
          const rsm = macroatividadesByModeloServico[i];
          selectedMacroatividadesCopy.push(rsm);
        }


        const epsPropByModeloServicoId = await getEPsPropByModeloServicoIdForModeloProposta(rps.modeloServico_id, rps.relacaoPropServico_id);
        for (let i = 0; i < epsPropByModeloServicoId.length; i++) {
          const rsep = epsPropByModeloServicoId[i];
          selectedEpsPropCopy.push(rsep);
        }

        const prodsPropByModeloServicoId = await getProdsPropByModeloServicoIdForModeloProposta(rps.modeloServico_id, rps.relacaoPropServico_id);
        for (let i = 0; i < prodsPropByModeloServicoId.length; i++) {
          const rspp = prodsPropByModeloServicoId[i];
          selectedProdPropCopy.push(rspp);
        }

      } else {
        const rps = element;
        const selectedMacroatividadesFromModeloServico = selectedMacroatividades.filter(sma => sma.modeloServico_id === rps.modeloServico_id)
        const selectedEPsFromModeloServico = selectedEpsProp.filter(sep => sep.modeloServico_id === rps.modeloServico_id)
        const selectedProdsPropFromModeloServico = selectedProdsProp.filter(sep => sep.modeloServico_id === rps.modeloServico_id)

        const macroatividadesByModeloServico = await getMacroatividadesByModeloServicoIdForModeloProposta(rps.modeloServico_id, rps.relacaoPropServico_id);
        for (let i = 0; i < macroatividadesByModeloServico.length; i++) {
          const rsm = macroatividadesByModeloServico[i];
          selectedMacroatividadesCopy.push(rsm);
        }

        const epsPropByModeloServicoId = await getEPsPropByModeloServicoIdForModeloProposta(rps.modeloServico_id, rps.relacaoPropServico_id);
        for (let i = 0; i < epsPropByModeloServicoId.length; i++) {
          const rsep = epsPropByModeloServicoId[i];
          selectedEpsPropCopy.push(rsep);
        }

        const prodsPropByModeloServicoId = await getProdsPropByModeloServicoIdForModeloProposta(rps.modeloServico_id, rps.relacaoPropServico_id);
        for (let i = 0; i < prodsPropByModeloServicoId.length; i++) {
          const rspp = prodsPropByModeloServicoId[i];
          selectedProdPropCopy.push(rspp);
        }
      }
    }
    setSelectedMacroatividades([...selectedMacroatividadesCopy]);
    setSelectedEpsProp([...selectedEpsPropCopy]);
    setSelectedProdsProp([...selectedProdPropCopy]);
    const modeloServicoPrincipalArr = res.data.filter(rps => Number(rps.relacaoPropServico_servicoPrincipal) !== 0).map(rps => { return {modeloServico_id: rps.modeloServico_id, modeloServico_primario: true, relacaoPropServico_id: rps.relacaoPropServico_id}});
    const modelosServicosSecundariosArr = res.data.filter(rps => Number(rps.relacaoPropServico_servicoPrincipal) !== 1).map(rps => { return {modeloServico_id: rps.modeloServico_id, modeloServico_secundario: true, relacaoPropServico_id: rps.relacaoPropServico_id}});

    return [...modeloServicoPrincipalArr, ...modelosServicosSecundariosArr];
  }

  const getEntidadesDosModelosByComposicaoModeloServicoId = async (composicaoModeloServicoId) => {

    setIsLoadingSelected(true);
    await Promise.all([
      getMacroatividadeByComposicaoServicoId(composicaoModeloServicoId),
      getProdPropByComposicaoServicoId(composicaoModeloServicoId),
      getEPsPropByComposicaoServicoId(composicaoModeloServicoId),
    ]);
    setIsLoadingSelected(false);
  };

  const getModelosServicosIdByComposicaoServicosModelosId = async (composicaoModeloServicoId) => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoComposicaoModeloServicoModeloServico',
        data: {
          composicaoModeloServico_id: composicaoModeloServicoId
        }
      })}`
    )
    return res.data
  }

  const getMacroatividadeByComposicaoServicoId = async (composicaoModeloServicoId) => {

    const resRelacaoComposicaoModeloServicoModeloServico = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoComposicaoModeloServicoModeloServico',
        data: {
          composicaoModeloServico_id: composicaoModeloServicoId,
        }
      })}`
    )

    const all = [];

    for (let index = 0; index < resRelacaoComposicaoModeloServicoModeloServico.data.length; index++) {
      const element = resRelacaoComposicaoModeloServicoModeloServico.data[index];

      const macroatividadesByModeloServico = await getMacroatividadesByModeloServicoId(element.modeloServico_id);
      all.push(...macroatividadesByModeloServico);


      /* if (selectedMacroatividades.length > 0) {

        for (let i = 0; i < macroatividadesByModeloServico.length; i++) {
          const rsm = macroatividadesByModeloServico[i];
          if (selectedMacroatividades.find(sm => sm.macroatividade_id === rsm.macroatividade_id)) {
            continue;
          } else {
          }
        }
      } else {
        setSelectedMacroatividades(prevState => [...prevState, ...macroatividadesByModeloServico]);
      } */
    }
    setSelectedMacroatividades(all);
  }

  const getProdPropByComposicaoServicoId = async (composicaoModeloServicoId) => {
    const resRelacaoComposicaoModeloServicoModeloServico = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoComposicaoModeloServicoModeloServico',
        data: {
          composicaoModeloServico_id: composicaoModeloServicoId,
        }
      })}`
    )

    const all = [];

    for (let index = 0; index < resRelacaoComposicaoModeloServicoModeloServico.data.length; index++) {
      const element = resRelacaoComposicaoModeloServicoModeloServico.data[index];

      const prodsPropByModeloServicoId = await getProdsPropByModeloServicoId(element.modeloServico_id);
      all.push(...prodsPropByModeloServicoId);

      /* if (selectedProdsProp.length > 0) {
        const selectedProdsPropCopy = [];
        for (let i = 0; i < prodsPropByModeloServicoId.length; i++) {
          const rspp = prodsPropByModeloServicoId[i];
          if (selectedProdsProp.find(sep => sep.prodProp_id === rspp.prodProp_id)) {
            continue;
          } else {
            selectedProdsPropCopy.push(rspp);
          }
        }
        setSelectedProdsProp(prevState => [...prevState, ...selectedProdsPropCopy]);
      } else {
        setSelectedProdsProp(prevState => [...prevState, ...prodsPropByModeloServicoId]);
      } */
    }
    setSelectedProdsProp(all);
  }

  const getEPsPropByComposicaoServicoId = async (composicaoModeloServicoId) => {
    const resRelacaoComposicaoModeloServicoModeloServico = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoComposicaoModeloServicoModeloServico',
        data: {
          composicaoModeloServico_id: composicaoModeloServicoId,
        }
      })}`
    )

    const all = [];

    for (let index = 0; index < resRelacaoComposicaoModeloServicoModeloServico.data.length; index++) {
      const element = resRelacaoComposicaoModeloServicoModeloServico.data[index];

      const epsPropByModeloServicoId = await getEPsPropByModeloServicoId(element.modeloServico_id);
      all.push(...epsPropByModeloServicoId);

      /* if (selectedEpsProp.length > 0) {
        const selectedEpsPropCopy = [];
        for (let i = 0; i < epsPropByModeloServicoId.length; i++) {
          const rsep = epsPropByModeloServicoId[i];
          if (selectedEpsProp.find(sep => sep.eventoPagamentoProp_id === rsep.eventoPagamentoProp_id)) {
            continue;
          } else {
            selectedEpsPropCopy.push(rsep);
          }
        }
        setSelectedEpsProp(prevState => [...prevState, ...selectedEpsPropCopy]);
      } else {
        setSelectedEpsProp(prevState => [...prevState, ...epsPropByModeloServicoId]);
      } */
    }
    setSelectedEpsProp(all);
  }

  const getMacroatividadesByModeloServicoId = async (modeloServicoId) => {

    let res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoServicoMacroatividade',
        data: {
          modeloServico_id: modeloServicoId,
          relacaoServicoMacroatividade_ativo: 1,
        },
        fields: {
          "(SELECT macroatividade_nome FROM macroatividade WHERE macroatividade.macroatividade_id = relacaoServicoMacroatividade.macroatividade_id)": "macroatividade_nome",
          "(SELECT modeloServico_nome FROM modeloServico WHERE modeloServico.modeloServico_id = relacaoServicoMacroatividade.modeloServico_id)": "modeloServico_nome",
        }
      })}`
    )

    res = {...res, data: res.data.filter(d => !d.relacaoPropServico_id)}

    if (res.data.length > 0) {

      for (let idx = 0; idx < res.data.length; idx++) {
        const macroatividade = res.data[idx];

        const instanceId = crypto.randomUUID();

        res.data[idx] = {
          ...res.data[idx],

          // UI identity
          value: instanceId,
          instanceId,

          // Domain identity (keep numeric!)
          macroatividade_id: Number(macroatividade.macroatividade_id),

          label: macroatividade.macroatividade_nome
        };

        const resRelPropItemMacroatividade = await getPropItemsByMacroatividadeId(macroatividade.macroatividade_id, macroatividade.relacaoServicoMacroatividade_id);

        console.log('resRelPropItemMacroatividade', resRelPropItemMacroatividade);

        res.data[idx].propItens = resRelPropItemMacroatividade;

        let resRelProdPropMacroatividade = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoProdPropMacroatividade',
            data: {
              macroatividade_id: macroatividade.macroatividade_id,
              relacaoProdPropMacroatividade_ativo: 1,
              relacaoServicoMacroatividade_id: macroatividade.relacaoServicoMacroatividade_id
            }
          })}`
        )

        resRelProdPropMacroatividade = {...resRelProdPropMacroatividade, data: resRelProdPropMacroatividade.data.filter(d => d.relacaoServicoProdProp_id)}

        if (resRelProdPropMacroatividade.data.length > 0) {

          for (let index = 0; index < resRelProdPropMacroatividade.data.length; index++) {

            const relProdPropMacroatividade = resRelProdPropMacroatividade.data[index];

            let resRelServicoProdProp = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoProdProp',
                data: {
                  relacaoServicoProdProp_id: relProdPropMacroatividade.relacaoServicoProdProp_id,
                  prodProp_id: relProdPropMacroatividade.prodProp_id,
                  modeloServico_id: modeloServicoId,
                  relacaoServicoProdProp_ativo: 1
                }
              })}`
            )

            resRelServicoProdProp = {...resRelServicoProdProp, data: resRelServicoProdProp.data.filter(d => !d.relacaoPropServico_id)}

            if (resRelServicoProdProp.data.length > 0) {

              for (let index = 0; index < resRelServicoProdProp.data.length; index++) {
                const prodProp_id = resRelServicoProdProp.data[index].prodProp_id;
                res.data[idx].produtos = res.data[idx].produtos ?
                [
                  ...res.data[idx].produtos,
                  ...prodsProp.filter(m => m.prodProp_id === prodProp_id).map(p => {
                    return {
                      ...p, relacaoProdPropMacroatividade_id: relProdPropMacroatividade.relacaoProdPropMacroatividade_id
                    }
                  })
                ] :
                [
                  ...prodsProp.filter(m => m.prodProp_id === prodProp_id).map(p => {
                    return {
                      ...p, relacaoProdPropMacroatividade_id: relProdPropMacroatividade.relacaoProdPropMacroatividade_id
                    }
                  })
                ]
              }
            }
          }
        }

        let resRelEventoPagamentoPropMacroatividade = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoEventoPagamentoPropMacroatividade',
            data: {
              macroatividade_id: macroatividade.macroatividade_id,
              relacaoEventoPagamentoPropMacroatividade_ativo: 1,
              relacaoServicoMacroatividade_id: macroatividade.relacaoServicoMacroatividade_id
            },
            fields: {
              "(SELECT macroatividade_nome FROM macroatividade WHERE macroatividade.macroatividade_id = relacaoEventoPagamentoPropMacroatividade.macroatividade_id)": "macroatividade_nome",
            }
          })}`
        )

        resRelEventoPagamentoPropMacroatividade = {...resRelEventoPagamentoPropMacroatividade, data: resRelEventoPagamentoPropMacroatividade.data.filter(d => d.relacaoServicoEventoPagamentoProp_id)}

        if (resRelEventoPagamentoPropMacroatividade.data.length > 0) {
          for (let index = 0; index < resRelEventoPagamentoPropMacroatividade.data.length; index++) {
            const relEventoPagamentoPropMacroatividade = resRelEventoPagamentoPropMacroatividade.data[index];

            const resRelServicoEventosPagamentoProp = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoEventoPagamentoProp',
                data: {
                  eventoPagamentoProp_id: relEventoPagamentoPropMacroatividade.eventoPagamentoProp_id,
                  modeloServico_id: modeloServicoId
                }
              })}`
            )

            if (resRelServicoEventosPagamentoProp.data.length > 0) {
              for (let index = 0; index < resRelServicoEventosPagamentoProp.data.length; index++) {
                const eventoPagamentoProp_id = resRelServicoEventosPagamentoProp.data[index].eventoPagamentoProp_id;
                res.data[idx].eventosPagamento = res.data[idx].eventosPagamento ? [...res.data[idx].eventosPagamento, ...eventosPagamentoProp.filter(m => m.eventoPagamentoProp_id === eventoPagamentoProp_id).map(ep => { return {...ep, relacaoEventoPagamentoPropMacroatividade_id: relEventoPagamentoPropMacroatividade.relacaoEventoPagamentoPropMacroatividade_id}})] : [...eventosPagamentoProp.filter(m => m.eventoPagamentoProp_id === eventoPagamentoProp_id).map(ep => { return {...ep, relacaoEventoPagamentoPropMacroatividade_id: relEventoPagamentoPropMacroatividade.relacaoEventoPagamentoPropMacroatividade_id}})]
              }
            }
          }
        }
      }
    }

    return res.data;
  }

  const getMacroatividadesByModeloServicoIdForModeloProposta = async (modeloServicoId, relacaoModeloPropostaId) => {

    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoServicoMacroatividade',
        data: {
          modeloServico_id: modeloServicoId,
          relacaoServicoMacroatividade_ativo: 1,
          relacaoPropServico_id: relacaoModeloPropostaId
        },
        fields: {
          "(SELECT macroatividade_nome FROM macroatividade WHERE macroatividade.macroatividade_id = relacaoServicoMacroatividade.macroatividade_id)": "macroatividade_nome",
          "(SELECT modeloServico_nome FROM modeloServico WHERE modeloServico.modeloServico_id = relacaoServicoMacroatividade.modeloServico_id)": "modeloServico_nome",
        }
      })}`
    )

    if (res.data.length > 0) {

      for (let idx = 0; idx < res.data.length; idx++) {
        const macroatividade = res.data[idx];

        res.data[idx].value = macroatividade.macroatividade_id;
        res.data[idx].label = macroatividade.macroatividade_nome;

        const resRelPropItemMacroatividade = await getPropItemsByMacroatividadeId(macroatividade.macroatividade_id, macroatividade.relacaoServicoMacroatividade_id);

        res.data[idx].propItens = resRelPropItemMacroatividade;



        const resRelProdPropMacroatividade = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoProdPropMacroatividade',
            data: {
              macroatividade_id: macroatividade.macroatividade_id,
              relacaoServicoMacroatividade_id: macroatividade.relacaoServicoMacroatividade_id,
              relacaoProdPropMacroatividade_ativo: 1,
            }
          })}`
        )

        if (resRelProdPropMacroatividade.data.length > 0) {

          for (let index = 0; index < resRelProdPropMacroatividade.data.length; index++) {

            const relProdPropMacroatividade = resRelProdPropMacroatividade.data[index];

            const resRelServicoProdProp = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoProdProp',
                data: {
                  prodProp_id: relProdPropMacroatividade.prodProp_id,
                  modeloServico_id: modeloServicoId
                }
              })}`
            )

            if (resRelServicoProdProp.data.length > 0) {

              for (let index = 0; index < resRelServicoProdProp.data.length; index++) {
                const prodProp_id = resRelServicoProdProp.data[index].prodProp_id;
                res.data[idx].produtos = res.data[idx].produtos ? [...res.data[idx].produtos, ...prodsProp.filter(m => m.prodProp_id === prodProp_id).map(p => { return {...p, relacaoProdPropMacroatividade_id: relProdPropMacroatividade.relacaoProdPropMacroatividade_id}})] : [...prodsProp.filter(m => m.prodProp_id === prodProp_id).map(p => { return {...p, relacaoProdPropMacroatividade_id: relProdPropMacroatividade.relacaoProdPropMacroatividade_id}})]
              }
            }
          }
        }

        const resRelEventoPagamentoPropMacroatividade = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoEventoPagamentoPropMacroatividade',
            data: {
              macroatividade_id: macroatividade.macroatividade_id,
              relacaoServicoMacroatividade_id: macroatividade.relacaoServicoMacroatividade_id,
              relacaoEventoPagamentoPropMacroatividade_ativo: 1,
            },
            fields: {
              "(SELECT macroatividade_nome FROM macroatividade WHERE macroatividade.macroatividade_id = relacaoEventoPagamentoPropMacroatividade.macroatividade_id)": "macroatividade_nome",
            }
          })}`
        )

        if (resRelEventoPagamentoPropMacroatividade.data.length > 0) {
          for (let index = 0; index < resRelEventoPagamentoPropMacroatividade.data.length; index++) {
            const relEventoPagamentoPropMacroatividade = resRelEventoPagamentoPropMacroatividade.data[index];

            const resRelServicoEventosPagamentoProp = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoEventoPagamentoProp',
                data: {
                  eventoPagamentoProp_id: relEventoPagamentoPropMacroatividade.eventoPagamentoProp_id,
                  modeloServico_id: modeloServicoId
                }
              })}`
            )

            if (resRelServicoEventosPagamentoProp.data.length > 0) {
              for (let index = 0; index < resRelServicoEventosPagamentoProp.data.length; index++) {
                const eventoPagamentoProp_id = resRelServicoEventosPagamentoProp.data[index].eventoPagamentoProp_id;
                res.data[idx].eventosPagamento = res.data[idx].eventosPagamento ? [...res.data[idx].eventosPagamento, ...eventosPagamentoProp.filter(m => m.eventoPagamentoProp_id === eventoPagamentoProp_id).map(ep => { return {...ep, relacaoEventoPagamentoPropMacroatividade_id: relEventoPagamentoPropMacroatividade.relacaoEventoPagamentoPropMacroatividade_id}})] : [...eventosPagamentoProp.filter(m => m.eventoPagamentoProp_id === eventoPagamentoProp_id).map(ep => { return {...ep, relacaoEventoPagamentoPropMacroatividade_id: relEventoPagamentoPropMacroatividade.relacaoEventoPagamentoPropMacroatividade_id}})]
              }
            }
          }
        }
      }
    }

    return res.data;
  }

  const getEPsPropByModeloServicoId = async (modeloServicoId) => {
    let res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoServicoEventoPagamentoProp',
        data: {
          relacaoServicoEventoPagamentoProp_ativo: 1,
          modeloServico_id: modeloServicoId,
        },
        fields: {
          "(SELECT modeloServico_nome FROM modeloServico WHERE modeloServico.modeloServico_id = relacaoServicoEventoPagamentoProp.modeloServico_id)": "modeloServico_nome",
          "(SELECT eventoPagamentoProp_nome FROM eventoPagamentoProp WHERE eventoPagamentoProp.eventoPagamentoProp_id = relacaoServicoEventoPagamentoProp.eventoPagamentoProp_id)": "eventoPagamentoProp_nome",
        }
      })}`
    )

    res = {...res, data: res.data.filter(d => !d.relacaoPropServico_id)}

    if (res.data.length > 0) {

      for (let idx = 0; idx < res.data.length; idx++) {
        const eventoPagamentoProp = res.data[idx];
        const instanceId = crypto.randomUUID();

        res.data[idx] = {
          ...res.data[idx],

          // UI identity
          value: instanceId,
          instanceId,

          // Domain identity (keep numeric!)
          eventoPagamentoProp_id: Number(eventoPagamentoProp.eventoPagamentoProp_id),

          label: eventoPagamentoProp.eventoPagamentoProp_nome
        };
        let resRelEventoPagamentoPropMacroatividade = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoEventoPagamentoPropMacroatividade',
            data: {
              eventoPagamentoProp_id: eventoPagamentoProp.eventoPagamentoProp_id,
              relacaoEventoPagamentoPropMacroatividade_ativo: 1,
              relacaoServicoEventoPagamentoProp_id: eventoPagamentoProp.relacaoServicoEventoPagamentoProp_id,
            }
          })}`
        )

        resRelEventoPagamentoPropMacroatividade = {...resRelEventoPagamentoPropMacroatividade, data: resRelEventoPagamentoPropMacroatividade.data.filter(d => d.relacaoServicoMacroatividade_id)}

        if (resRelEventoPagamentoPropMacroatividade.data.length > 0) {

          for (let index = 0; index < resRelEventoPagamentoPropMacroatividade.data.length; index++) {

            const relEventoPagamentoPropMacroatividade = resRelEventoPagamentoPropMacroatividade.data[index];

            let resRelServicoMacroatividade = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoMacroatividade',
                data: {
                  relacaoServicoMacroatividade_id: relEventoPagamentoPropMacroatividade.relacaoServicoMacroatividade_id,
                  macroatividade_id: relEventoPagamentoPropMacroatividade.macroatividade_id,
                  modeloServico_id: modeloServicoId,
                  relacaoServicoMacroatividade_ativo: 1
                }
              })}`
            )

            resRelServicoMacroatividade = {...resRelServicoMacroatividade, data: resRelServicoMacroatividade.data.filter(d => !d.relacaoPropServico_id)}

            if (resRelServicoMacroatividade.data.length > 0) {

              for (let index = 0; index < resRelServicoMacroatividade.data.length; index++) {
                const macroatividade_id = resRelServicoMacroatividade.data[index].macroatividade_id;
                res.data[idx].macroatividades = res.data[idx].macroatividades ? [...res.data[idx].macroatividades, ...macroatividades.filter(m => m.macroatividade_id === macroatividade_id).map(m => { return {...m, relacaoEventoPagamentoPropMacroatividade_id: relEventoPagamentoPropMacroatividade.relacaoEventoPagamentoPropMacroatividade_id}})] : [...macroatividades.filter(m => m.macroatividade_id === macroatividade_id).map(m => { return {...m, relacaoEventoPagamentoPropMacroatividade_id: relEventoPagamentoPropMacroatividade.relacaoEventoPagamentoPropMacroatividade_id}})]
              }
            }
          }
        }

        let resRelProdPropEventoPagamentoProp = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoProdPropEventoPagamentoProp',
            data: {
              eventoPagamentoProp_id: eventoPagamentoProp.eventoPagamentoProp_id,
              relacaoServicoEventoPagamentoProp_id: eventoPagamentoProp.relacaoServicoEventoPagamentoProp_id,
              relacaoProdPropEventoPagamentoProp_ativo: 1
            },
            fields: {
              "(SELECT eventoPagamentoProp_nome FROM eventoPagamentoProp WHERE eventoPagamentoProp.eventoPagamentoProp_id = relacaoProdPropEventoPagamentoProp.eventoPagamentoProp_id)": "eventoPagamentoProp_nome",
              "(SELECT prodProp_nome FROM prodProp WHERE prodProp.prodProp_id = relacaoProdPropEventoPagamentoProp.prodProp_id)": "prodProp_nome",
            }
          })}`
        )

        resRelProdPropEventoPagamentoProp = {...resRelProdPropEventoPagamentoProp, data: resRelProdPropEventoPagamentoProp.data.filter(d => d.relacaoServicoProdProp_id)}

        if (resRelProdPropEventoPagamentoProp.data.length > 0) {
          for (let index = 0; index < resRelProdPropEventoPagamentoProp.data.length; index++) {
            const relProdPropEventoPagamentoProp = resRelProdPropEventoPagamentoProp.data[index];

            const resRelServicoProdProp = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoProdProp',
                data: {
                  prodProp_id: relProdPropEventoPagamentoProp.prodProp_id,
                  modeloServico_id: modeloServicoId
                }
              })}`
            )

            if (resRelServicoProdProp.data.length > 0) {
              for (let index = 0; index < resRelServicoProdProp.data.length; index++) {
                const prodProp_id = resRelServicoProdProp.data[index].prodProp_id;
                res.data[idx].produtos = res.data[idx].produtos ? [...res.data[idx].produtos, ...prodsProp.filter(m => m.prodProp_id === prodProp_id).map(p => { return {...p, relacaoProdPropEventoPagamentoProp_id: relProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id}})] : [...prodsProp.filter(m => m.prodProp_id === prodProp_id).map(p => { return {...p, relacaoProdPropEventoPagamentoProp_id: relProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id}})]
              }
            }
          }
        }
      }
    }

    return res.data;
  }

  const getEPsPropByModeloServicoIdForModeloProposta = async (modeloServicoId, relacaoModeloPropostaId) => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoServicoEventoPagamentoProp',
        data: {
          modeloServico_id: modeloServicoId,
          relacaoServicoEventoPagamentoProp_ativo: 1,
          relacaoPropServico_id: relacaoModeloPropostaId
        },
        fields: {
          "(SELECT modeloServico_nome FROM modeloServico WHERE modeloServico.modeloServico_id = relacaoServicoEventoPagamentoProp.modeloServico_id)": "modeloServico_nome",
          "(SELECT eventoPagamentoProp_nome FROM eventoPagamentoProp WHERE eventoPagamentoProp.eventoPagamentoProp_id = relacaoServicoEventoPagamentoProp.eventoPagamentoProp_id)": "eventoPagamentoProp_nome",
        }
      })}`
    )


    if (res.data.length > 0) {

      for (let idx = 0; idx < res.data.length; idx++) {
        const eventoPagamentoProp = res.data[idx];
        res.data[idx].value = eventoPagamentoProp.eventoPagamentoProp_id;
        res.data[idx].label = eventoPagamentoProp.eventoPagamentoProp_nome;
        const resRelEventoPagamentoPropMacroatividade = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoEventoPagamentoPropMacroatividade',
            data: {
              eventoPagamentoProp_id: eventoPagamentoProp.eventoPagamentoProp_id,
              relacaoEventoPagamentoPropMacroatividade_ativo: 1,
              relacaoServicoEventoPagamentoProp_id: eventoPagamentoProp.relacaoServicoEventoPagamentoProp_id,
            }
          })}`
        )

        if (resRelEventoPagamentoPropMacroatividade.data.length > 0) {

          for (let index = 0; index < resRelEventoPagamentoPropMacroatividade.data.length; index++) {

            const relEventoPagamentoPropMacroatividade = resRelEventoPagamentoPropMacroatividade.data[index];

            const resRelServicoMacroatividades = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoMacroatividade',
                data: {
                  macroatividade_id: relEventoPagamentoPropMacroatividade.macroatividade_id,
                  modeloServico_id: modeloServicoId,
                  relacaoServicoMacroatividade_ativo: 1
                }
              })}`
            )

            if (resRelServicoMacroatividades.data.length > 0) {

              for (let index = 0; index < resRelServicoMacroatividades.data.length; index++) {
                const macroatividade_id = resRelServicoMacroatividades.data[index].macroatividade_id;
                res.data[idx].macroatividades = res.data[idx].macroatividades ? [...res.data[idx].macroatividades, ...macroatividades.filter(m => m.macroatividade_id === macroatividade_id).map(m => { return {...m, relacaoEventoPagamentoPropMacroatividade_id: relEventoPagamentoPropMacroatividade.relacaoEventoPagamentoPropMacroatividade_id}})] : [...macroatividades.filter(m => m.macroatividade_id === macroatividade_id).map(m => { return {...m, relacaoEventoPagamentoPropMacroatividade_id: relEventoPagamentoPropMacroatividade.relacaoEventoPagamentoPropMacroatividade_id}})]
              }
            }
          }
        }

        const resRelProdPropEventoPagamentoProp = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoProdPropEventoPagamentoProp',
            data: {
              eventoPagamentoProp_id: eventoPagamentoProp.eventoPagamentoProp_id,
              relacaoProdPropEventoPagamentoProp_ativo: 1
            },
            fields: {
              "(SELECT eventoPagamentoProp_nome FROM eventoPagamentoProp WHERE eventoPagamentoProp.eventoPagamentoProp_id = relacaoProdPropEventoPagamentoProp.eventoPagamentoProp_id)": "eventoPagamentoProp_nome",
            }
          })}`
        )

        if (resRelProdPropEventoPagamentoProp.data.length > 0) {
          for (let index = 0; index < resRelProdPropEventoPagamentoProp.data.length; index++) {
            const relProdPropEventoPagamentoProp = resRelProdPropEventoPagamentoProp.data[index];

            const resRelServicoProdProp = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoProdProp',
                data: {
                  prodProp_id: relProdPropEventoPagamentoProp.prodProp_id,
                  modeloServico_id: modeloServicoId
                }
              })}`
            )

            if (resRelServicoProdProp.data.length > 0) {
              for (let index = 0; index < resRelServicoProdProp.data.length; index++) {
                const prodProp_id = resRelServicoProdProp.data[index].prodProp_id;
                res.data[idx].produtos = res.data[idx].produtos ? [...res.data[idx].produtos, ...prodsProp.filter(m => m.prodProp_id === prodProp_id).map(p => { return {...p, relacaoProdPropEventoPagamentoProp_id: relProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id}})] : [...prodsProp.filter(m => m.prodProp_id === prodProp_id).map(p => { return {...p, relacaoProdPropEventoPagamentoProp_id: relProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id}})]
              }
            }
          }
        }
      }
    }

    return res.data;
  }

  const getProdsPropByModeloServicoId = async (modeloServicoId) => {

    let resProd = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoServicoProdProp',
        data: {
          modeloServico_id: modeloServicoId,
          relacaoServicoProdProp_ativo: 1,
        },
        fields: {
          "(SELECT modeloServico_nome FROM modeloServico WHERE modeloServico.modeloServico_id = relacaoServicoProdProp.modeloServico_id)": "modeloServico_nome",
          "(SELECT prodProp_nome FROM prodProp WHERE prodProp.prodProp_id = relacaoServicoProdProp.prodProp_id)": "prodProp_nome",
        }
      })}`
    )

    resProd = {...resProd, data: resProd.data.filter(d => !d.relacaoPropServico_id)}


    if (resProd.data.length > 0) {

      for (let idx = 0; idx < resProd.data.length; idx++) {
        const prodProp = resProd.data[idx];

        const instanceId = crypto.randomUUID();

        resProd.data[idx] = {
          ...resProd.data[idx],

          // UI identity
          value: instanceId,
          instanceId,

          // Domain identity (keep numeric!)
          prodProp_id: Number(prodProp.prodProp_id),

          label: prodProp.prodProp_nome
        };

        let resProdRelProdPropMacroatividade = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoProdPropMacroatividade',
            data: {
              prodProp_id: prodProp.prodProp_id,
              relacaoProdPropMacroatividade_ativo: 1,
              relacaoServicoProdProp_id: prodProp.relacaoServicoProdProp_id,
            }
          })}`
        )

        resProdRelProdPropMacroatividade = {
          ...resProdRelProdPropMacroatividade,
          data: resProdRelProdPropMacroatividade.data.filter(d => d.relacaoServicoMacroatividade_id)
        }

        if (resProdRelProdPropMacroatividade.data.length > 0) {

          for (let index = 0; index < resProdRelProdPropMacroatividade.data.length; index++) {

            const relProdPropMacroatividade = resProdRelProdPropMacroatividade.data[index];

            let resRelServicoMacroatividade = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoMacroatividade',
                data: {
                  relacaoServicoMacroatividade_id: relProdPropMacroatividade.relacaoServicoMacroatividade_id,
                  macroatividade_id: relProdPropMacroatividade.macroatividade_id,
                  modeloServico_id: modeloServicoId,
                  relacaoServicoMacroatividade_ativo: 1
                }
              })}`
            )

            resRelServicoMacroatividade = {...resRelServicoMacroatividade, data: resRelServicoMacroatividade.data.filter(d => !d.relacaoPropServico_id)}

            if (resRelServicoMacroatividade.data.length > 0) {

              for (let index = 0; index < resRelServicoMacroatividade.data.length; index++) {
                const macroatividade_id = resRelServicoMacroatividade.data[index].macroatividade_id;
                resProd.data[idx].macroatividades = resProd.data[idx].macroatividades ?
                  [
                    ...resProd.data[idx].macroatividades,
                    ...macroatividades.filter(m => m.macroatividade_id === macroatividade_id).map(m => {
                      return {...m, relacaoProdPropMacroatividade_id: relProdPropMacroatividade.relacaoProdPropMacroatividade_id}
                    })
                  ] :
                  [
                    ...macroatividades.filter(m => m.macroatividade_id === macroatividade_id).map(m => {
                      return {...m, relacaoProdPropMacroatividade_id: relProdPropMacroatividade.relacaoProdPropMacroatividade_id}
                    })
                  ]
              }
            }
          }
        }

        let resRelProdPropEventoPagamentoProp = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoProdPropEventoPagamentoProp',
            data: {
              prodProp_id: prodProp.prodProp_id,
              relacaoServicoProdProp_id: prodProp.relacaoServicoProdProp_id,
              relacaoProdPropEventoPagamentoProp_ativo: 1
            },
            fields: {
              "(SELECT eventoPagamentoProp_nome FROM eventoPagamentoProp WHERE eventoPagamentoProp.eventoPagamentoProp_id = relacaoProdPropEventoPagamentoProp.eventoPagamentoProp_id)": "eventoPagamentoProp_nome",
              "(SELECT prodProp_nome FROM prodProp WHERE prodProp.prodProp_id = relacaoProdPropEventoPagamentoProp.prodProp_id)": "prodProp_nome",
            }
          })}`
        )

        resRelProdPropEventoPagamentoProp = {...resRelProdPropEventoPagamentoProp, data: resRelProdPropEventoPagamentoProp.data.filter(d => d.relacaoServicoEventoPagamentoProp_id)}

        if (resRelProdPropEventoPagamentoProp.data.length > 0) {
          for (let index = 0; index < resRelProdPropEventoPagamentoProp.data.length; index++) {
            const relProdPropEventoPagamentoProp = resRelProdPropEventoPagamentoProp.data[index];

            const resRelServicoEventosPagamentoProp = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoEventoPagamentoProp',
                data: {
                  eventoPagamentoProp_id: relProdPropEventoPagamentoProp.eventoPagamentoProp_id,
                  modeloServico_id: modeloServicoId,
                }
              })}`
            )

            if (resRelServicoEventosPagamentoProp.data.length > 0) {
              for (let index = 0; index < resRelServicoEventosPagamentoProp.data.length; index++) {
                const eventoPagamentoProp_id = resRelServicoEventosPagamentoProp.data[index].eventoPagamentoProp_id;
                resProd.data[idx].eventosPagamento = resProd.data[idx].eventosPagamento ?
                  [
                    ...resProd.data[idx].eventosPagamento,
                    ...eventosPagamentoProp.filter(m => m.eventoPagamentoProp_id === eventoPagamentoProp_id).map(ep => {
                      return {...ep, relacaoProdPropEventoPagamentoProp_id: relProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id}
                    })
                  ] : [
                    ...eventosPagamentoProp.filter(m => m.eventoPagamentoProp_id === eventoPagamentoProp_id).map(ep => {
                      return {...ep, relacaoProdPropEventoPagamentoProp_id: relProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id}
                    })
                  ]
              }
            }
          }
        }
      }
    }

    return resProd.data;
  }

  const getProdsPropByModeloServicoIdForModeloProposta = async (modeloServicoId, relacaoModeloPropostaId) => {

    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoServicoProdProp',
        data: {
          modeloServico_id: modeloServicoId,
          relacaoServicoProdProp_ativo: 1,
          relacaoPropServico_id: relacaoModeloPropostaId
        },
        fields: {
          "(SELECT modeloServico_nome FROM modeloServico WHERE modeloServico.modeloServico_id = relacaoServicoProdProp.modeloServico_id)": "modeloServico_nome",
          "(SELECT prodProp_nome FROM prodProp WHERE prodProp.prodProp_id = relacaoServicoProdProp.prodProp_id)": "prodProp_nome",
        }
      })}`
    )

    if (res.data.length > 0) {

      for (let idx = 0; idx < res.data.length; idx++) {
        const prodProp = res.data[idx];
        res.data[idx].value = prodProp.prodProp_id;
        res.data[idx].label = prodProp.prodProp_nome;

        const resRelProdPropMacroatividade = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoProdPropMacroatividade',
            data: {
              prodProp_id: prodProp.prodProp_id,
              relacaoProdPropMacroatividade_ativo: 1,
            }
          })}`
        )

        if (resRelProdPropMacroatividade.data.length > 0) {

          for (let index = 0; index < resRelProdPropMacroatividade.data.length; index++) {

            const relProdPropMacroatividade = resRelProdPropMacroatividade.data[index];

            const resRelServicoMacroatividades = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoMacroatividade',
                data: {
                  macroatividade_id: relProdPropMacroatividade.macroatividade_id,
                  modeloServico_id: modeloServicoId,
                  relacaoServicoMacroatividade_ativo: 1
                }
              })}`
            )

            if (resRelServicoMacroatividades.data.length > 0) {

              for (let index = 0; index < resRelServicoMacroatividades.data.length; index++) {
                const macroatividade_id = resRelServicoMacroatividades.data[index].macroatividade_id;
                res.data[idx].macroatividades = res.data[idx].macroatividades ? [...res.data[idx].macroatividades, ...macroatividades.filter(m => m.macroatividade_id === macroatividade_id).map(m => { return {...m, relacaoProdPropMacroatividade_id: relProdPropMacroatividade.relacaoProdPropMacroatividade_id}})] : [...macroatividades.filter(m => m.macroatividade_id === macroatividade_id).map(m => { return {...m, relacaoProdPropMacroatividade_id: relProdPropMacroatividade.relacaoProdPropMacroatividade_id}})]
              }
            }
          }
        }

        const resRelProdPropEventoPagamentoProp = await oikosApi.get(
          `/?${qs.stringify({
            action: 'get',
            table: 'relacaoProdPropEventoPagamentoProp',
            data: {
              prodProp_id: prodProp.prodProp_id,
              relacaoProdPropEventoPagamentoProp_ativo: 1
            },
            fields: {
              "(SELECT eventoPagamentoProp_nome FROM eventoPagamentoProp WHERE eventoPagamentoProp.eventoPagamentoProp_id = relacaoProdPropEventoPagamentoProp.eventoPagamentoProp_id)": "eventoPagamentoProp_nome",
            }
          })}`
        )

        if (resRelProdPropEventoPagamentoProp.data.length > 0) {
          for (let index = 0; index < resRelProdPropEventoPagamentoProp.data.length; index++) {
            const relProdPropEventoPagamentoProp = resRelProdPropEventoPagamentoProp.data[index];

            const resRelServicoEventosPagamentoProp = await oikosApi.get(
              `/?${qs.stringify({
                action: 'get',
                table: 'relacaoServicoEventoPagamentoProp',
                data: {
                  eventoPagamentoProp_id: relProdPropEventoPagamentoProp.eventoPagamentoProp_id,
                  modeloServico_id: modeloServicoId
                }
              })}`
            )

            if (resRelServicoEventosPagamentoProp.data.length > 0) {
              for (let index = 0; index < resRelServicoEventosPagamentoProp.data.length; index++) {
                const eventoPagamentoProp_id = resRelServicoEventosPagamentoProp.data[index].eventoPagamentoProp_id;
                res.data[idx].eventosPagamento = res.data[idx].eventosPagamento ? [...res.data[idx].eventosPagamento, ...eventosPagamentoProp.filter(m => m.eventoPagamentoProp_id === eventoPagamentoProp_id).map(ep => { return {...ep, relacaoProdPropEventoPagamentoProp_id: relProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id}})] : [...eventosPagamentoProp.filter(m => m.eventoPagamentoProp_id === eventoPagamentoProp_id).map(ep => { return {...ep, relacaoProdPropEventoPagamentoProp_id: relProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id}})]
              }
            }
          }
        }
      }
    }

    return res.data;
  }

  const handleSaveModeloServico = async () => {
    setIsSubmitEntityLoading(true);

    if(!modeloServicoData.modeloServico_nome) {
      setIsSubmitEntityLoading(false);
      return notifyError('Adicione um nome ao modelo de serviço');
    }
    if(!modeloServicoData.servico?.servico_id) {
      setIsSubmitEntityLoading(false);
      return notifyError('Adicione um serviço ao modelo de serviço');
    }
    if(!modeloServicoData.modeloServico_prazoFim) {
      setIsSubmitEntityLoading(false);
      return notifyError('Adicione um prazo final ao modelo de serviço');
    }
    if(!modeloServicoData.modeloServico_prazoInicio && Number(modeloServicoData.modeloServico_prazoInicio) !== 0) {
      setIsSubmitEntityLoading(false);
      return notifyError('Adicione um prazo inicial ao modelo de serviço');
    }

    let resPostModeloServico = null

    const relacoesServicoMacroatividadeOnDataBase = [];
    const relacoesServicoProdsPropOnDataBase = [];
    const relacoesServicoEventosPagamentoPropOnDataBase = [];

    if (!modeloServicoData.modeloServico_id) {
      resPostModeloServico = await oikosApi.post(
        '/',
        {
          action: 'insert',
          table: 'modeloServico',
          data: {
            servico_id: modeloServicoData.servico.value,
            modeloServico_nome: modeloServicoData.modeloServico_nome,
            modeloServico_prazoInicio: modeloServicoData.modeloServico_prazoInicio,
            modeloServico_prazoFim: modeloServicoData.modeloServico_prazoFim,
          }
        }
      )

      if (modeloServicoData.macroatividades?.length > 0) {
        for (let index = 0; index < modeloServicoData.macroatividades.length; index++) {
          const element = modeloServicoData.macroatividades[index];
          const propItens = [];

          const resPostModeloServicoMacroatividade = await oikosApi.post(
            '/',
            {
              action: 'insert',
              table: 'relacaoServicoMacroatividade',
              data: {
                servico_id: modeloServicoData.servico.value,
                modeloServico_id: resPostModeloServico.data[0].modeloServico_id,
                macroatividade_id: element.macroatividade_id,
                relacaoServicoMacroatividade_tempoEstimadoExecucaoDias: element.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias
              }
            }
          )

          if (element.propItens?.length) {
            for (let index = 0; index < element.propItens.length; index++) {
              const propItem = element.propItens[index];

              const resPostMacroatividadePropItem = await oikosApi.post(
                '/',
                {
                  action: 'insert',
                  table: 'relacaoMacroatividadePropItem',
                  data: {
                    propItem_id: propItem.propItem_id,
                    macroatividade_id: element.macroatividade_id,
                    relacaoServicoMacroatividade_id: resPostModeloServicoMacroatividade.data[0].relacaoServicoMacroatividade_id,
                    relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: propItem.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias,
                    relacaoMacroatividadePropItem_propItemQtd: propItem.relacaoMacroatividadePropItem_propItemQtd
                  }
                }
              )

              propItens.push(resPostMacroatividadePropItem.data[0])
            }
          }

          relacoesServicoMacroatividadeOnDataBase.push({_uiKey: element.value, ...resPostModeloServicoMacroatividade.data[0]});
        }
      }

      if (modeloServicoData.produtos?.length > 0) {
        for (let index = 0; index < modeloServicoData.produtos.length; index++) {
          const element = modeloServicoData.produtos[index];

          const resPostModeloServicoProdProp = await oikosApi.post(
            '/',
            {
              action: 'insert',
              table: 'relacaoServicoProdProp',
              data: {
                servico_id: modeloServicoData.servico.value,
                modeloServico_id: resPostModeloServico.data[0].modeloServico_id,
                prodProp_id: element.prodProp_id,
              }
            }
          )

          relacoesServicoProdsPropOnDataBase.push(resPostModeloServicoProdProp.data[0]);
        }
      }

      if (modeloServicoData.eventosPagamento?.length > 0) {
        for (let index = 0; index < modeloServicoData.eventosPagamento.length; index++) {
          const element = modeloServicoData.eventosPagamento[index];

          const resPostModeloServicoEventoPagamentoProp = await oikosApi.post(
            '/',
            {
              action: 'insert',
              table: 'relacaoServicoEventoPagamentoProp',
              data: {
                servico_id: modeloServicoData.servico.value,
                modeloServico_id: resPostModeloServico.data[0].modeloServico_id,
                eventoPagamentoProp_id: element.eventoPagamentoProp_id,
                relacaoServicoEventoPagamentoProp_vlr: element.relacaoServicoEventoPagamentoProp_vlr,
              }
            }
          )

          relacoesServicoEventosPagamentoPropOnDataBase.push(resPostModeloServicoEventoPagamentoProp.data[0]);
        }
      }

      if (modeloServicoData.macroatividades?.length > 0) {
        for (let index = 0; index < modeloServicoData.macroatividades.length; index++) {

          const element = modeloServicoData.macroatividades[index];
          const findedMacroatividadeOnDataBase = relacoesServicoMacroatividadeOnDataBase.find(m => m._uiKey === element.value)

          if (element.produtos && element.produtos.length > 0) {
            for (let index = 0; index < element.produtos.length; index++) {
              const elementProduto = element.produtos[index];
              const findedProdPropOnDataBase = relacoesServicoProdsPropOnDataBase.find(m => m.prodProp_id === elementProduto.prodProp_id)

              const resPostProdPropMacroatividade = await oikosApi.post(
                '/',
                {
                  action: 'insert',
                  table: 'relacaoProdPropMacroatividade',
                  data: {
                    prodProp_id: elementProduto.prodProp_id,
                    macroatividade_id: element.macroatividade_id,
                    relacaoServicoProdProp_id: findedProdPropOnDataBase.relacaoServicoProdProp_id,
                    relacaoServicoMacroatividade_id: findedMacroatividadeOnDataBase.relacaoServicoMacroatividade_id,
                  }
                }
              )
            }
          }

          if (element.eventosPagamento && element.eventosPagamento.length > 0) {
            for (let index = 0; index < element.eventosPagamento.length; index++) {
              const elementEventoPagamento = element.eventosPagamento[index];
              const findedEventoPagamentoPropOnDataBase = relacoesServicoEventosPagamentoPropOnDataBase.find(m => m.eventoPagamentoProp_id === elementEventoPagamento.eventoPagamentoProp_id)

              const resPostEventoPagametoPropMacroatividade = await oikosApi.post(
                '/',
                {
                  action: 'insert',
                  table: 'relacaoEventoPagamentoPropMacroatividade',
                  data: {
                    eventoPagamentoProp_id: elementEventoPagamento.eventoPagamentoProp_id,
                    macroatividade_id: element.macroatividade_id,
                    relacaoServicoEventoPagamentoProp_id: findedEventoPagamentoPropOnDataBase.relacaoServicoEventoPagamentoProp_id,
                    relacaoServicoMacroatividade_id: findedMacroatividadeOnDataBase.relacaoServicoMacroatividade_id,
                  }
                }
              )
            }
          }
        }
      }

      if (modeloServicoData.produtos?.length > 0) {
        for (let index = 0; index < modeloServicoData.produtos.length; index++) {
          const element = modeloServicoData.produtos[index];
          const findedProdPropOnDataBase = relacoesServicoProdsPropOnDataBase.find(m => m.prodProp_id === element.prodProp_id)

          if (element.eventosPagamento && element.eventosPagamento.length > 0) {
            for (let index = 0; index < element.eventosPagamento.length; index++) {
              const elementEventoPagamento = element.eventosPagamento[index];
              const findedEventoPagamentoPropOnDataBase = relacoesServicoEventosPagamentoPropOnDataBase.find(m => m.eventoPagamentoProp_id === elementEventoPagamento.eventoPagamentoProp_id)

              const resPostEventoPagamentoPropProdProp = await oikosApi.post(
                '/',
                {
                  action: 'insert',
                  table: 'relacaoProdPropEventoPagamentoProp',
                  data: {
                    eventoPagamentoProp_id: elementEventoPagamento.eventoPagamentoProp_id,
                    prodProp_id: element.prodProp_id,
                    relacaoServicoEventoPagamentoProp_id: findedEventoPagamentoPropOnDataBase.relacaoServicoEventoPagamentoProp_id,
                    relacaoServicoProdProp_id: findedProdPropOnDataBase.relacaoServicoProdProp_id,
                  }
                }
              )
            }
          }
        }
      }

    } else {

      if (modeloServicoData.macroatividades?.length > 0) {
        for (let index = 0; index < modeloServicoData.macroatividades.length; index++) {
          const element = modeloServicoData.macroatividades[index];

          const resPostModeloServicoMacroatividade = await oikosApi.post(
            '/',
            {
              action: 'insert',
              table: 'relacaoServicoMacroatividade',
              data: {
                servico_id: modeloServicoData.servico.value,
                modeloServico_id: modeloServicoData.modeloServico_id,
                macroatividade_id: element.macroatividade_id,
                relacaoServicoMacroatividade_tempoEstimadoExecucaoDias: element.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias
              }
            }
          )

          setModeloServicoData({
            ...modeloServicoData,
            macroatividades:
              modeloServicoData.macroatividades.map(m => {
                if (m.macroatividade_id === element.macroatividade_id) {
                  return {...m, relacaoServicoMacroatividade_id: resPostModeloServicoMacroatividade.data[0].relacaoServicoMacroatividade_id}
                } else {
                  return m
                }
              })
          })
        }
      }

      if (modeloServicoData.produtos?.length > 0) {
        for (let index = 0; index < modeloServicoData.produtos.length; index++) {
          const element = modeloServicoData.produtos[index];

          const resPostModeloServicoProdProp = await oikosApi.post(
            '/',
            {
              action: 'insert',
              table: 'relacaoServicoProdProp',
              data: {
                servico_id: modeloServicoData.servico.value,
                modeloServico_id: modeloServicoData.modeloServico_id,
                prodProp_id: element.prodProp_id,
              }
            }
          )

          setModeloServicoData({
            ...modeloServicoData,
            produtos:
              modeloServicoData.produtos.map(m => {
                if (m.prodProp_id === element.prodProp_id) {
                  return {...m, relacaoServicoProdProp_id: resPostModeloServicoProdProp.data[0].relacaoServicoProdProp_id}
                } else {
                  return m
                }
              })
          })
        }
      }

      if (modeloServicoData.eventosPagamento?.length > 0) {
        for (let index = 0; index < modeloServicoData.eventosPagamento.length; index++) {
          const element = modeloServicoData.eventosPagamento[index];

          const resPostModeloServicoEventoPagamentoProp = await oikosApi.post(
            '/',
            {
              action: 'insert',
              table: 'relacaoServicoEventoPagamentoProp',
              data: {
                servico_id: modeloServicoData.servico.value,
                modeloServico_id: modeloServicoData.modeloServico_id,
                eventoPagamentoProp_id: element.eventoPagamentoProp_id,
                relacaoServicoEventoPagamentoProp_vlr: element.relacaoServicoEventoPagamentoProp_vlr,
              }
            }
          )

          setModeloServicoData({
            ...modeloServicoData,
            eventosPagamento:
              modeloServicoData.eventosPagamento.map(ep => {
                if (ep.prodProp_id === element.prodProp_id) {
                  return {...ep, relacaoServicoEventoPagamentoProp_id: resPostModeloServicoEventoPagamentoProp.data[0].relacaoServicoEventoPagamentoProp_id}
                } else {
                  return ep
                }
              })
          })
        }
      }

      if (modeloServicoData.macroatividades?.length > 0) {
        for (let index = 0; index < modeloServicoData.macroatividades.length; index++) {
          const element = modeloServicoData.macroatividades[index];

          if (element.produtos && element.produtos.length > 0) {
            for (let index = 0; index < element.produtos.length; index++) {
              const elementProduto = element.produtos[index];

              const resPostProdPropMacroatividade = await oikosApi.post(
                '/',
                {
                  action: 'insert',
                  table: 'relacaoProdPropMacroatividade',
                  data: {
                    prodProp_id: elementProduto.prodProp_id,
                    macroatividade_id: element.macroatividade_id,
                    relacaoServicoProdProp_id: elementProduto.relacaoServicoProdProp_id,
                    relacaoServicoMacroatividade_id: element.relacaoServicoMacroatividade_id,
                  }
                }
              )
            }
          }

          if (element.eventosPagamento && element.eventosPagamento.length > 0) {
            for (let index = 0; index < element.eventosPagamento.length; index++) {
              const elementEventoPagamento = element.eventosPagamento[index];

              const resPostEventoPagametoPropMacroatividade = await oikosApi.post(
                '/',
                {
                  action: 'insert',
                  table: 'relacaoEventoPagamentoPropMacroatividade',
                  data: {
                    eventoPagamentoProp_id: elementEventoPagamento.eventoPagamentoProp_id,
                    macroatividade_id: element.macroatividade_id,
                    relacaoServicoEventoPagamento_id: elementEventoPagamento.relacaoServicoEventoPagamento_id,
                    relacaoServicoMacroatividade_id: element.relacaoServicoMacroatividade_id,
                  }
                }
              )
            }
          }
        }
      }
    }

    await fetchSelectServicos();
    setModeloServicoData({});
    setIsSubmitEntityLoading(false);
    setModalAddServicoOpen(false);
  }

  const checkPropItensDataFields = (propItemData) => {

    console.log(propItemData);

    if (!propItemData.propItem_desc || propItemData.propItem_desc.trim() === "") {
      notifyError("Item sem descrição");
      return false;
    }

    if (!propItemData.relacaoMacroatividadePropItem_propItemQtd) {
      notifyError("Item sem quantidade");
      return false;
    }

    return true;
  }

  const checkMacroatividadeDataFields = (macroatividadeData) => {

    console.log('macroatividadeData', macroatividadeData)

    if (!macroatividadeData.macroatividade_nome || macroatividadeData.macroatividade_nome.trim() === "") {
      notifyError("Dê um nome a macroatividade");
      return false;
    }

    if (!macroatividadeData.propItens || macroatividadeData.propItens.length <= 0) {
      notifyError("Atribua itens orçamentários para a macroatividade");
      return false;
    }

    for (let index = 0; index < macroatividadeData.propItens.length; index++) {
      const propItem = macroatividadeData.propItens[index];

      const checkPropItens = checkPropItensDataFields(propItem);

      if (!checkPropItens) return false;
    }

    if (!macroatividadeData.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias) {
      notifyError("Atribua um tempo estimado de execução para a macroatividade");
      return false;
    }

    return true;

  }

  const checkProdPropDataFields = (prodPropData) => {
    if (!prodPropData.prodProp_nome || prodPropData.prodProp_nome.trim() === "") {
      notifyError("Dê um nome ao produto");
      return false;
    }

    return true;
  }

  const checkEventoPagamentoPropDataFields = (eventoPagamentoPropData) => {
    if (!eventoPagamentoPropData.eventoPagamentoProp_nome || eventoPagamentoPropData.eventoPagamentoProp_nome.trim() === "") {
      notifyError("Dê um nome ao evento de pagamento");
      return false;
    }

    return true;
  }

  const handleSaveProdProp = async () => {
    const isValid = checkProdPropDataFields(prodPropData);
    if (!isValid) return;

    setIsSubmitEntityLoading(true);
    try {
      await oikosApi.post("/", {
        action: "insert",
        table: "prodProp",
        data: {
          prodProp_nome: prodPropData.prodProp_nome.trim(),
          prodProp_ativo: 1,
        },
      });

      await fetchProdsProp();
      setProdPropData({});
      setModalProdPropOpen(false);
    } catch (err) {
      console.error(err);
      notifyError("Erro ao salvar produto");
    } finally {
      setIsSubmitEntityLoading(false);
    }
  }

  const handleUpdateProdProp = async () => {

    setIsSubmitEntityLoading(true);

    if (prodPropData.prodProp_nome) {
      let prodPropId;

      if (isEditingProdProp && prodPropData.prodProp_id) {

        let prodPropInfo = {};
        let relServicoProdPropInfo = {};
        let servicoInfo = {
          modeloServico_nome: modeloServicoData.modeloServico_nome,
          modeloServico_id: modeloServicoData.modeloServico_id,
          servico_id: modeloServicoData.servico_id,
          modeloServico_prazoInicio: modeloServicoData.modeloServico_prazoInicio,
          modeloServico_prazoFim: modeloServicoData.modeloServico_prazoFim
        };

        if (prodPropData.relacaoServicoProdProp_id && prodPropData.prodProp_id) {

          // Update existing prodProp
          prodPropId = prodPropData.prodProp_id;
          const resProdPropUpdate = await oikosApi.post('/', {
            action: 'update',
            table: 'prodProp',
            data: {
              prodProp_id: prodPropId,
              prodProp_nome: prodPropData.prodProp_nome,
            }
          });

          prodPropInfo = resProdPropUpdate.data[0];

          console.log('prodPropInfo', prodPropInfo);

          setModeloServicoData({
            ...modeloServicoData,
            servico: modeloServicoData.servico,
            produtos: (
              modeloServicoData.produtos.map(m => {
                if(m.relacaoServicoProdProp_id === prodPropData.relacaoServicoProdProp_id) {
                  return {
                    ...m,
                    ...servicoInfo,
                    ...relServicoProdPropInfo,
                    ...prodPropInfo,
                    value: prodPropInfo.value,
                    label: prodPropInfo.prodProp_nome
                  }
                } else {
                  return m;
                }
              })
            )
          })

          await fetchProdsProp();
        }
      }
    }
  }

  const handleSaveEventoPagamentoProp = async () => {
    const isValid = checkEventoPagamentoPropDataFields(eventoPagamentoPropData);
    if (!isValid) return;

    setIsSubmitEntityLoading(true);
    try {
      await oikosApi.post("/", {
        action: "insert",
        table: "eventoPagamentoProp",
        data: {
          eventoPagamentoProp_nome: eventoPagamentoPropData.eventoPagamentoProp_nome.trim(),
          eventoPagamentoProp_ativo: 1,
        },
      });

      await fetchEventosPagamento();
      setEventoPagamentoPropData({});
      setModalEpOpen(false);
    } catch (err) {
      console.error(err);
      notifyError("Erro ao salvar evento de pagamento");
    } finally {
      setIsSubmitEntityLoading(false);
    }
  }

  const handleUpdateEventoPagamentoProp = async () => {
    if (!eventoPagamentoPropData.eventoPagamentoProp_nome) return;
    if (!isEditingEventoPagamentoProp) return;

    const eventoPagamentoPropId = eventoPagamentoPropData.eventoPagamentoProp_id ?? eventoPagamentoPropData.value;
    if (!eventoPagamentoPropId) return;

    setIsSubmitEntityLoading(true);
    try {
      const resEventoPagamentoPropUpdate = await oikosApi.post("/", {
        action: "update",
        table: "eventoPagamentoProp",
        data: {
          eventoPagamentoProp_id: eventoPagamentoPropId,
          eventoPagamentoProp_nome: eventoPagamentoPropData.eventoPagamentoProp_nome.trim(),
        },
      });

      const updated = resEventoPagamentoPropUpdate?.data?.[0] || {};
      const updatedName = updated.eventoPagamentoProp_nome ?? eventoPagamentoPropData.eventoPagamentoProp_nome.trim();

      let updatedVlr = null;
      if (eventoPagamentoPropData.relacaoServicoEventoPagamentoProp_id) {
        console.log(eventoPagamentoPropData.relacaoServicoEventoPagamentoProp_id);
        console.log(eventoPagamentoPropData);
        const resEventoPagamentoPropUpdate = await oikosApi.post("/", {
          action: "update",
          table: "relacaoServicoEventoPagamentoProp",
          data: {
            relacaoServicoEventoPagamentoProp_id: eventoPagamentoPropData.relacaoServicoEventoPagamentoProp_id,
            relacaoServicoEventoPagamentoProp_vlr: Number(eventoPagamentoPropData.relacaoServicoEventoPagamentoProp_vlr),
          },
        });

        updatedVlr = resEventoPagamentoPropUpdate.data[0].relacaoServicoEventoPagamentoProp_vlr;
      }

      setModeloServicoData((prev) => ({
        ...prev,
        eventosPagamento: prev.eventosPagamento
          ? prev.eventosPagamento.map((ep) => {
              const epId = ep.eventoPagamentoProp_id ?? ep.value;
              if (String(epId) !== String(eventoPagamentoPropId)) return ep;

              return {
                ...ep,
                eventoPagamentoProp_nome: updatedName,
                ...(updatedVlr ? {relacaoServicoEventoPagamentoProp_vlr: updatedVlr} : {}),
                label: updatedName,
              };
            })
          : prev.eventosPagamento,
      }));

      setSelectedEpsProp((prev) =>
        prev
          ? prev.map((ep) => {
              const epId = ep.eventoPagamentoProp_id ?? ep.value;
              if (String(epId) !== String(eventoPagamentoPropId)) return ep;

              return {
                ...ep,
                eventoPagamentoProp_nome: updatedName,
                ...(updatedVlr ? {relacaoServicoEventoPagamentoProp_vlr: updatedVlr} : {}),
                label: updatedName,
              };
            })
          : prev
      );

      await fetchEventosPagamento();
    } catch (err) {
      console.error(err);
      notifyError("Erro ao atualizar evento de pagamento");
    } finally {
      setIsSubmitEntityLoading(false);
    }
  }

  const getPropItemsByMacroatividadeId = async (macroatividadeId, relacaoServicoMacroatividadeId) => {
    let res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'relacaoMacroatividadePropItem',
        data: {
          macroatividade_id: macroatividadeId,
          relacaoServicoMacroatividade_id: relacaoServicoMacroatividadeId,
          relacaoMacroatividadePropItem_ativo: 1
        },
        fields: {
          "(SELECT macroatividade_nome FROM macroatividade WHERE macroatividade.macroatividade_id = relacaoMacroatividadePropItem.macroatividade_id)": "macroatividade_nome",
          "(SELECT propItem_desc FROM propItem WHERE propItem.propItem_id = relacaoMacroatividadePropItem.propItem_id)": "propItem_desc",
          "(SELECT propItem_refVlr FROM propItem WHERE propItem.propItem_id = relacaoMacroatividadePropItem.propItem_id)": "propItem_refVlr",
          "(SELECT propItemGr_id FROM propItem WHERE propItem.propItem_id = relacaoMacroatividadePropItem.propItem_id)": "propItemGr_id",
          "(SELECT unidade_label FROM propItem WHERE propItem.propItem_id = relacaoMacroatividadePropItem.propItem_id)": "unidade_label",
        }
      })}`
    );

    res.data = res.data.filter(rmpi => rmpi.relacaoServicoMacroatividade_id);

    console.log(res.data);

    return res.data;
  }

  const handleShowEntity = (key) => {
    setEntitySelected(prev => {
      const allFalse = Object.fromEntries(
        Object.keys(prev).map(k => [k, false])
      );

      return {
        ...allFalse,
        [key]: true
      };
    });
  };

  const handleShowItemGr = (key) => {
    setItemGrSelected(prev => {
      const allFalse = Object.fromEntries(
        Object.keys(prev).map(k => [k, false])
      );

      return {
        ...allFalse,
        [key]: true
      };
    });
  };

  const handleShowEntityInsideMacroatividade = (key) => {
    setEntitySelectedInsideMacroatividades(prev => {
      const allFalse = Object.fromEntries(
        Object.keys(prev).map(k => [k, false])
      );

      return {
        ...allFalse,
        [key]: true
      };
    });
  };

  function diffObjects(obj1, obj2, path = '') {
    const allKeys = new Set([
      ...Object.keys(obj1 || {}),
      ...Object.keys(obj2 || {})
    ])

    for (const key of allKeys) {
      const val1 = obj1?.[key]
      const val2 = obj2?.[key]
      const currentPath = path ? `${path}.${key}` : key

      const bothObjects =
        typeof val1 === 'object' &&
        typeof val2 === 'object' &&
        val1 !== null &&
        val2 !== null

      if (bothObjects) {
        diffObjects(val1, val2, currentPath)
      } else if (val1 !== val2) {
        console.log(`Difference at "${currentPath}"`, {
          from: val1,
          to: val2
        })
      }
    }
  }

  const createArraySumPropItensObjects = (arr) => {
    const macroatividadesWithPropItens = arr.filter(m => m.propItens && m.propItens.length > 0);
    const propItensArr = macroatividadesWithPropItens.map(m => m.propItens).flat();

    const grouped = propItensArr.reduce((acc, item) => {
      const id = item.propItem_id;

      if (!acc[id]) {
        acc[id] = {
          propItem_id: id,
          macroatividade_id: [],
          relacaoMacroatividadePropItem_propItemQtd: {},
          relacaoMacroatividadePropItem_vlr: {},
          macroatividade_nome: [],
          propItem_desc: item.propItem_desc,
          propItem_refVlr: item.propItem_refVlr,
          propItemGr_id: item.propItemGr_id,
          unidade_label: item.unidade_label
        };
      }

      // push macroatividade info
      acc[id].macroatividade_id.push(item.macroatividade_id);
      acc[id].macroatividade_nome.push(item.macroatividade_nome);

      // map qtd and vlr by macroatividade_nome (or macroatividade_id)
      acc[id].relacaoMacroatividadePropItem_propItemQtd[item.macroatividade_nome] =
        item.relacaoMacroatividadePropItem_propItemQtd;

      // convert vlr to number if it comes as string
      acc[id].relacaoMacroatividadePropItem_vlr[item.macroatividade_nome] =
        Number(item.relacaoMacroatividadePropItem_vlr);

      return acc;
    }, {});

    // convert object into array if needed
    const result = Object.values(grouped);


    return result;
  }

  const handleSaveMacroatividade = async () => {
    if (macroatividadeData.macroatividade_nome) {
      let macroatividadeId;

      console.log(macroatividadeData);

      if (isEditingMacroatividade && macroatividadeData.macroatividade_id) {
        const isValid = checkMacroatividadeDataFields(macroatividadeData);
        if (!isValid) return;

        setModeloServicoData({
          ...modeloServicoData,
          macroatividades: modeloServicoData.macroatividades.map(m => {
            if (m.value === macroatividadeData.value) {
              return {...macroatividadeData}
            }
            return m;
          })
        })
      } else {

        const newMacroatividade = await oikosApi.post('/', {
          action: 'insert',
          table: 'macroatividade',
          data: {
            macroatividade_nome: macroatividadeData.macroatividade_nome,
            macroatividade_ativo: 1,
          }
        });

        macroatividadeId = newMacroatividade.data[0].macroatividade_id;

        const newMacroPropItens = [];

        if (macroatividadeData.propItens && macroatividadeData.propItens.length > 0) {
          for (const element of macroatividadeData.propItens) {
            const resInserRelPropItemawait = await oikosApi.post('/', {
              action: 'insert',
              table: 'relacaoMacroatividadePropItem',
              data: {
                macroatividade_id: macroatividadeId,
                propItem_id: element.propItem_id,
                relacaoMacroatividadePropItem_propItemQtd: element.relacaoMacroatividadePropItem_propItemQtd,
                relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: Number(element.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias),
              }
            });

            console.log('resInserRelPropItemawait', resInserRelPropItemawait);

            newMacroPropItens.push(resInserRelPropItemawait.data[0])
          }
        }

        await fetchMacroatividades();
      }

      /* if (isEditingMacroatividade && macroatividadeData.macroatividade_id) {

        let propItens = [];
        let macroatividadeInfo = {};
        let relServicoMacroatividadeInfo = {};
        let servicoInfo = {
          modeloServico_nome: modeloServicoData.modeloServico_nome,
          modeloServico_id: modeloServicoData.modeloServico_id,
          servico_id: modeloServicoData.servico_id,
          modeloServico_prazoInicio: modeloServicoData.modeloServico_prazoInicio,
          modeloServico_prazoFim: modeloServicoData.modeloServico_prazoFim
        };

        if (macroatividadeData.relacaoServicoMacroatividade_id) {

          // Update existing macroatividade
          macroatividadeId = macroatividadeData.macroatividade_id;
          const resMacroatividadeUpdate = await oikosApi.post('/', {
            action: 'update',
            table: 'macroatividade',
            data: {
              macroatividade_id: macroatividadeId,
              macroatividade_nome: macroatividadeData.macroatividade_nome,
            }
          });

          macroatividadeInfo = resMacroatividadeUpdate.data[0];

          // Get existing propItens relationships
          const existingPropItens = await getPropItemsByMacroatividadeId(macroatividadeId);
          const existingPropItemIds = existingPropItens.map(pi => pi.propItem_id);
          const newPropItemIds = macroatividadeData.propItens ? macroatividadeData.propItens.map(pi => pi.propItem_id) : [];

          // Delete removed propItens relationships
          const propItensToRemove = existingPropItemIds.filter(id => !newPropItemIds.includes(id));
          for (const propItemId of propItensToRemove) {
            const relToDelete = existingPropItens.find(pi => pi.propItem_id === propItemId);
            if (relToDelete && relToDelete.relacaoMacroatividadePropItem_id) {
              const resUpdateRemovePropItensFromMacroatividade = await oikosApi.post('/', {
                action: 'update',
                table: 'relacaoMacroatividadePropItem',
                data: {
                  relacaoMacroatividadePropItem_id: relToDelete.relacaoMacroatividadePropItem_id,
                  relacaoMacroatividadePropItem_ativo: 0,
                }
              });

              propItens = macroatividadeData.propItens.filter(rmpi => rmpi.relacaoMacroatividadePropItem_id !== relToDelete.relacaoMacroatividadePropItem_id);
            }
          }

          // Add or update propItens relationships
          if (macroatividadeData.propItens && macroatividadeData.propItens.length > 0) {
            for (const element of macroatividadeData.propItens) {
              const existingRel = existingPropItens.find(pi => pi.propItem_id === element.propItem_id);
              if (existingRel && existingRel.relacaoMacroatividadePropItem_id) {
                // Update existing relationship
                const resUpdatePropItensFromMacroatividade = await oikosApi.post('/', {
                  action: 'update',
                  table: 'relacaoMacroatividadePropItem',
                  data: {
                    relacaoMacroatividadePropItem_id: existingRel.relacaoMacroatividadePropItem_id,
                    relacaoMacroatividadePropItem_propItemQtd: element.relacaoMacroatividadePropItem_propItemQtd || existingRel.relacaoMacroatividadePropItem_propItemQtd,
                    relacaoMacroatividadePropItem_ativo: 1,
                    relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: element.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias || existingRel.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias,
                  }
                });

                propItens = macroatividadeData.propItens.map(pi => {
                  if (pi.relacaoMacroatividadePropItem_id === resUpdatePropItensFromMacroatividade.relacaoMacroatividadePropItem_id) {
                    return {
                      ...pi,
                      relacaoMacroatividadePropItem_propItemQtd: element.relacaoMacroatividadePropItem_propItemQtd || existingRel.relacaoMacroatividadePropItem_propItemQtd,
                      relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: element.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias || existingRel.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias,
                    }
                  } else {
                    return pi;
                  }
                })

                console.log(propItens)
              } else {
                // Insert new relationship
                const resPostInsertRelacaoMacroatividadePropItem = await oikosApi.post('/', {
                  action: 'insert',
                  table: 'relacaoMacroatividadePropItem',
                  data: {
                    macroatividade_id: macroatividadeId,
                    propItem_id: element.propItem_id,
                    relacaoMacroatividadePropItem_propItemQtd: element.relacaoMacroatividadePropItem_propItemQtd,
                    relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: element.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias,
                    relacaoServicoMacroatividade_id: macroatividadeData.relacaoServicoMacroatividade_id
                  }
                });

                propItens = propItens.push(resPostInsertRelacaoMacroatividadePropItem.data[0]);
              }
            }
            macroatividadeInfo = {...macroatividadeInfo, propItens: propItens}
          }

          // Update relacaoServicoMacroatividade if prazoDias is provided
          if (macroatividadeData.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias !== undefined && macroatividadeData.modeloServico_id) {
            const resRelServicoMacroatividade = await oikosApi.post('/', {
              action: 'update',
              table: 'relacaoServicoMacroatividade',
              data: {
                relacaoServicoMacroatividade_id: macroatividadeData.relacaoServicoMacroatividade_id,
                relacaoServicoMacroatividade_tempoEstimadoExecucaoDias: macroatividadeData.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias,
              }
            });

            relServicoMacroatividadeInfo = resRelServicoMacroatividade.data[0];
          }

          console.log('objetos', {...servicoInfo, ...relServicoMacroatividadeInfo, ...macroatividadeInfo, value: macroatividadeInfo.macroatividade_id, label: macroatividadeInfo.macroatividade_nome});

          setModeloServicoData({
            ...modeloServicoData,
            servico: modeloServicoData.servico,
            macroatividades: (
              modeloServicoData.macroatividades.map(m => {
                if(m.relacaoServicoMacroatividade_id === macroatividadeData.relacaoServicoMacroatividade_id) {
                  return {
                    ...m,
                    ...servicoInfo,
                    ...relServicoMacroatividadeInfo,
                    ...macroatividadeInfo,
                    value: macroatividadeInfo.value,
                    label: macroatividadeInfo.macroatividade_nome
                  }
                } else {
                  return m;
                }
              })
            )
          })

        } else {
          setModeloServicoData({
            ...modeloServicoData,
            servico: modeloServicoData.servico,
            macroatividades: (
              modeloServicoData.macroatividades.map(m => {
                if(m.relacaoServicoMacroatividade_id === macroatividadeData.relacaoServicoMacroatividade_id) {

                  return {
                    ...m,
                    ...servicoInfo,
                    ...relServicoMacroatividadeInfo,
                    ...macroatividadeInfo,
                    value: macroatividadeInfo.value,
                    label: macroatividadeInfo.macroatividade_nome
                  }
                } else {
                  return m;
                }
              })
            )
          })
        }
      } else {
        // Insert new macroatividade
        const newMacroatividade = await oikosApi.post('/', {
          action: 'insert',
          table: 'macroatividade',
          data: {
            macroatividade_nome: macroatividadeData.macroatividade_nome,
            macroatividade_ativo: 1,
          }
        });

        macroatividadeId = newMacroatividade.data[0].macroatividade_id;

        console.log({...macroatividadeData, ...newMacroatividade.data[0]})

        if (!modeloServicoData.modeloServico_id) {

          const newMacroPropItens = [];

          if (macroatividadeData.propItens && macroatividadeData.propItens.length > 0) {
            for (const element of macroatividadeData.propItens) {
              const resInserRelPropItemawait = await oikosApi.post('/', {
                action: 'insert',
                table: 'relacaoMacroatividadePropItem',
                data: {
                  macroatividade_id: macroatividadeId,
                  propItem_id: element.propItem_id,
                  relacaoMacroatividadePropItem_propItemQtd: element.relacaoMacroatividadePropItem_propItemQtd,
                  relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: Number(element.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias),
                }
              });

              console.log('resInserRelPropItemawait', resInserRelPropItemawait);
              const propItemInfo = propItens.find(pi => pi.propItem_id === resInserRelPropItemawait.data[0].propItem_id)

              newMacroPropItens.push({...resInserRelPropItemawait.data[0], value: propItemInfo.propItem_id, label: propItemInfo.label})
            }
          }

          if (newMacroPropItens.length > 0) {
            newMacroatividade.data[0].propItens = newMacroPropItens;
          }

          setModeloServicoData({
            ...modeloServicoData,
            servico: modeloServicoData.servico,
            macroatividades: (
              modeloServicoData.macroatividades ?
              [...modeloServicoData.macroatividades, {modeloServico_nome: modeloServicoData.modeloServico_nome, ...newMacroatividade.data[0], value: newMacroatividade.data[0].macroatividade_id, label: newMacroatividade.data[0].macroatividade_nome}] :
              [{...modeloServicoData, ...newMacroatividade.data[0], value: newMacroatividade.data[0].macroatividade_id, label: newMacroatividade.data[0].macroatividade_nome}]
            )
          })
        } else {

          const newRelServicoMacroatividade = await oikosApi.post('/', {
            action: 'insert',
            table: 'relacaoServicoMacroatividade',
            data: {
              macroatividade_id: macroatividadeId,
              servico_id: modeloServicoData.servico.servico_id,
              modeloServico_id: modeloServicoData.modeloServico_id,
              relacaoServicoMacroatividade_tempoEstimadoExecucaoDias: macroatividadeData.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias
            }
          });

          console.log('newRelServicoMacroatividade', newRelServicoMacroatividade);

          const newMacroPropItens = [];

          if (macroatividadeData.propItens && macroatividadeData.propItens.length > 0) {
            for (const element of macroatividadeData.propItens) {
              const resInserRelPropItemawait = await oikosApi.post('/', {
                action: 'insert',
                table: 'relacaoMacroatividadePropItem',
                data: {
                  macroatividade_id: macroatividadeId,
                  propItem_id: element.propItem_id,
                  relacaoMacroatividadePropItem_propItemQtd: element.relacaoMacroatividadePropItem_propItemQtd,
                  relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: Number(element.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias),
                  relacaoServicoMacroatividade_id: newRelServicoMacroatividade.data[0].relacaoServicoMacroatividade_id
                }
              });

              console.log('resInserRelPropItemawait', resInserRelPropItemawait);

              newMacroPropItens.push(resInserRelPropItemawait.data[0])
            }
          }

          if (newMacroPropItens.length > 0) {
            newRelServicoMacroatividade.data[0].propItens = newMacroPropItens.map(pi => { return {...pi, label: pi.propItem_desc, value: pi.propItem_id} });
          }

          setModeloServicoData({
            ...modeloServicoData,
            servico: modeloServicoData.servico,
            macroatividades: (
              modeloServicoData.macroatividades ?
              [...modeloServicoData.macroatividades, {modeloServico_id: modeloServicoData.modeloServico_id, modeloServico_nome: modeloServicoData.modeloServico_nome, ...newRelServicoMacroatividade.data[0], ...newMacroatividade.data[0], value: newMacroatividade.data[0].macroatividade_id, label: newMacroatividade.data[0].macroatividade_nome}] :
              [{modeloServico_id: modeloServicoData.modeloServico_id, modeloServico_nome: modeloServicoData.modeloServico_nome, ...newRelServicoMacroatividade.data[0], ...newMacroatividade.data[0], value: newMacroatividade.data[0].macroatividade_id, label: newMacroatividade.data[0].macroatividade_nome}]
            )
          })
        }
      } */
    }
  }

  const handleUpdatePropItem = async () => {

    setIsSubmitEntityLoading(true);

    if (propItemData.relacaoMacroatividadePropItem_propItemQtd) {
      setMacroatividadeData({
        ...macroatividadeData,
        propItens: macroatividadeData.propItens.map(pi => {
          if (pi.propItem_id === propItemData.propItem_id) {
            return {...pi, relacaoMacroatividadePropItem_propItemQtd: propItemData.relacaoMacroatividadePropItem_propItemQtd, relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: propItemData.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias}
          }
          return pi;
        })
      })
    }
  }

  const handleSaveDraft = async () => {
    if (propostaData.propStatus_id === 2) {
      if (propostaData.propItens.length) {
        for (let index = 0; index < propostaData.propItens.length; index++) {
          const element = propostaData.propItens[index];
          const findedPropItem = originalPropostaData.propItens.find(pi => pi.propItem_id === element.propItem_id)
          if (originalPropostaData.propItens && findedPropItem) {
            if (findedPropItem.relacaoPropPropItem_propItemQtd !== element.relacaoPropPropItem_propItemQtd) {
              await oikosApi.post('/', {
                action: 'update',
                table: 'relacaoPropPropItem',
                data: {
                  relacaoPropPropItem_id: findedPropItem.relacaoPropPropItem_id,
                  relacaoPropPropItem_propItemQtd: element.relacaoPropPropItem_propItemQtd,
                }
              })
            }
          }
        }
      }
    }
  }

  useEffect(() => {
    fetchPjs();
    fetchModelosPropostas();
    fetchSelectServicos();
    fetchSelectServicosCompostos();
    fetchMacroatividades();
    fetchProdsProp();
    fetchEventosPagamento();
    fetchItensOrcamentarios();
    fetchServicos();
    setActiveId(TABS[0].id);
  }, [])

  return (
    <Container fluid style={{paddingTop: "9rem", height: "120vh", overflow: 'scroll'}}>
      {/* <Button onClick={()=>setEmBranco(true)}>Iniciar em branco</Button>
      <Button onClick={()=>setEmBranco(false)}>Carregar um modelo</Button> */}
      <div className="timeline-tabs">
        {/* LEFT: timeline tabs */}
        <aside className="timeline-tabs__sidebar">
          <ul className="timeline">
            {TABS.map((tab, index) => (
              <li
                key={tab.id}
                className={
                  "timeline__item" +
                  (tab.id === activeId ? " timeline__item--active" : "") +
                  (index === 0 ? " timeline__item--first" : "") +
                  (index === TABS.length - 1 ? " timeline__item--last" : "")
                }
              >
                <button
                  type="button"
                  className="timeline__button"
                  onClick={() => setActiveId(tab.id)}
                >
                  <span className="timeline__marker" />
                  <div className="timeline__text">
                    <span className="timeline__label">{tab.label}</span>
                    {tab.subtitle && (
                      <span className="timeline__subtitle">
                        {tab.subtitle}
                      </span>
                    )}
                  </div>
                </button>
              </li>
            ))}
            <li>
              <button>
                Salvar rascunho
              </button>
            </li>
          </ul>
        </aside>

        {/* RIGHT: content */}
        <section className="timeline-tabs__content">
          {activeTab?.content}
        </section>
      </div>

      <ModalConfirmacao
        openModal={isModalWarningOpen}
        onClosed={()=>setIsModalWarningOpen(false)}
        title={'Tem certeza que deseja alterar o serviço?'}
        subtitle={`As informações de macroatividades, produtos e eventos de pagamento serão perdidas.`}
        confirmButtonText='Alterar'
        onConfirm={()=>{
          setPropostaData({
            ...propostaData,
            modeloServico_ids: [],
          });
          setSelectedEpsProp([]);
          setSelectedMacroatividades([]);
          setSelectedProdsProp([]);
          servicoCompostoMode ? setServicoCompostoMode(false) : setServicoCompostoMode(true);
          setIsModalWarningOpen(false);
        }}
      />

      <Modal
        size='lg'
        centered={false}
        isOpen={modalMacroatividadeOpen}
        toggle={() => {
          setModalMacroatividadeOpen(false);
          setIsEditingMacroatividade(false);
          setMacroatividadeData({});
        }}
      >
        <ModalHeader>{isEditingMacroatividade ? 'Editar Macroatividade' : 'Adicionar Macroatividade'}</ModalHeader>

        <ModalBody>

          <Tabs>
            <TabList>
              {!isEditingMacroatividade && <Tab>Modelo de macroatividade</Tab>}
              <Tab>{isEditingMacroatividade ? `Editando ${macroatividadeData.macroatividade_nome}` : 'Nova macroatividade'}</Tab>
            </TabList>
            {!isEditingMacroatividade && <TabPanel>
              <FormGroup>
                <span>
                  Modelo de macroatividade
                </span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  isDisabled={isEditingMacroatividade}
                  value={isEditingMacroatividade && macroatividadeData.value ? {value: macroatividadeData.value, label: macroatividadeData.macroatividade_nome} : null}
                  options={macroatividades}
                  onChange={async (e) => {
                    if (e) {
                      setIsLoadingShowPropItens(true);
                      const propItens = await getPropItemsByMacroatividadeId(e.value);
                      setPropItensShowed(propItens);
                      setIsLoadingShowPropItens(false);
                    }
                  }}
                />
              </FormGroup>

              {
                isLoadingShowPropItens ? <Spinner /> :
                (!isLoadingShowPropItens && propItensShowed.length > 0) ?
                <FormGroup>
                  <div>
                    <strong>Itens orçamentários da macroatividade selecionada:</strong><br />
                    {propItensShowed.map(propItem => {
                      return (
                        <div>
                          <span>{propItem.propItem_desc}</span><br />
                        </div>
                      )
                    })}
                  </div>
                </FormGroup> : <></>
              }

              <FormGroup>
                <span>
                  Prazo para execução da macroatividade (dias)
                </span>
                <Input
                  value={macroatividadeData.relacaoServicoMacroatividade_prazoDias ? macroatividadeData.relacaoServicoMacroatividade_prazoDias : ''}
                  onChange={e => {
                    if (e && !isNaN(Number(e.target.value))) {
                      setMacroatividadeData({...macroatividadeData, relacaoServicoMacroatividade_prazoDias: e.target.value})
                    }
                  }}
                />
              </FormGroup>
            </TabPanel>}
            <TabPanel>
              <FormGroup>
                <span>
                  Nome da macroatividade
                </span>
                <Input
                  value={macroatividadeData.macroatividade_nome ? macroatividadeData.macroatividade_nome : null}
                  onChange={e => setMacroatividadeData({...macroatividadeData, macroatividade_nome: e.target.value})}
                />
              </FormGroup>

              <FormGroup>
                <span>
                  Itens Orçamentários
                </span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  isMulti
                  options={propItens}
                  value={macroatividadeData.propItens ? macroatividadeData.propItens.map(pi => {return {value: pi.propItem_id, label: pi.propItem_desc, ...pi}}) : []}
                  onChange={async (e) => {
                    if (e) {
                      setMacroatividadeData({...macroatividadeData, propItens: e});
                    } else {
                      setMacroatividadeData({...macroatividadeData, propItens: []});
                    }
                  }}
                />
              </FormGroup>

              <FormGroup>
                <span>
                  Tempo estimado de execução (dias)
                </span>
                <Input
                  value={macroatividadeData.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias}
                  onChange={async (e) => {
                    if (macroatividadeData) {
                      if (e) {
                        if (
                          e.target.value &&
                          e.target.value !== '' &&
                          !isNaN(Number(e.target.value))
                        ) {
                          setMacroatividadeData({
                            ...macroatividadeData,
                            relacaoServicoMacroatividade_tempoEstimadoExecucaoDias: Number(e.target.value)
                          })
                        }
                        else {
                          setMacroatividadeData({
                            ...macroatividadeData,
                            relacaoServicoMacroatividade_tempoEstimadoExecucaoDias: 0
                          })
                        }
                      } else {
                        if (
                          e.target.value &&
                          e.target.value !== '' &&
                          !isNaN(Number(e.target.value))
                        ) {
                          setMacroatividadeData({
                            ...macroatividadeData,
                            relacaoServicoMacroatividade_tempoEstimadoExecucaoDias: Number(e.target.value)
                          })
                        }
                      }
                    }
                  }}
                />
              </FormGroup>

              <MaterialReactTable
                columns={columnsSelectedMacroatividadesPropItens}
                data={macroatividadeData.propItens ? macroatividadeData.propItens : []}
                initialState={{
                  density: 'compact',
                  expanded: {}, //expand all groups by default
                  pagination: { pageIndex: 0, pageSize: 10 },
                  sorting: [], //sort by state by default,
                }}
                enableColumnResizing={true}
                enableGrouping={false}
                enableGlobalFilter={true}
                enableFilters={true}
                getRowId={(row) => String(row.prop_id)}
                enablePagination={(macroatividadeData.propItens?.length > 10)}
                muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                muiTablePaginationProps={{
                  sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                  labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                  rowsPerPageOptions: [10, 50, 100],
                }}
                positionPagination='bottom'
                muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                enableDensityToggle={false}
                enableColumnFilters={false}
                muiTableHeadCellProps={{
                  sx: {
                    '.MuiSvgIcon-root': {fontSize: "18px"},
                    fontSize: '12px',
                    fontWeight: 'normal', // Remove bold text in the header
                    padding: '8px', // Adjust padding to reduce white space
                  },
                }}
              />
            </TabPanel>
          </Tabs>

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => {
              setModalMacroatividadeOpen(false);
              setIsEditingMacroatividade(false);
              setMacroatividadeData({});
            }}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={async ()=>{
                setIsSubmitEntityLoading(true);

                const checkFields = checkMacroatividadeDataFields(macroatividadeData);

                if (!checkFields) {
                  setIsSubmitEntityLoading(false);
                  return
                }

                await handleSaveMacroatividade();

                setModalMacroatividadeOpen(false);
                setIsEditingMacroatividade(false);
                setMacroatividadeData({});
                setIsSubmitEntityLoading(false);
              }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal
        centered={false}
        isOpen={modalProdPropOpen}
        toggle={() => {
          setModalProdPropOpen(false);
          setProdPropData({});
        }}
      >
        <ModalHeader>{isEditingProdProp ? 'Editar Produto' : 'Adicionar Produto'}</ModalHeader>

        <ModalBody>

          <Tabs>
            <TabList>
              <Tab>Modelo de produto</Tab>
              <Tab>Novo produto</Tab>
            </TabList>
            <TabPanel>
              <FormGroup>
                <span>
                  Modelo de produto
                </span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={prodsProp}
                  onChange={async (e) => {
                  }}
                />
              </FormGroup>
            </TabPanel>
            <TabPanel>
              <FormGroup>
                <span>
                  Nome do produto
                </span>
                <Input
                  value={prodPropData.prodProp_nome || ""}
                  onChange={e => setProdPropData({...prodPropData, prodProp_nome: e.target.value})}
                />
              </FormGroup>
            </TabPanel>
          </Tabs>

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => {
              setModalProdPropOpen(false);
              setProdPropData({});
            }}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
             <Button
               type="button"
               color="primary"
               className="waves-effect waves-light"
              onClick={async () => {
                /* if (isEditingProdProp) {
                  await handleUpdateProdProp();
                } else {
                } */
                await handleSaveProdProp();

                setModalProdPropOpen(false);
                setIsEditingProdProp(false);
                setProdPropData({});
                setIsSubmitEntityLoading(false);
              }}
             >
               Salvar
             </Button>
           )}
         </ModalFooter>
      </Modal>

      <Modal
        centered={false}
        isOpen={modalEpOpen}
        toggle={() => {
          setModalEpOpen(false);
          setEventoPagamentoPropData({});
          setIsEditingEventoPagamentoProp(false);
        }}
      >
        <ModalHeader>{isEditingEventoPagamentoProp ? 'Editar evento de pagamento' : 'Adicionar evento de pagamento'}</ModalHeader>

        <ModalBody>

          <Tabs>
            <TabList>
              <Tab>Modelo de evento de pagamento</Tab>
              <Tab>Novo evento de pagamento</Tab>
            </TabList>
            <TabPanel>
              <FormGroup>
                <span>
                  Modelo de evento de pagamento
                </span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={eventosPagamentoProp}
                  onChange={async (e) => {
                  }}
                />
              </FormGroup>
            </TabPanel>
            <TabPanel>
              <FormGroup>
                <span>
                  Nome do evento de pagamento
                </span>
                <Input
                  value={eventoPagamentoPropData.eventoPagamentoProp_nome || ""}
                  onChange={e => setEventoPagamentoPropData({...eventoPagamentoPropData, eventoPagamentoProp_nome: e.target.value})}
                />
              </FormGroup>
              {
                isEditingEventoPagamentoProp &&
                <FormGroup>
                  <span>Valor (%)</span>
                  <MaskedInput
                    unmask
                    mask="num %"
                    blocks={{
                      num: {
                        mask: Number,
                        scale: 2, // digits after point 0 for integers
                        signed: false, // disallow negative
                        thousandsSeparator: '.', // any single char
                        padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                        normalizeZeros: false, // appends or removes zeros at ends
                        radix: ',', // fractional delimiter
                        min: 0,
                        max: 100,
                      },
                    }}
                    lazy={false}
                    value={String(modeloServicoData.eventosPagamento?.find(ep => ep.value === eventoPagamentoPropData.value)?.relacaoServicoEventoPagamentoProp_vlr || "")}
                    onAccept={value => {
                      setEventoPagamentoPropData({...eventoPagamentoPropData, relacaoServicoEventoPagamentoProp_vlr: Number(value)});

                      if (modeloServicoData.eventosPagamento) {
                        setModeloServicoData({
                          ...modeloServicoData,
                          eventosPagamento: modeloServicoData.eventosPagamento.map(ep =>
                            ep.value === eventoPagamentoPropData.value
                              ? { ...ep, relacaoServicoEventoPagamentoProp_vlr: Number(value) || null }
                              : ep
                          )
                        });
                      }
                    }}
                  />
                </FormGroup>
              }
            </TabPanel>
          </Tabs>

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => {
              setModalEpOpen(false);
              setEventoPagamentoPropData({});
              setIsEditingEventoPagamentoProp(false);
            }}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={async () => {
                if (isEditingEventoPagamentoProp) {
                  await handleUpdateEventoPagamentoProp();
                } else {
                  await handleSaveEventoPagamentoProp();
                }

                setModalEpOpen(false);
                setIsEditingEventoPagamentoProp(false);
                setEventoPagamentoPropData({});
                setIsSubmitEntityLoading(false);
              }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal
        size='lg'
        centered={false}
        isOpen={modalAddServicoOpen}
        toggle={() => setModalAddServicoOpen(false)}
      >
        <ModalHeader>Adicionar Modelo Serviço</ModalHeader>

        <ModalBody>
          <Tabs>
            <TabList>
              <Tab>Composição de serviços</Tab>
              <Tab>Serviços Principal ou secundário</Tab>
            </TabList>
            <TabPanel>
              <FormGroup>
                <span>
                  Nome do modelo da composição de serviços
                </span>
                <Input
                  value={modeloServicoData.modeloServico_nome ? modeloServicoData.modeloServico_nome : null}
                  onChange={e => setModeloServicoData({...modeloServicoData, modeloServico_nome: e.target.value})}
                />
              </FormGroup>
              <FormGroup>
                <span>
                  Serviços que compõem a composição de serviços
                </span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  isMulti
                  options={modelosServicos}
                  //value={modeloServicoData.modeloServico_ids ? [...modeloServicoData.modeloServico_ids.filter(ms => ms.servicoComposto && !ms.modeloServico_primario).map(ms => modelosServicos.find(option => option.value === ms.modeloServico_id))] : []}
                  onChange={async (e) => {
                    setIsLoadingSelected(true);
                    if (e) {

                    } else {

                    }
                    setIsLoadingSelected(false);
                  }}
                />
              </FormGroup>
            </TabPanel>
            <TabPanel>
              <Tabs>
                <TabList>
                  <Tab>Geral</Tab>
                  <Tab>Macroatividades</Tab>
                  <Tab>Produtos</Tab>
                  <Tab>Eventos de Pagamento</Tab>
                </TabList>
                <TabPanel>
                  <FormGroup>
                    <span onClick={() => console.log(modeloServicoData)}>
                      Nome do modelo do serviço
                    </span>
                    <Input
                      value={modeloServicoData.modeloServico_nome ? modeloServicoData.modeloServico_nome : null}
                      onChange={e => setModeloServicoData({...modeloServicoData, modeloServico_nome: e.target.value})}
                    />
                  </FormGroup>
                  <FormGroup>
                    <span>
                      Selecione o serviço a que o modelo se refere
                    </span>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={true}
                      isSearchable={true}
                      options={servicos}
                      value={modeloServicoData.servico ? modeloServicoData.servico : null}
                      onChange={async (e) => {
                        setIsLoadingSelected(true);
                        if (e) {
                          setModeloServicoData({...modeloServicoData, servico: e})
                        } else {
                          setModeloServicoData({...modeloServicoData, servico: null})
                        }
                        setIsLoadingSelected(false);
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <span>
                      Início do prazo para execução (dias)
                    </span>
                    <Input
                      type="text"
                      value={
                        (modeloServicoData.modeloServico_prazoInicio || modeloServicoData.modeloServico_prazoInicio !== "0") ? modeloServicoData.modeloServico_prazoInicio : ""
                      }
                      onChange={e => {
                        const onlyNumbers = e.target.value.replace(/\D/g, "");

                        setModeloServicoData({...modeloServicoData, modeloServico_prazoInicio: onlyNumbers})
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <span>
                      Fim do prazo para execução (dias)
                    </span>
                    <Input
                      value={
                        (modeloServicoData.modeloServico_prazoFim || modeloServicoData.modeloServico_prazoFim !== "0") ? modeloServicoData.modeloServico_prazoFim : ""
                      }
                      onChange={e => {
                        const onlyNumbers = e.target.value.replace(/\D/g, "");

                        setModeloServicoData({...modeloServicoData, modeloServico_prazoFim: onlyNumbers})
                      }}
                    />
                  </FormGroup>
{/*                   <FormGroup>
                    <span>
                      Serviço principal
                    </span>
                    <input type="checkbox" name="servico-primario" id="servico-primario" checked={modeloServicoData.modeloServico_primario === 1} onChange={(e) => {
                      if(modeloServicoData.modeloServico_secundario){
                        setModeloServicoData({...modeloServicoData, modeloServico_secundario: 0, modeloServico_primario: e.target.checked ? 1 : 0} )
                      } else {
                        setModeloServicoData({...modeloServicoData, modeloServico_primario: e.target.checked ? 1 : 0})
                      }
                    }}/>
                    <span>
                      Serviço secundário
                    </span>
                    <input type="checkbox" name="servico-secundario" id="servico-secundario" checked={modeloServicoData.modeloServico_secundario === 1} onChange={(e) => {
                      if(modeloServicoData.modeloServico_primario){
                        setModeloServicoData({...modeloServicoData, modeloServico_primario: 0, modeloServico_secundario: e.target.checked ? 1 : 0} )
                      } else {
                        setModeloServicoData({...modeloServicoData, modeloServico_secundario: e.target.checked ? 1 : 0})
                      }
                    }}/>
                  </FormGroup> */}
                </TabPanel>
                <TabPanel>
                  <FormGroup>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        Macroatividades
                      </span>
                      <Button
                        size="sm"
                        color="link"
                        className="ml-2 px-0"
                        onClick={(e)=>{
                          if(!modeloServicoData.modeloServico_nome) return notifyError('Adicione um nome ao modelo de serviço');
                          if(!modeloServicoData.servico?.servico_id) return notifyError('Adicione um serviço ao modelo de serviço');
                          if(!modeloServicoData.modeloServico_prazoFim) return notifyError('Adicione um prazo final ao modelo de serviço');
                          if(!modeloServicoData.modeloServico_prazoInicio && Number(modeloServicoData.modeloServico_prazoInicio) !== 0) return notifyError('Adicione um prazo inicial ao modelo de serviço');

                          setIsEditingMacroatividade(false);
                          setMacroatividadeData({});
                          setModalMacroatividadeOpen(true);
                        }}
                      >
                        Adicionar macroatividade
                      </Button>
                    </div>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={true}
                      isSearchable={true}
                      value={modeloServicoData.macroatividades || []}
                      options={(macroatividades && macroatividades.length > 0) ?
                        macroatividades.map(m => {return {...m, modeloServico_nome: modeloServicoData.modeloServico_nome}}) :
                      []}
                      isMulti
                      onChange={(selectedOptions, actionMeta) => {
                        const { action, option, removedValue } = actionMeta;

                        // When selecting → duplicate with new value
                        if (action === 'select-option') {
                          setModeloServicoData(prev => ({
                            ...prev,
                            macroatividades: [
                              ...(prev.macroatividades || []),
                              {
                                ...option,
                                value: `${option.value}-${Date.now()}`
                              }
                            ]
                          }));
                          return;
                        }

                        // When removing / clearing → trust react-select
                        if (action === "remove-value" || action === "pop-value") {
                          setModeloServicoData(prev => ({
                            ...prev,
                            macroatividades: selectedOptions || [],
                            produtos: prev.produtos ? prev.produtos.map(p => {
                              if (
                                p.macroatividades &&
                                p.macroatividades.find(m =>
                                  m.relacaoProdPropMacroatividade_id &&
                                  m.relacaoProdPropMacroatividade_id === removedValue.produtos.find(p =>
                                    p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id
                                  )?.relacaoProdPropMacroatividade_id
                                )
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.relacaoProdPropMacroatividade_id !== removedValue.produtos.find(p => p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id)?.relacaoProdPropMacroatividade_id) };
                              } else if (
                                p.macroatividades &&
                                !p.macroatividades.find(m =>
                                  m.relacaoProdPropMacroatividade_id &&
                                  m.relacaoProdPropMacroatividade_id === removedValue.produtos.find(p =>
                                    p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id
                                  )?.relacaoProdPropMacroatividade_id
                                ) && p.macroatividades.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.macroatividades &&
                                !p.macroatividades.find(m =>
                                  !m.relacaoProdPropMacroatividade_id &&
                                  m.value === removedValue.produtos.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.macroatividades.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                            eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(p => {
                              if (
                                p.macroatividades &&
                                p.macroatividades.find(m =>
                                  m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.eventosPagamento.find(p =>
                                    p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id
                                  )?.relacaoEventoPagamentoPropMacroatividade_id
                                )
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.eventosPagamento.find(p => p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id)?.relacaoEventoPagamentoPropMacroatividade_id) };
                              } else if (
                                p.macroatividades &&
                                !p.macroatividades.find(m =>
                                  m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.eventosPagamento.find(p =>
                                    p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id
                                  )?.relacaoEventoPagamentoPropMacroatividade_id
                                ) && p.macroatividades.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.macroatividades &&
                                !p.macroatividades.find(m =>
                                  !m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.value === removedValue.eventosPagamento.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.macroatividades.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                          }));
                        }

                        if (action === "clear") {
                          setModeloServicoData(prev => (
                            {
                              ...prev,
                              macroatividades: [],
                              produtos: prev.produtos && prev.produtos.map(p => {
                                return { ...p, macroatividades: []}
                              }),
                              eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(ep => {
                                return { ...ep, macroatividades: []}
                              }),
                            }
                          )); return;
                        }
                      }}
                    />
                    <MaterialReactTable
                      columns={columnsSelectedMacroatividades}
                      data={modeloServicoData.macroatividades ? modeloServicoData.macroatividades : []}
                      initialState={{
                        density: 'compact',
                        expanded: {}, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 10 },
                        sorting: [], //sort by state by default,
                      }}
                      enableColumnResizing={true}
                      enableGrouping={false}
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(modeloServicoData.macroatividades && modeloServicoData.macroatividades.length > 10)}
                      muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                      muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                      muiTablePaginationProps={{
                        sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                        labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                        rowsPerPageOptions: [10, 50, 100],
                      }}
                      positionPagination='bottom'
                      muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                      enableDensityToggle={false}
                      enableColumnFilters={false}
                      muiTableHeadCellProps={{
                        sx: {
                          '.MuiSvgIcon-root': {fontSize: "18px"},
                          fontSize: '12px',
                          fontWeight: 'normal', // Remove bold text in the header
                          padding: '8px', // Adjust padding to reduce white space
                        },
                      }}
                      renderDetailPanel={({ row }) => {
                        // Check if product details have been loaded
                        const details = macroatividadeDetails[row.id];
                        const currentMacroatividade = modeloServicoData.macroatividades?.find(m => m.value === row.original.value);

                        if (!details) {
                          // Trigger data fetching for this row, but only once
                          if (!loadingMacroatividadeRows || !loadingMacroatividadeRows.includes(row.id)) {
                            setLoadingMacroatividadeRows([...(loadingMacroatividadeRows || []), row.id]);
                            setMacroatividadeDetails({...macroatividadeDetails, [row.id]: {...modeloServicoData.macroatividades.find(m => m.value === row.original.value)}}); // Placeholder to avoid repeated fetches
                          }

                          return <div>Loading details...</div>;
                        }

                        return (
                          <div>
                            <FormGroup>
                              <span>Produtos</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable
                                isSearchable
                                isMulti
                                value={currentMacroatividade?.produtos || []}
                                options={modeloServicoData.produtos || []}
                                onChange={(selectedOptions, actionMeta) => {

                                const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        produtos: prev.produtos ? prev.produtos.map(p => {
                                          if (p.value === option.value) {
                                            return {
                                              ...p,
                                              macroatividades: p.macroatividades ? [...p.macroatividades, row.original] : [row.original],
                                            }
                                          } else {
                                            return p;
                                          }
                                        }) : [row.original],
                                        macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              produtos: m.produtos ? [...m.produtos, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if (removedValue.relacaoProdPropMacroatividade_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          produtos: prev.produtos && prev.produtos.map(p => {
                                            if (p.macroatividades?.some(m => m.relacaoProdPropMacroatividade_id === removedValue.relacaoProdPropMacroatividade_id)) {
                                              return {
                                                ...p,
                                                macroatividades: p.macroatividades ? p.macroatividades.filter(m => m.relacaoProdPropMacroatividade_id !== removedValue.relacaoProdPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                produtos: m.produtos ? m.produtos.filter(p => p.relacaoProdPropMacroatividade_id !== removedValue.relacaoProdPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          produtos: prev.produtos && prev.produtos.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                macroatividades: p.macroatividades ? p.macroatividades.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                produtos: m.produtos ? m.produtos.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <span>Eventos de pagamento</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable
                                isSearchable
                                isMulti
                                value={currentMacroatividade?.eventosPagamento || []}
                                options={modeloServicoData.eventosPagamento || []}
                                onChange={(selectedOptions, actionMeta) => {

                                  const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(ep => {
                                          if (ep.value === option.value) {
                                            return {
                                              ...ep,
                                              macroatividades: ep.macroatividades ? [...ep.macroatividades, row.original] : [row.original],
                                            }
                                          } else {
                                            return ep;
                                          }
                                        }) : [row.original],
                                        macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              eventosPagamento: m.eventosPagamento ? [...m.eventosPagamento, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if(removedValue.relacaoEventoPagamentoPropMacroatividade_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(p => {
                                            if (p.macroatividades?.some(m => m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.relacaoEventoPagamentoPropMacroatividade_id)) {
                                              return {
                                                ...p,
                                                macroatividades: p.macroatividades ? p.macroatividades.filter(m => m.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.relacaoEventoPagamentoPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                eventosPagamento: m.eventosPagamento ? m.eventosPagamento.filter(p => p.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.relacaoEventoPagamentoPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                macroatividades: p.macroatividades ? p.macroatividades.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                eventosPagamento: m.eventosPagamento ? m.eventosPagamento.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <span>Tempo estimado de execução para a macroatividade (dias)</span>
                              <Input
                                type="text"
                                value={
                                  modeloServicoData.macroatividades.find(
                                    m => m.value === row.original.value
                                  )?.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias ?? ""
                                }
                                onChange={e => {
                                  const onlyNumbers = e.target.value.replace(/\D/g, "");

                                  setModeloServicoData({
                                    ...modeloServicoData,
                                    macroatividades: modeloServicoData.macroatividades.map(m =>
                                      m.value === row.original.value
                                        ? {
                                            ...m,
                                            relacaoServicoMacroatividade_tempoEstimadoExecucaoDias:
                                              onlyNumbers === "" ? null : Number(onlyNumbers),
                                          }
                                        : m
                                    ),
                                  });
                                }}
                              />
                            </FormGroup>
                          </div>
                        )
                      }}
                    />
                  </FormGroup>
                </TabPanel>
                <TabPanel>
                  <FormGroup>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        Produtos
                      </span>
                      <Button
                        size="sm"
                        color="link"
                        className="ml-2 px-0"
                        onClick={(e)=>{
                          setModalProdPropOpen(true);
                        }}
                      >
                        Adicionar produto
                      </Button>
                    </div>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={true}
                      isSearchable={true}
                      value={modeloServicoData.produtos}
                      options={(prodsProp && prodsProp.length > 0) ?
                        prodsProp.map(m => {return {...m, modeloServico_nome: modeloServicoData.modeloServico_nome}}) :
                      []}
                      isMulti
                      onChange={(selectedOptions, actionMeta) => {
                        const { action, option, removedValue } = actionMeta;

                        // When selecting → duplicate with new value
                        if (action === 'select-option') {
                          setModeloServicoData(prev => ({
                            ...prev,
                            produtos: [
                              ...(prev.produtos || []),
                              {
                                ...option,
                                value: `${option.value}-${Date.now()}`
                              }
                            ]
                          }));
                          return;
                        }

                        // When removing / clearing → trust react-select
                        if (action === "remove-value" || action === "pop-value") {
                          setModeloServicoData(prev => ({
                            ...prev,
                            produtos: selectedOptions || [],
                            macroatividades: prev.macroatividades ? prev.macroatividades.map(p => {
                              if (
                                p.produtos &&
                                p.produtos.find(m =>
                                  m.relacaoProdPropMacroatividade_id &&
                                  m.relacaoProdPropMacroatividade_id === removedValue.macroatividades.find(p =>
                                    p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id
                                  )?.relacaoProdPropMacroatividade_id
                                )
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.relacaoProdPropMacroatividade_id !== removedValue.produtos.find(p => p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id)?.relacaoProdPropMacroatividade_id) };
                              } else if (
                                p.produtos &&
                                !p.produtos.find(m =>
                                  m.relacaoProdPropMacroatividade_id &&
                                  m.relacaoProdPropMacroatividade_id === removedValue.macroatividades.find(p =>
                                    p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id
                                  )?.relacaoProdPropMacroatividade_id
                                ) && p.produtos.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.produtos &&
                                !p.produtos.find(m =>
                                  !m.relacaoProdPropMacroatividade_id &&
                                  m.value === removedValue.macroatividades.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.produtos.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                            eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(p => {
                              if (
                                p.produtos &&
                                p.produtos.find(m =>
                                  m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.relacaoProdPropEventoPagamentoProp_id === removedValue.eventosPagamento.find(p =>
                                    p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id
                                  )?.relacaoProdPropEventoPagamentoProp_id
                                )
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.relacaoProdPropEventoPagamentoProp_id !== removedValue.eventosPagamento.find(p => p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id)?.relacaoProdPropEventoPagamentoProp_id) };
                              } else if (
                                p.produtos &&
                                !p.produtos.find(m =>
                                  m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.relacaoProdPropEventoPagamentoProp_id === removedValue.eventosPagamento.find(p =>
                                    p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id
                                  )?.relacaoProdPropEventoPagamentoProp_id
                                ) && p.produtos.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.produtos &&
                                !p.produtos.find(m =>
                                  !m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.value === removedValue.eventosPagamento.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.produtos.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                          }));
                        }

                        if (action === "clear") {
                          setModeloServicoData(prev => (
                            {
                              ...prev,
                              produtos: [],
                              macroatividades: prev.macroatividades && prev.macroatividades.map(p => {
                                return { ...p, produtos: []}
                              }),
                              eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(ep => {
                                return { ...ep, produtos: []}
                              }),
                            }
                          )); return;
                        }
                      }}
                    />
                    <MaterialReactTable
                      columns={columnsSelectedProdsProp}
                      data={modeloServicoData.produtos ? modeloServicoData.produtos : []}
                      initialState={{
                        density: 'compact',
                        expanded: {}, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 10 },
                        sorting: [], //sort by state by default,
                      }}
                      enableColumnResizing={true}
                      enableGrouping={false}
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(modeloServicoData.produtos && modeloServicoData.produtos.length > 10)}
                      muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                      muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                      muiTablePaginationProps={{
                        sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                        labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                        rowsPerPageOptions: [10, 50, 100],
                      }}
                      positionPagination='bottom'
                      muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                      enableDensityToggle={false}
                      enableColumnFilters={false}
                      muiTableHeadCellProps={{
                        sx: {
                          '.MuiSvgIcon-root': {fontSize: "18px"},
                          fontSize: '12px',
                          fontWeight: 'normal', // Remove bold text in the header
                          padding: '8px', // Adjust padding to reduce white space
                        },
                      }}
                      renderDetailPanel={({ row }) => {
                        // Check if product details have been loaded
                        const details = produtoDetails[row.id];
                        const currentProduto = modeloServicoData.produtos?.find(m => m.value === row.original.value);

                        if (!details) {
                          // Trigger data fetching for this row, but only once
                          if (!loadingProdutoRows || !loadingProdutoRows.includes(row.id)) {
                            setLoadingProdutoRows([...(loadingProdutoRows || []), row.id]);
                            setProdutoDetails({...produtoDetails, [row.id]: {macroatividades: [], eventosPagamento: []}}); // Placeholder to avoid repeated fetches
                          }

                          return <div>Loading details...</div>;
                        }

                        return (
                          <div>
                            <FormGroup>
                              <span>Macroatividades</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable={true}
                                isSearchable={true}
                                value={currentProduto?.macroatividades}
                                options={modeloServicoData.macroatividades || []}
                                isMulti
                                onChange={(selectedOptions, actionMeta) => {

                                const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        macroatividades: prev.macroatividades ? prev.macroatividades.map(p => {
                                          if (p.value === option.value) {
                                            return {
                                              ...p,
                                              produtos: p.produtos ? [...p.produtos, row.original] : [row.original],
                                            }
                                          } else {
                                            return p;
                                          }
                                        }) : [row.original],
                                        produtos: prev.produtos ? prev.produtos.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              macroatividades: m.macroatividades ? [...m.macroatividades, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if (removedValue.relacaoProdPropMacroatividade_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          macroatividades: prev.macroatividades && prev.macroatividades.map(p => {
                                            if (p.produtos?.some(m => m.relacaoProdPropMacroatividade_id === removedValue.relacaoProdPropMacroatividade_id)) {
                                              return {
                                                ...p,
                                                produtos: p.produtos ? p.produtos.filter(m => m.relacaoProdPropMacroatividade_id !== removedValue.relacaoProdPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          produtos: prev.produtos ? prev.produtos.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                macroatividades: m.macroatividades ? m.macroatividades.filter(p => p.relacaoProdPropMacroatividade_id !== removedValue.relacaoProdPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          macroatividades: prev.macroatividades && prev.macroatividades.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                produtos: p.produtos ? p.produtos.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          produtos: prev.produtos ? prev.produtos.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                macroatividades: m.macroatividades ? m.macroatividades.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <span>Eventos de pagamento</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable
                                isSearchable
                                isMulti
                                value={currentProduto?.eventosPagamento || []}
                                options={modeloServicoData.eventosPagamento || []}
                                onChange={(selectedOptions, actionMeta) => {

                                  const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(ep => {
                                          if (ep.value === option.value) {
                                            return {
                                              ...ep,
                                              produtos: ep.produtos ? [...ep.produtos, row.original] : [row.original],
                                            }
                                          } else {
                                            return ep;
                                          }
                                        }) : [row.original],
                                        produtos: prev.produtos ? prev.produtos.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              eventosPagamento: m.eventosPagamento ? [...m.eventosPagamento, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if(removedValue.relacaoProdPropEventoPagamentoProp_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(p => {
                                            if (p.produtos?.some(m => m.relacaoProdPropEventoPagamentoProp_id === removedValue.relacaoProdPropEventoPagamentoProp_id)) {
                                              return {
                                                ...p,
                                                produtos: p.produtos ? p.produtos.filter(m => m.relacaoProdPropEventoPagamentoProp_id !== removedValue.relacaoProdPropEventoPagamentoProp_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          produtos: prev.produtos ? prev.produtos.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                eventosPagamento: m.eventosPagamento ? m.eventosPagamento.filter(p => p.relacaoProdPropEventoPagamentoProp_id !== removedValue.relacaoProdPropEventoPagamentoProp_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                produtos: p.produtos ? p.produtos.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          produtos: prev.produtos ? prev.produtos.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                eventosPagamento: m.eventosPagamento ? m.eventosPagamento.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                          </div>
                        )
                      }}
                    />
                  </FormGroup>
                </TabPanel>
                <TabPanel>
                  <FormGroup>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        Eventos de pagamento
                      </span>
                      <Button
                        size="sm"
                        color="link"
                        className="ml-2 px-0"
                        onClick={(e)=>{
                          setIsEditingEventoPagamentoProp(false);
                          setEventoPagamentoPropData({});
                          setModalEpOpen(true);
                        }}
                      >
                        Adicionar evento de pagamento
                      </Button>
                    </div>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={true}
                      isSearchable={true}
                      value={modeloServicoData.eventosPagamento}
                      options={(eventosPagamentoProp && eventosPagamentoProp.length > 0) ?
                        eventosPagamentoProp.map(m => {return {...m, modeloServico_nome: modeloServicoData.modeloServico_nome}}) :
                      []}
                      isMulti
                      onChange={(selectedOptions, actionMeta) => {
                        const { action, option, removedValue } = actionMeta;

                        // When selecting → duplicate with new value
                        if (action === 'select-option') {
                          setModeloServicoData(prev => ({
                            ...prev,
                            eventosPagamento: [
                              ...(prev.eventosPagamento || []),
                              {
                                ...option,
                                value: `${option.value}-${Date.now()}`
                              }
                            ]
                          }));
                          return;
                        }

                        // When removing / clearing → trust react-select
                        if (action === "remove-value" || action === "pop-value") {
                          setModeloServicoData(prev => ({
                            ...prev,
                            eventosPagamento: selectedOptions || [],
                            macroatividades: prev.macroatividades ? prev.macroatividades.map(p => {
                              if (
                                p.eventosPagamento &&
                                p.eventosPagamento.find(m =>
                                  m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.macroatividades.find(p =>
                                    p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id
                                  )?.relacaoEventoPagamentoPropMacroatividade_id
                                )
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.eventosPagamento.find(p => p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id)?.relacaoEventoPagamentoPropMacroatividade_id) };
                              } else if (
                                p.eventosPagamento &&
                                !p.eventosPagamento.find(m =>
                                  m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.macroatividades.find(p =>
                                    p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id
                                  )?.relacaoEventoPagamentoPropMacroatividade_id
                                ) && p.eventosPagamento.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.eventosPagamento &&
                                !p.eventosPagamento.find(m =>
                                  !m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.value === removedValue.macroatividades.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.eventosPagamento.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                            produtos: prev.produtos ? prev.produtos.map(p => {
                              if (
                                p.eventosPagamento &&
                                p.eventosPagamento.find(m =>
                                  m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.relacaoProdPropEventoPagamentoProp_id === removedValue.produtos.find(p =>
                                    p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id
                                  )?.relacaoProdPropEventoPagamentoProp_id
                                )
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.relacaoProdPropEventoPagamentoProp_id !== removedValue.eventosPagamento.find(p => p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id)?.relacaoProdPropEventoPagamentoProp_id) };
                              } else if (
                                p.eventosPagamento &&
                                !p.eventosPagamento.find(m =>
                                  m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.relacaoProdPropEventoPagamentoProp_id === removedValue.produtos.find(p =>
                                    p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id
                                  )?.relacaoProdPropEventoPagamentoProp_id
                                ) && p.eventosPagamento.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.eventosPagamento &&
                                !p.eventosPagamento.find(m =>
                                  !m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.value === removedValue.produtos.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.eventosPagamento.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                          }));
                        }

                        if (action === "clear") {
                          setModeloServicoData(prev => (
                            {
                              ...prev,
                              eventosPagamento: [],
                              produtos: prev.produtos && prev.produtos.map(p => {
                                return { ...p, eventosPagamento: []}
                              }),
                              macroatividades: prev.macroatividades && prev.macroatividades.map(ep => {
                                return { ...ep, eventosPagamento: []}
                              }),
                            }
                          )); return;
                        }
                      }}
                    />
                    <MaterialReactTable
                      columns={columnsSelectedEventosPagamentoProp}
                      data={modeloServicoData.eventosPagamento ? modeloServicoData.eventosPagamento : []}
                      initialState={{
                        density: 'compact',
                        expanded: {}, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 10 },
                        sorting: [], //sort by state by default,
                      }}
                      enableColumnResizing={true}
                      enableGrouping={false}
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(modeloServicoData.eventosPagamento && modeloServicoData.eventosPagamento.length > 10)}
                      muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                      muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                      muiTablePaginationProps={{
                        sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                        labelRowsPerPage: <span style={{fontSize: "12px"}}>Eventos de pagamento por página</span>,
                        rowsPerPageOptions: [10, 50, 100],
                      }}
                      positionPagination='bottom'
                      muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                      enableDensityToggle={false}
                      enableColumnFilters={false}
                      muiTableHeadCellProps={{
                        sx: {
                          '.MuiSvgIcon-root': {fontSize: "18px"},
                          fontSize: '12px',
                          fontWeight: 'normal', // Remove bold text in the header
                          padding: '8px', // Adjust padding to reduce white space
                        },
                      }}
                      renderDetailPanel={({ row }) => {
                        // Check if product details have been loaded
                        const details = eventoPagamentoDetails[row.id];
                        const currentEventoPagamento = modeloServicoData.eventosPagamento?.find(m => m.value === row.original.value);

                        if (!details) {
                          // Trigger data fetching for this row, but only once
                          if (!loadingEventoPagamentoRows || !loadingEventoPagamentoRows.includes(row.id)) {
                            setLoadingEventoPagamentoRows([...(loadingEventoPagamentoRows || []), row.id]);
                            setEventoPagamentoDetails({...eventoPagamentoDetails, [row.id]: {macroatividades: [], produtos: []}}); // Placeholder to avoid repeated fetches
                          }

                          return <div>Loading details...</div>;
                        }

                        return (
                          <div>
                            <FormGroup>
                              <span>Macroatividades</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable={true}
                                isSearchable={true}
                                value={currentEventoPagamento?.macroatividades}
                                options={modeloServicoData.macroatividades || []}
                                isMulti
                                onChange={(selectedOptions, actionMeta) => {

                                const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        macroatividades: prev.macroatividades ? prev.macroatividades.map(p => {
                                          if (p.value === option.value) {
                                            return {
                                              ...p,
                                              eventosPagamento: p.eventosPagamento ? [...p.eventosPagamento, row.original] : [row.original],
                                            }
                                          } else {
                                            return p;
                                          }
                                        }) : [row.original],
                                        eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              macroatividades: m.macroatividades ? [...m.macroatividades, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if (removedValue.relacaoEventoPagamentoPropMacroatividade_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          macroatividades: prev.macroatividades && prev.macroatividades.map(p => {
                                            if (p.eventosPagamento?.some(m => m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.relacaoEventoPagamentoPropMacroatividade_id)) {
                                              return {
                                                ...p,
                                                eventosPagamento: p.eventosPagamento ? p.eventosPagamento.filter(m => m.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.relacaoEventoPagamentoPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                macroatividades: m.macroatividades ? m.macroatividades.filter(p => p.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.relacaoEventoPagamentoPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          macroatividades: prev.macroatividades && prev.macroatividades.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                eventosPagamento: p.eventosPagamento ? p.eventosPagamento.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                macroatividades: m.macroatividades ? m.macroatividades.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <span>Produtos</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable={true}
                                isSearchable={true}
                                value={currentEventoPagamento?.produtos}
                                options={modeloServicoData.produtos || []}
                                isMulti
                                onChange={(selectedOptions, actionMeta) => {

                                const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        produtos: prev.produtos ? prev.produtos.map(p => {
                                          if (p.value === option.value) {
                                            return {
                                              ...p,
                                              eventosPagamento: p.eventosPagamento ? [...p.eventosPagamento, row.original] : [row.original],
                                            }
                                          } else {
                                            return p;
                                          }
                                        }) : [row.original],
                                        eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              produtos: m.produtos ? [...m.produtos, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if (removedValue.relacaoProdPropEventoPagamentoProp_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          produtos: prev.produtos && prev.produtos.map(p => {
                                            if (p.eventosPagamento?.some(m => m.relacaoProdPropEventoPagamentoProp_id === removedValue.relacaoProdPropEventoPagamentoProp_id)) {
                                              return {
                                                ...p,
                                                eventosPagamento: p.eventosPagamento ? p.eventosPagamento.filter(m => m.relacaoProdPropEventoPagamentoProp_id !== removedValue.relacaoProdPropEventoPagamentoProp_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                produtos: m.produtos ? m.produtos.filter(p => p.relacaoProdPropEventoPagamentoProp_id !== removedValue.relacaoProdPropEventoPagamentoProp_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          produtos: prev.produtos && prev.produtos.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                eventosPagamento: p.eventosPagamento ? p.eventosPagamento.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                produtos: m.produtos ? m.produtos.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <span>Valor (%)</span>
                              <MaskedInput
                                unmask
                                mask="num %"
                                blocks={{
                                  num: {
                                    mask: Number,
                                    scale: 2, // digits after point 0 for integers
                                    signed: false, // disallow negative
                                    thousandsSeparator: '.', // any single char
                                    padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                                    normalizeZeros: false, // appends or removes zeros at ends
                                    radix: ',', // fractional delimiter
                                    min: 0,
                                    max: 100,
                                  },
                                }}
                                lazy={false}
                                value={String(modeloServicoData.eventosPagamento.find(ep => ep.value === row.original.value).relacaoServicoEventoPagamentoProp_vlr || "")}
                                onAccept={value => {
                                  setModeloServicoData({
                                    ...modeloServicoData,
                                    eventosPagamento: modeloServicoData.eventosPagamento.map(ep =>
                                      ep.value === row.original.value
                                        ? { ...ep, relacaoServicoEventoPagamentoProp_vlr: value || null }
                                        : ep
                                    )
                                  });
                                }}
                              />
                            </FormGroup>
                          </div>
                        )
                      }}
                    />
                  </FormGroup>
                </TabPanel>
              </Tabs>
            </TabPanel>
          </Tabs>

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => setModalAddServicoOpen(false)}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={async () => {
                await handleSaveModeloServico()
              }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal
        size='lg'
        centered={false}
        isOpen={modalEditServicoOpen}
        toggle={() => setModalEditServicoOpen(false)}
      >
        <ModalHeader>Editar Serviço {modeloServicoData.modeloServico_nome}</ModalHeader>

        <ModalBody>
          <Tabs>
            <TabList>
              <Tab>Composição de serviços</Tab>
              <Tab>Serviços Principal ou secundário</Tab>
            </TabList>
            <TabPanel>
              <FormGroup>
                <span onClick={() => console.log(modeloServicoData)}>
                  Nome do modelo da composição de serviços
                </span>
                <Input
                  value={modeloServicoData.modeloServico_nome ? modeloServicoData.modeloServico_nome : null}
                  onChange={e => setModeloServicoData({...modeloServicoData, modeloServico_nome: e.target.value})}
                />
              </FormGroup>
              <FormGroup>
                <span>
                  Serviços que compõem a composição de serviços
                </span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  isMulti
                  options={modelosServicos}
                  //value={modeloServicoData.modeloServico_ids ? [...modeloServicoData.modeloServico_ids.filter(ms => ms.servicoComposto && !ms.modeloServico_primario).map(ms => modelosServicos.find(option => option.value === ms.modeloServico_id))] : []}
                  onChange={async (e) => {
                    setIsLoadingSelected(true);
                    if (e) {

                    } else {

                    }
                    setIsLoadingSelected(false);
                  }}
                />
              </FormGroup>
            </TabPanel>
            <TabPanel>
              <Tabs>
                <TabList>
                  <Tab>Geral</Tab>
                  <Tab>Macroatividades</Tab>
                  <Tab>Produtos</Tab>
                  <Tab>Eventos de Pagamento</Tab>
                </TabList>
                <TabPanel>
                  <FormGroup>
                    <span>
                      Nome do modelo do serviço
                    </span>
                    <Input
                      value={modeloServicoData.modeloServico_nome ? modeloServicoData.modeloServico_nome : null}
                      onChange={e => setModeloServicoData({...modeloServicoData, modeloServico_nome: e.target.value})}
                    />
                  </FormGroup>
                  <FormGroup>
                    <span>
                      Início do prazo para execução (dias)
                    </span>
                    <Input
                      value={(!isNaN(Number(modeloServicoData.modeloServico_prazoInicio)) && modeloServicoData.modeloServico_prazoInicio === 0) ? modeloServicoData.modeloServico_prazoInicio : null}
                      onChange={e => {
                        if ((!e.target.value && Number(e.target.value) !== 0) || isNaN(Number(e.target.value))) {
                          setModeloServicoData({...modeloServicoData, modeloServico_prazoInicio: null})
                        } else {
                          setModeloServicoData({...modeloServicoData, modeloServico_prazoInicio: Number(e.target.value)})
                        }
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <span>
                      Fim do prazo para execução (dias)
                    </span>
                    <Input
                      value={(modeloServicoData.modeloServico_prazoFim && modeloServicoData.modeloServico_prazoFim !== 0) ? modeloServicoData.modeloServico_prazoFim : null}
                      onChange={e => {
                        if ((!e.target.value && Number(e.target.value) !== 0) || isNaN(Number(e.target.value))) {
                          setModeloServicoData({...modeloServicoData, modeloServico_prazoFim: null})
                        } else {
                          setModeloServicoData({...modeloServicoData, modeloServico_prazoFim: Number(e.target.value)})
                        }
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <span>
                      Serviço principal
                    </span>
                    <input type="checkbox" name="servico-primario" id="servico-primario" checked={modeloServicoData.modeloServico_primario === 1} onChange={(e) => {
                      if(modeloServicoData.modeloServico_secundario){
                        setModeloServicoData({...modeloServicoData, modeloServico_secundario: 0, modeloServico_primario: e.target.checked ? 1 : 0} )
                      } else {
                        setModeloServicoData({...modeloServicoData, modeloServico_primario: e.target.checked ? 1 : 0})
                      }
                    }}/>
                    <span>
                      Serviço secundário
                    </span>
                    <input type="checkbox" name="servico-secundario" id="servico-secundario" checked={modeloServicoData.modeloServico_secundario === 1} onChange={(e) => {
                      if(modeloServicoData.modeloServico_primario){
                        setModeloServicoData({...modeloServicoData, modeloServico_primario: 0, modeloServico_secundario: e.target.checked ? 1 : 0} )
                      } else {
                        setModeloServicoData({...modeloServicoData, modeloServico_secundario: e.target.checked ? 1 : 0})
                      }
                    }}/>
                  </FormGroup>
                </TabPanel>
                <TabPanel>
                  <FormGroup>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        Macroatividades
                      </span>
                      <Button
                        size="sm"
                        color="link"
                        className="ml-2 px-0"
                        onClick={(e)=>{
                          setIsEditingMacroatividade(false);
                          setMacroatividadeData({});
                          setModalMacroatividadeOpen(true);
                        }}
                      >
                        Adicionar macroatividade
                      </Button>
                    </div>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={true}
                      isSearchable={true}
                      value={modeloServicoData.macroatividades || []}
                      options={(macroatividades && macroatividades.length > 0) ? macroatividades : []}
                      isMulti
                      onChange={async (selectedOptions, actionMeta) => {
                        const { action, option, removedValue } = actionMeta;

                        // When selecting → duplicate with new value
                        if (action === 'select-option') {
                          setModeloServicoData(prev => ({
                            ...prev,
                            macroatividades: [
                              ...(prev.macroatividades || []),
                              {
                                ...option,
                                value: `${option.value}-${Date.now()}`
                              }
                            ]
                          }));
                          return;
                        }

                        // When removing / clearing → trust react-select
                        if (action === "remove-value" || action === "pop-value") {
                          setModeloServicoData(prev => ({
                            ...prev,
                            macroatividades: selectedOptions || [],
                            produtos: prev.produtos ? prev.produtos.map(p => {
                              if (
                                p.macroatividades &&
                                p.macroatividades.find(m =>
                                  m.relacaoProdPropMacroatividade_id &&
                                  m.relacaoProdPropMacroatividade_id === removedValue.produtos.find(p =>
                                    p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id
                                  )?.relacaoProdPropMacroatividade_id
                                )
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.relacaoProdPropMacroatividade_id !== removedValue.produtos.find(p => p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id)?.relacaoProdPropMacroatividade_id) };
                              } else if (
                                p.macroatividades &&
                                !p.macroatividades.find(m =>
                                  m.relacaoProdPropMacroatividade_id &&
                                  m.relacaoProdPropMacroatividade_id === removedValue.produtos.find(p =>
                                    p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id
                                  )?.relacaoProdPropMacroatividade_id
                                ) && p.macroatividades.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.macroatividades &&
                                !p.macroatividades.find(m =>
                                  !m.relacaoProdPropMacroatividade_id &&
                                  m.value === removedValue.produtos.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.macroatividades.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                            eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(p => {
                              if (
                                p.macroatividades &&
                                p.macroatividades.find(m =>
                                  m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.eventosPagamento.find(p =>
                                    p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id
                                  )?.relacaoEventoPagamentoPropMacroatividade_id
                                )
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.eventosPagamento.find(p => p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id)?.relacaoEventoPagamentoPropMacroatividade_id) };
                              } else if (
                                p.macroatividades &&
                                !p.macroatividades.find(m =>
                                  m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.eventosPagamento.find(p =>
                                    p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id
                                  )?.relacaoEventoPagamentoPropMacroatividade_id
                                ) && p.macroatividades.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.macroatividades &&
                                !p.macroatividades.find(m =>
                                  !m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.value === removedValue.eventosPagamento.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.macroatividades.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, macroatividades: p.macroatividades.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                          }));
                        }

                        if (action === "clear") {
                          console.log('actionMeta', actionMeta)
                          setModeloServicoData(prev => (
                            {
                              ...prev,
                              macroatividades: [],
                              produtos: prev.produtos && prev.produtos.map(p => {
                                return { ...p, macroatividades: []}
                              }),
                              eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(ep => {
                                return { ...ep, macroatividades: []}
                              }),
                            }
                          )); return;
                        }
                      }}
                    />
                    <MaterialReactTable
                      columns={columnsSelectedMacroatividades}
                      data={modeloServicoData.macroatividades ? modeloServicoData.macroatividades : []}
                      initialState={{
                        density: 'compact',
                        expanded: {}, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 10 },
                        sorting: [], //sort by state by default,
                      }}
                      enableColumnResizing={true}
                      enableGrouping={false}
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(modeloServicoData.macroatividades && modeloServicoData.macroatividades.length > 10)}
                      muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                      muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                      muiTablePaginationProps={{
                        sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                        labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                        rowsPerPageOptions: [10, 50, 100],
                      }}
                      positionPagination='bottom'
                      muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                      enableDensityToggle={false}
                      enableColumnFilters={false}
                      muiTableHeadCellProps={{
                        sx: {
                          '.MuiSvgIcon-root': {fontSize: "18px"},
                          fontSize: '12px',
                          fontWeight: 'normal', // Remove bold text in the header
                          padding: '8px', // Adjust padding to reduce white space
                        },
                      }}
                      renderDetailPanel={({ row }) => {
                        // Check if product details have been loaded
                        const details = macroatividadeDetails[row.id];
                        const currentMacroatividade = modeloServicoData.macroatividades?.find(m => m.value === row.original.value);

                        if (!details) {
                          // Trigger data fetching for this row, but only once
                          if (!loadingMacroatividadeRows || !loadingMacroatividadeRows.includes(row.id)) {
                            setLoadingMacroatividadeRows([...(loadingMacroatividadeRows || []), row.id]);
                            setMacroatividadeDetails({...macroatividadeDetails, [row.id]: {...modeloServicoData.macroatividades.find(m => m.value === row.original.value)}}); // Placeholder to avoid repeated fetches
                          }

                          return <div>Loading details...</div>;
                        }

                        return (
                          <div>
                            <FormGroup>
                              <span>Produtos</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable
                                isMulti
                                isClearable={false}
                                value={currentMacroatividade?.produtos || []}
                                options={modeloServicoData.produtos || []}
                                onChange={(selectedOptions, actionMeta) => {

                                const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        produtos: prev.produtos ? prev.produtos.map(p => {
                                          if (p.value === option.value) {
                                            return {
                                              ...p,
                                              macroatividades: p.macroatividades ? [...p.macroatividades, row.original] : [row.original],
                                            }
                                          } else {
                                            return p;
                                          }
                                        }) : [row.original],
                                        macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              produtos: m.produtos ? [...m.produtos, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if (removedValue.relacaoProdPropMacroatividade_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          produtos: prev.produtos && prev.produtos.map(p => {
                                            if (p.macroatividades?.some(m => m.relacaoProdPropMacroatividade_id === removedValue.relacaoProdPropMacroatividade_id)) {
                                              return {
                                                ...p,
                                                macroatividades: p.macroatividades ? p.macroatividades.filter(m => m.relacaoProdPropMacroatividade_id !== removedValue.relacaoProdPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                produtos: m.produtos ? m.produtos.filter(p => p.relacaoProdPropMacroatividade_id !== removedValue.relacaoProdPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          produtos: prev.produtos && prev.produtos.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                macroatividades: p.macroatividades ? p.macroatividades.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                produtos: m.produtos ? m.produtos.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <span>Eventos de pagamento</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable
                                isMulti
                                isClearable={false}
                                value={currentMacroatividade?.eventosPagamento || []}
                                options={modeloServicoData.eventosPagamento || []}
                                onChange={(selectedOptions, actionMeta) => {

                                  const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(ep => {
                                          if (ep.value === option.value) {
                                            return {
                                              ...ep,
                                              macroatividades: ep.macroatividades ? [...ep.macroatividades, row.original] : [row.original],
                                            }
                                          } else {
                                            return ep;
                                          }
                                        }) : [row.original],
                                        macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              eventosPagamento: m.eventosPagamento ? [...m.eventosPagamento, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if(removedValue.relacaoEventoPagamentoPropMacroatividade_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(p => {
                                            if (p.macroatividades?.some(m => m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.relacaoEventoPagamentoPropMacroatividade_id)) {
                                              return {
                                                ...p,
                                                macroatividades: p.macroatividades ? p.macroatividades.filter(m => m.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.relacaoEventoPagamentoPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                eventosPagamento: m.eventosPagamento ? m.eventosPagamento.filter(p => p.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.relacaoEventoPagamentoPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                macroatividades: p.macroatividades ? p.macroatividades.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          macroatividades: prev.macroatividades ? prev.macroatividades.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                eventosPagamento: m.eventosPagamento ? m.eventosPagamento.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <span>Tempo estimado de execução para a macroatividade (dias)</span>
                              <Input
                                type="text"
                                value={
                                  modeloServicoData.macroatividades.find(
                                    m => m.value === row.original.value
                                  )?.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias ?? ""
                                }
                                onChange={e => {
                                  const onlyNumbers = e.target.value.replace(/\D/g, "");

                                  setModeloServicoData({
                                    ...modeloServicoData,
                                    macroatividades: modeloServicoData.macroatividades.map(m =>
                                      m.value === row.original.value
                                        ? {
                                            ...m,
                                            relacaoServicoMacroatividade_tempoEstimadoExecucaoDias:
                                              onlyNumbers === "" ? null : Number(onlyNumbers),
                                          }
                                        : m
                                    ),
                                  });
                                }}
                              />
                            </FormGroup>
                          </div>
                        )
                      }}
                    />
                  </FormGroup>
                </TabPanel>
                <TabPanel>
                  <FormGroup>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        Produtos
                      </span>
                      <Button
                        size="sm"
                        color="link"
                        className="ml-2 px-0"
                        onClick={(e)=>{
                          setModalProdPropOpen(true);
                        }}
                      >
                        Adicionar produto
                      </Button>
                    </div>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={true}
                      isSearchable={true}
                      value={modeloServicoData.produtos || []}
                      options={(prodsProp && prodsProp.length > 0 && modeloServicoData.produtos?.length > 0) ?
                        prodsProp.filter(ma => modeloServicoData.produtos.filter(mas => mas.value === ma.value).length === 0) :
                      prodsProp}
                      isMulti
                      onChange={async (selectedOptions, actionMeta) => {
                        const { action, option, removedValue } = actionMeta;

                        // When selecting → duplicate with new value
                        if (action === 'select-option') {
                          setModeloServicoData(prev => ({
                            ...prev,
                            produtos: [
                              ...(prev.produtos || []),
                              {
                                ...option,
                                value: `${option.value}-${Date.now()}`
                              }
                            ]
                          }));
                          return;
                        }

                        // When removing / clearing → trust react-select
                        if (action === "remove-value" || action === "pop-value") {
                          setModeloServicoData(prev => ({
                            ...prev,
                            produtos: selectedOptions || [],
                            macroatividades: prev.macroatividades ? prev.macroatividades.map(p => {
                              if (
                                p.produtos &&
                                p.produtos.find(m =>
                                  m.relacaoProdPropMacroatividade_id &&
                                  m.relacaoProdPropMacroatividade_id === removedValue.macroatividades.find(p =>
                                    p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id
                                  )?.relacaoProdPropMacroatividade_id
                                )
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.relacaoProdPropMacroatividade_id !== removedValue.produtos.find(p => p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id)?.relacaoProdPropMacroatividade_id) };
                              } else if (
                                p.produtos &&
                                !p.produtos.find(m =>
                                  m.relacaoProdPropMacroatividade_id &&
                                  m.relacaoProdPropMacroatividade_id === removedValue.macroatividades.find(p =>
                                    p.relacaoProdPropMacroatividade_id === m.relacaoProdPropMacroatividade_id
                                  )?.relacaoProdPropMacroatividade_id
                                ) && p.produtos.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.produtos &&
                                !p.produtos.find(m =>
                                  !m.relacaoProdPropMacroatividade_id &&
                                  m.value === removedValue.macroatividades.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.produtos.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                            eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(p => {
                              if (
                                p.produtos &&
                                p.produtos.find(m =>
                                  m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.relacaoProdPropEventoPagamentoProp_id === removedValue.eventosPagamento.find(p =>
                                    p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id
                                  )?.relacaoProdPropEventoPagamentoProp_id
                                )
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.relacaoProdPropEventoPagamentoProp_id !== removedValue.eventosPagamento.find(p => p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id)?.relacaoProdPropEventoPagamentoProp_id) };
                              } else if (
                                p.produtos &&
                                !p.produtos.find(m =>
                                  m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.relacaoProdPropEventoPagamentoProp_id === removedValue.eventosPagamento.find(p =>
                                    p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id
                                  )?.relacaoProdPropEventoPagamentoProp_id
                                ) && p.produtos.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.produtos &&
                                !p.produtos.find(m =>
                                  !m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.value === removedValue.eventosPagamento.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.produtos.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, produtos: p.produtos.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                          }));
                        }

                        if (action === "clear") {
                          setModeloServicoData(prev => (
                            {
                              ...prev,
                              produtos: [],
                              macroatividades: prev.macroatividades && prev.macroatividades.map(p => {
                                return { ...p, produtos: []}
                              }),
                              eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(ep => {
                                return { ...ep, produtos: []}
                              }),
                            }
                          )); return;
                        }
                      }}
                    />
                    <MaterialReactTable
                      columns={columnsSelectedProdsProp}
                      data={modeloServicoData.produtos ? modeloServicoData.produtos : []}
                      initialState={{
                        density: 'compact',
                        expanded: {}, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 10 },
                        sorting: [], //sort by state by default,
                      }}
                      enableColumnResizing={true}
                      enableGrouping={false}
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(modeloServicoData.produtos && modeloServicoData.produtos.length > 10)}
                      muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                      muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                      muiTablePaginationProps={{
                        sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                        labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                        rowsPerPageOptions: [10, 50, 100],
                      }}
                      positionPagination='bottom'
                      muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                      enableDensityToggle={false}
                      enableColumnFilters={false}
                      muiTableHeadCellProps={{
                        sx: {
                          '.MuiSvgIcon-root': {fontSize: "18px"},
                          fontSize: '12px',
                          fontWeight: 'normal', // Remove bold text in the header
                          padding: '8px', // Adjust padding to reduce white space
                        },
                      }}
                      renderDetailPanel={({ row }) => {
                        // Check if product details have been loaded
                        const details = produtoDetails[row.id];
                        const currentProduto = modeloServicoData.produtos?.find(m => m.value === row.original.value);

                        if (!details) {
                          // Trigger data fetching for this row, but only once
                          if (!loadingProdutoRows || !loadingProdutoRows.includes(row.id)) {
                            setLoadingProdutoRows([...(loadingProdutoRows || []), row.id]);
                            setProdutoDetails({...produtoDetails, [row.id]: {macroatividades: [], eventosPagamento: []}}); // Placeholder to avoid repeated fetches
                          }

                          return <div>Loading details...</div>;
                        }

                        return (
                          <div>
                            <FormGroup>
                              <span>Macroatividades</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable={false}
                                isSearchable={true}
                                value={currentProduto?.macroatividades}
                                options={modeloServicoData.macroatividades || []}
                                isMulti
                                onChange={(selectedOptions, actionMeta) => {

                                const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        macroatividades: prev.macroatividades ? prev.macroatividades.map(p => {
                                          if (p.value === option.value) {
                                            return {
                                              ...p,
                                              produtos: p.produtos ? [...p.produtos, row.original] : [row.original],
                                            }
                                          } else {
                                            return p;
                                          }
                                        }) : [row.original],
                                        produtos: prev.produtos ? prev.produtos.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              macroatividades: m.macroatividades ? [...m.macroatividades, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if (removedValue.relacaoProdPropMacroatividade_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          macroatividades: prev.macroatividades && prev.macroatividades.map(p => {
                                            if (p.produtos?.some(m => m.relacaoProdPropMacroatividade_id === removedValue.relacaoProdPropMacroatividade_id)) {
                                              return {
                                                ...p,
                                                produtos: p.produtos ? p.produtos.filter(m => m.relacaoProdPropMacroatividade_id !== removedValue.relacaoProdPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          produtos: prev.produtos ? prev.produtos.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                macroatividades: m.macroatividades ? m.macroatividades.filter(p => p.relacaoProdPropMacroatividade_id !== removedValue.relacaoProdPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          macroatividades: prev.macroatividades && prev.macroatividades.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                produtos: p.produtos ? p.produtos.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          produtos: prev.produtos ? prev.produtos.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                macroatividades: m.macroatividades ? m.macroatividades.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <span>Eventos de pagamento</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable={false}
                                isSearchable
                                isMulti
                                value={currentProduto?.eventosPagamento || []}
                                options={modeloServicoData.eventosPagamento || []}
                                onChange={(selectedOptions, actionMeta) => {

                                  const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(ep => {
                                          if (ep.value === option.value) {
                                            return {
                                              ...ep,
                                              produtos: ep.produtos ? [...ep.produtos, row.original] : [row.original],
                                            }
                                          } else {
                                            return ep;
                                          }
                                        }) : [row.original],
                                        produtos: prev.produtos ? prev.produtos.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              eventosPagamento: m.eventosPagamento ? [...m.eventosPagamento, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if(removedValue.relacaoProdPropEventoPagamentoProp_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(p => {
                                            if (p.produtos?.some(m => m.relacaoProdPropEventoPagamentoProp_id === removedValue.relacaoProdPropEventoPagamentoProp_id)) {
                                              return {
                                                ...p,
                                                produtos: p.produtos ? p.produtos.filter(m => m.relacaoProdPropEventoPagamentoProp_id !== removedValue.relacaoProdPropEventoPagamentoProp_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          produtos: prev.produtos ? prev.produtos.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                eventosPagamento: m.eventosPagamento ? m.eventosPagamento.filter(p => p.relacaoProdPropEventoPagamentoProp_id !== removedValue.relacaoProdPropEventoPagamentoProp_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          eventosPagamento: prev.eventosPagamento && prev.eventosPagamento.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                produtos: p.produtos ? p.produtos.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          produtos: prev.produtos ? prev.produtos.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                eventosPagamento: m.eventosPagamento ? m.eventosPagamento.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                          </div>
                        )
                      }}
                    />
                  </FormGroup>
                </TabPanel>
                <TabPanel>
                  <FormGroup>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        Eventos de pagamento
                      </span>
                      <Button
                        size="sm"
                        color="link"
                        className="ml-2 px-0"
                        onClick={(e)=>{
                          setIsEditingEventoPagamentoProp(false);
                          setEventoPagamentoPropData({});
                          setModalEpOpen(true);
                        }}
                      >
                        Adicionar evento de pagamento
                      </Button>
                    </div>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={true}
                      isSearchable={true}
                      value={modeloServicoData.eventosPagamento || []}
                      options={(eventosPagamentoProp && eventosPagamentoProp.length > 0 && modeloServicoData.eventosPagamento?.length > 0) ?
                        eventosPagamentoProp.filter(ma => modeloServicoData.eventosPagamento.filter(mas => mas.value === ma.value).length === 0) :
                      eventosPagamentoProp}
                      isMulti
                      onChange={(selectedOptions, actionMeta) => {
                        const { action, option, removedValue } = actionMeta;

                        // When selecting → duplicate with new value
                        if (action === 'select-option') {
                          setModeloServicoData(prev => ({
                            ...prev,
                            eventosPagamento: [
                              ...(prev.eventosPagamento || []),
                              {
                                ...option,
                                value: `${option.value}-${Date.now()}`
                              }
                            ]
                          }));
                          return;
                        }

                        // When removing / clearing → trust react-select
                        if (action === "remove-value" || action === "pop-value") {
                          setModeloServicoData(prev => ({
                            ...prev,
                            eventosPagamento: selectedOptions || [],
                            macroatividades: prev.macroatividades ? prev.macroatividades.map(p => {
                              if (
                                p.eventosPagamento &&
                                p.eventosPagamento.find(m =>
                                  m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.macroatividades.find(p =>
                                    p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id
                                  )?.relacaoEventoPagamentoPropMacroatividade_id
                                )
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.eventosPagamento.find(p => p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id)?.relacaoEventoPagamentoPropMacroatividade_id) };
                              } else if (
                                p.eventosPagamento &&
                                !p.eventosPagamento.find(m =>
                                  m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.macroatividades.find(p =>
                                    p.relacaoEventoPagamentoPropMacroatividade_id === m.relacaoEventoPagamentoPropMacroatividade_id
                                  )?.relacaoEventoPagamentoPropMacroatividade_id
                                ) && p.eventosPagamento.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.eventosPagamento &&
                                !p.eventosPagamento.find(m =>
                                  !m.relacaoEventoPagamentoPropMacroatividade_id &&
                                  m.value === removedValue.macroatividades.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.eventosPagamento.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                            produtos: prev.produtos ? prev.produtos.map(p => {
                              if (
                                p.eventosPagamento &&
                                p.eventosPagamento.find(m =>
                                  m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.relacaoProdPropEventoPagamentoProp_id === removedValue.produtos.find(p =>
                                    p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id
                                  )?.relacaoProdPropEventoPagamentoProp_id
                                )
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.relacaoProdPropEventoPagamentoProp_id !== removedValue.eventosPagamento.find(p => p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id)?.relacaoProdPropEventoPagamentoProp_id) };
                              } else if (
                                p.eventosPagamento &&
                                !p.eventosPagamento.find(m =>
                                  m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.relacaoProdPropEventoPagamentoProp_id === removedValue.produtos.find(p =>
                                    p.relacaoProdPropEventoPagamentoProp_id === m.relacaoProdPropEventoPagamentoProp_id
                                  )?.relacaoProdPropEventoPagamentoProp_id
                                ) && p.eventosPagamento.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.value !== removedValue.value) };
                              } else if (
                                p.eventosPagamento &&
                                !p.eventosPagamento.find(m =>
                                  !m.relacaoProdPropEventoPagamentoProp_id &&
                                  m.value === removedValue.produtos.find(p =>
                                    p.value === m.value
                                  )?.value
                                ) && p.eventosPagamento.find(m => m.value === removedValue.value)
                              ) {
                                return { ...p, eventosPagamento: p.eventosPagamento.filter(m => m.value !== removedValue.value) };
                              }
                              else {
                                return p;
                              }
                            }) : [],
                          }));
                        }

                        if (action === "clear") {
                          setModeloServicoData(prev => (
                            {
                              ...prev,
                              eventosPagamento: [],
                              produtos: prev.produtos && prev.produtos.map(p => {
                                return { ...p, eventosPagamento: []}
                              }),
                              macroatividades: prev.macroatividades && prev.macroatividades.map(ep => {
                                return { ...ep, eventosPagamento: []}
                              }),
                            }
                          )); return;
                        }
                      }}
                    />
                    <MaterialReactTable
                      columns={columnsSelectedEventosPagamentoProp}
                      data={modeloServicoData.eventosPagamento ? modeloServicoData.eventosPagamento : []}
                      initialState={{
                        density: 'compact',
                        expanded: {}, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 10 },
                        sorting: [], //sort by state by default,
                      }}
                      enableColumnResizing={true}
                      enableGrouping={false}
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(modeloServicoData.eventosPagamento && modeloServicoData.eventosPagamento.length > 10)}
                      muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                      muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                      muiTablePaginationProps={{
                        sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                        labelRowsPerPage: <span style={{fontSize: "12px"}}>Eventos de pagamento por página</span>,
                        rowsPerPageOptions: [10, 50, 100],
                      }}
                      positionPagination='bottom'
                      muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                      enableDensityToggle={false}
                      enableColumnFilters={false}
                      muiTableHeadCellProps={{
                        sx: {
                          '.MuiSvgIcon-root': {fontSize: "18px"},
                          fontSize: '12px',
                          fontWeight: 'normal', // Remove bold text in the header
                          padding: '8px', // Adjust padding to reduce white space
                        },
                      }}
                      renderDetailPanel={({ row }) => {
                        // Check if product details have been loaded
                        const details = eventoPagamentoDetails[row.id];
                        const currentEventoPagamento = modeloServicoData.eventosPagamento?.find(m => m.value === row.original.value);

                        if (!details) {
                          // Trigger data fetching for this row, but only once
                          if (!loadingEventoPagamentoRows || !loadingEventoPagamentoRows.includes(row.id)) {
                            setLoadingEventoPagamentoRows([...(loadingEventoPagamentoRows || []), row.id]);
                            setEventoPagamentoDetails({...eventoPagamentoDetails, [row.id]: {macroatividades: [], produtos: []}}); // Placeholder to avoid repeated fetches
                          }

                          return <div>Loading details...</div>;
                        }

                        return (
                          <div>
                            <FormGroup>
                              <span>Macroatividades</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable={true}
                                isSearchable={true}
                                value={currentEventoPagamento?.macroatividades}
                                options={modeloServicoData.macroatividades || []}
                                isMulti
                                onChange={(selectedOptions, actionMeta) => {

                                const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        macroatividades: prev.macroatividades ? prev.macroatividades.map(p => {
                                          if (p.value === option.value) {
                                            return {
                                              ...p,
                                              eventosPagamento: p.eventosPagamento ? [...p.eventosPagamento, row.original] : [row.original],
                                            }
                                          } else {
                                            return p;
                                          }
                                        }) : [row.original],
                                        eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              macroatividades: m.macroatividades ? [...m.macroatividades, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if (removedValue.relacaoEventoPagamentoPropMacroatividade_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          macroatividades: prev.macroatividades && prev.macroatividades.map(p => {
                                            if (p.eventosPagamento?.some(m => m.relacaoEventoPagamentoPropMacroatividade_id === removedValue.relacaoEventoPagamentoPropMacroatividade_id)) {
                                              return {
                                                ...p,
                                                eventosPagamento: p.eventosPagamento ? p.eventosPagamento.filter(m => m.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.relacaoEventoPagamentoPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                macroatividades: m.macroatividades ? m.macroatividades.filter(p => p.relacaoEventoPagamentoPropMacroatividade_id !== removedValue.relacaoEventoPagamentoPropMacroatividade_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          macroatividades: prev.macroatividades && prev.macroatividades.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                eventosPagamento: p.eventosPagamento ? p.eventosPagamento.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                macroatividades: m.macroatividades ? m.macroatividades.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <span>Produtos</span>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable={true}
                                isSearchable={true}
                                value={currentEventoPagamento?.produtos}
                                options={modeloServicoData.produtos || []}
                                isMulti
                                onChange={(selectedOptions, actionMeta) => {

                                const { action, option, removedValue } = actionMeta;

                                  // When selecting → duplicate with new value
                                  if (action === 'select-option') {
                                    setModeloServicoData(prev => {
                                      return {
                                        ...prev,
                                        produtos: prev.produtos ? prev.produtos.map(p => {
                                          if (p.value === option.value) {
                                            return {
                                              ...p,
                                              eventosPagamento: p.eventosPagamento ? [...p.eventosPagamento, row.original] : [row.original],
                                            }
                                          } else {
                                            return p;
                                          }
                                        }) : [row.original],
                                        eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                          if (m.value === row.original.value) {
                                            return {
                                              ...m,
                                              produtos: m.produtos ? [...m.produtos, option] : [option],
                                            }
                                          } else {
                                            return m;
                                          }
                                        }) : [option]
                                      }
                                    })
                                  }

                                  // When removing / clearing → trust react-select
                                  if (action === "remove-value" || action === "pop-value") {
                                    console.log('removedValue', removedValue);
                                    console.log('modeloServicoData', modeloServicoData);
                                    if (removedValue.relacaoProdPropEventoPagamentoProp_id) {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          produtos: prev.produtos && prev.produtos.map(p => {
                                            if (p.eventosPagamento?.some(m => m.relacaoProdPropEventoPagamentoProp_id === removedValue.relacaoProdPropEventoPagamentoProp_id)) {
                                              return {
                                                ...p,
                                                eventosPagamento: p.eventosPagamento ? p.eventosPagamento.filter(m => m.relacaoProdPropEventoPagamentoProp_id !== removedValue.relacaoProdPropEventoPagamentoProp_id) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                produtos: m.produtos ? m.produtos.filter(p => p.relacaoProdPropEventoPagamentoProp_id !== removedValue.relacaoProdPropEventoPagamentoProp_id) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    } else {
                                      setModeloServicoData(prev => {
                                        return {
                                          ...prev,
                                          produtos: prev.produtos && prev.produtos.map(p => {
                                            if (p.value === removedValue.value) {
                                              return {
                                                ...p,
                                                eventosPagamento: p.eventosPagamento ? p.eventosPagamento.filter(m => m.value !== row.original.value) : [],
                                              }
                                            } else {
                                              return p;
                                            }
                                          }),
                                          eventosPagamento: prev.eventosPagamento ? prev.eventosPagamento.map(m => {
                                            if (m.value === row.original.value) {
                                              return {
                                                ...m,
                                                produtos: m.produtos ? m.produtos.filter(p => p.value !== removedValue.value) : [],
                                              }
                                            } else {
                                              return m;
                                            }
                                          }) : [option]
                                        }
                                      })
                                    }
                                  }
                                }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <span>Valor (%)</span>
                              <MaskedInput
                                unmask
                                mask="num %"
                                blocks={{
                                  num: {
                                    mask: Number,
                                    scale: 2, // digits after point 0 for integers
                                    signed: false, // disallow negative
                                    thousandsSeparator: '.', // any single char
                                    padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                                    normalizeZeros: false, // appends or removes zeros at ends
                                    radix: ',', // fractional delimiter
                                    min: 0,
                                    max: 100,
                                  },
                                }}
                                lazy={false}
                                value={String(modeloServicoData.eventosPagamento.find(ep => ep.value === row.original.value).relacaoServicoEventoPagamentoProp_vlr || "")}
                                onAccept={value => {
                                  setModeloServicoData({
                                    ...modeloServicoData,
                                    eventosPagamento: modeloServicoData.eventosPagamento.map(ep =>
                                      ep.value === row.original.value
                                        ? { ...ep, relacaoServicoEventoPagamentoProp_vlr: value || null }
                                        : ep
                                    )
                                  });
                                }}
                              />
                            </FormGroup>
                          </div>
                        )
                      }}
                    />
                  </FormGroup>
                </TabPanel>
              </Tabs>
            </TabPanel>
          </Tabs>

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => { setModalEditServicoOpen(false); setModeloServicoData({});}}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={async () => {
                setIsSubmitEntityLoading(true);

                const selectedMacroatividadesCopy = selectedMacroatividades.filter(sma => sma.modeloServico_id !== modeloServicoData.modeloServico_id);
                const selectedProdsPropCopy = selectedProdsProp.filter(sma => sma.modeloServico_id !== modeloServicoData.modeloServico_id);
                const selectedEpsPropCopy = selectedEpsProp.filter(sma => sma.modeloServico_id !== modeloServicoData.modeloServico_id);
                let selectedMacroatividadesFromModeloServico = selectedMacroatividades.filter(sma => sma.modeloServico_id === modeloServicoData.modeloServico_id)
                let selectedProdsPropFromModeloServico = selectedProdsProp.filter(sep => sep.modeloServico_id === modeloServicoData.modeloServico_id);
                let selectedEpsPropFromModeloServico = selectedEpsProp.filter(sep => sep.modeloServico_id === modeloServicoData.modeloServico_id);
                let arrayRelacaoEventoPagamentoPropMacroatividade = [];
                let arrayRelacaoProdPropEventoPagamentoProp = [];
                let arrayRelacaoProdPropMacroatividade = [];

                const currentMacroatividadesIds = (modeloServicoData.macroatividades || [])
                .map(ma => ma.relacaoServicoMacroatividade_id);

                const macroatividadesToRemove = selectedMacroatividades.filter(sm =>
                  sm.modeloServico_id === modeloServicoData.modeloServico_id &&
                  !currentMacroatividadesIds.includes(sm.relacaoServicoMacroatividade_id)
                );

                const macroatividadesToAdd = modeloServicoData.macroatividades?.filter(m => !m.relacaoServicoMacroatividade_id) || [];

                const map1 = new Map(selectedMacroatividades.map(o => [o.relacaoServicoMacroatividade_id, o]))

                const changedMacroatividades = modeloServicoData.macroatividades?.filter(o => {
                  const oldObj = map1.get(o.relacaoServicoMacroatividade_id)

                  if (!oldObj || !o.relacaoServicoMacroatividade_id) return false

                  const isDifferent =
                    JSON.stringify(oldObj) !== JSON.stringify(o)

                  if (isDifferent) {
                    console.log('🔍 Diff for ID:', o.relacaoServicoMacroatividade_id)
                    diffObjects(oldObj, o)
                  }

                  return isDifferent
                }) || [];

                const currentProdutosIds = (modeloServicoData.produtos || [])
                  .map(p => p.relacaoServicoProdProp_id);

                const produtosToRemove = selectedProdsProp.filter(sp =>
                  sp.modeloServico_id === modeloServicoData.modeloServico_id &&
                  !currentProdutosIds.includes(sp.relacaoServicoProdProp_id)
                );

                const produtosToAdd = modeloServicoData.produtos?.filter(p => !p.relacaoServicoProdProp_id) || [];

                const map2 = new Map(selectedProdsProp.map(o => [o.relacaoServicoProdProp_id, o]))

                const changedProdutos = modeloServicoData.produtos?.filter(o => {
                  const oldObj = map2.get(o.relacaoServicoProdProp_id)

                  if (!oldObj || !o.relacaoServicoProdProp_id) return false

                  const isDifferent =
                    JSON.stringify(oldObj) !== JSON.stringify(o)

                  if (isDifferent) {
                    console.log('🔍 Diff for ID:', o.relacaoServicoProdProp_id)
                    diffObjects(oldObj, o)
                  }

                  return isDifferent
                }) || [];

                const currentEventosPagamentoIds = (modeloServicoData.eventosPagamento || [])
                  .map(p => p.relacaoServicoEventoPagamentoProp_id);

                const eventosPagamentoToRemove = selectedEpsProp.filter(sp =>
                  sp.modeloServico_id === modeloServicoData.modeloServico_id &&
                  !currentEventosPagamentoIds.includes(sp.relacaoServicoEventoPagamentoProp_id)
                );

                const eventosPagamentoToAdd = modeloServicoData.eventosPagamento?.filter(p => !p.relacaoServicoEventoPagamentoProp_id) || [];

                const map3 = new Map(selectedEpsProp.map(o => [o.relacaoServicoEventoPagamentoProp_id, o]))

                const changedEventosPagamento = modeloServicoData.eventosPagamento?.filter(o => {
                  const oldObj = map3.get(o.relacaoServicoEventoPagamentoProp_id)

                  if (!oldObj || !o.relacaoServicoEventoPagamentoProp_id) return false

                  const isDifferent =
                    JSON.stringify(oldObj) !== JSON.stringify(o)

                  if (isDifferent) {
                    console.log('🔍 Diff for ID:', o.relacaoServicoEventoPagamentoProp_id)
                    diffObjects(oldObj, o)
                  }

                  return isDifferent
                }) || [];

                //adding macroatividades:
                for (const sm of macroatividadesToAdd) {
                  const finded = modeloServicoData.macroatividades?.find(
                    m => m.value === sm.value
                  );

                  if (!finded) continue;

                  const resInsert = await oikosApi.post("/", {
                      action: "insert",
                      table: "relacaoServicoMacroatividade",
                      data: {
                        macroatividade_id: finded.macroatividade_id,
                        modeloServico_id: modeloServicoData.modeloServico_id,
                        servico_id: modeloServicoData.servico_id,
                        relacaoServicoMacroatividade_tempoEstimadoExecucaoDias: finded.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias,
                      },
                  });

                  console.log('finded macro add', finded);

                  if (finded.propItens?.length > 0) {

                    for (let index = 0; index < finded.propItens.length; index++) {
                      const propItem = finded.propItens[index];

                      const resInsertPropItem = await oikosApi.post("/", {
                        action: "insert",
                        table: "relacaoMacroatividadePropItem",
                        data: {
                          relacaoMacroatividadePropItem_propItemQtd: propItem.relacaoMacroatividadePropItem_propItemQtd,
                          propItem_id: propItem.propItem_id,
                          macroatividade_id: finded.macroatividade_id,
                          relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: propItem.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias,
                          relacaoServicoMacroatividade_id: resInsert.data[0].relacaoServicoMacroatividade_id
                        },
                      });

                      console.log('resInsertPropItem', resInsertPropItem);

                      finded.propItens[index] = {...finded.propItens[index], ...resInsertPropItem.data[0]}
                    }
                  }

                  if (finded.produtos?.length > 0) {
                    for (let index = 0; index < finded.produtos.length; index++) {
                      const produto = finded.produtos[index];

                      const resInsertProd = await oikosApi.post("/", {
                        action: "insert",
                        table: "relacaoProdPropMacroatividade",
                        data: {
                          macroatividade_id: finded.macroatividade_id,
                          prodProp_id: produto.prodProp_id,
                          relacaoServicoMacroatividade_id: resInsert.data[0].relacaoServicoMacroatividade_id,
                          relacaoServicoProdProp_id: produto.relacaoServicoProdProp_id,
                        },
                      });

                      console.log('resInsertProd', resInsertProd);

                      arrayRelacaoProdPropMacroatividade.push(resInsertProd.data[0]);
                    }
                  }

                  if (finded.eventosPagamento?.length > 0) {
                    for (let index = 0; index < finded.eventosPagamento.length; index++) {
                      const eventoPagamento = finded.eventosPagamento[index];

                      const resInsertRelacaoEventoPagamentoPropMacroatividade = await oikosApi.post("/", {
                        action: "insert",
                        table: "relacaoEventoPagamentoPropMacroatividade",
                        data: {
                          macroatividade_id: finded.macroatividade_id,
                          eventoPagamentoProp_id: eventoPagamento.eventoPagamentoProp_id,
                          relacaoServicoMacroatividade_id: resInsert.data[0].relacaoServicoMacroatividade_id,
                          relacaoServicoEventoPagamentoProp_id: eventoPagamento.relacaoServicoEventoPagamentoProp_id,
                        },
                      });

                      arrayRelacaoEventoPagamentoPropMacroatividade.push(resInsertRelacaoEventoPagamentoPropMacroatividade.data[0]);
                    }
                  }

                  selectedMacroatividadesFromModeloServico.push({...finded, produtos: arrayRelacaoProdPropMacroatividade, eventosPagamento: arrayRelacaoEventoPagamentoPropMacroatividade})
                }

                //adding produtos:
                for (const sp of produtosToAdd) {
                  const finded = modeloServicoData.produtos?.find(
                    p => p.value === sp.value
                  );

                  if (!finded) continue;

                  const resInsertRelacaoServicoProdProp = await oikosApi.post("/", {
                      action: "insert",
                      table: "relacaoServicoProdProp",
                      data: {
                        prodProp_id: finded.prodProp_id,
                        modeloServico_id: modeloServicoData.modeloServico_id,
                        servico_id: modeloServicoData.servico_id,
                      },
                  });

                  if (finded.macroatividades?.length > 0) {
                    for (let index = 0; index < finded.macroatividades.length; index++) {
                      const macroatividade = finded.macroatividades[index];
                      const relacaoProdPropMacroatividade = arrayRelacaoProdPropMacroatividade.find(aprm => aprm.macroatividade_id === macroatividade.macroatividade_id && aprm.prodProp_id === finded.prodProp_id)

                      if (relacaoProdPropMacroatividade.relacaoProdPropMacroatividade_id) {
                        const resUpdateRelacaoProdPropMacroatividade = await oikosApi.post("/", {
                          action: "update",
                          table: "relacaoProdPropMacroatividade",
                          data: {
                            relacaoProdPropMacroatividade_id: relacaoProdPropMacroatividade.relacaoProdPropMacroatividade_id,
                            prodProp_id: finded.prodProp_id,
                            macroatividade_id: macroatividade.macroatividade_id,
                            relacaoServicoProdProp_id: resInsertRelacaoServicoProdProp.data[0].relacaoServicoProdProp_id,
                            relacaoServicoMacroatividade_id: macroatividade.relacaoServicoMacroatividade_id,
                          },
                        });

                        arrayRelacaoProdPropMacroatividade = arrayRelacaoProdPropMacroatividade.map(arpm => {
                          if (arpm.relacaoProdPropMacroatividade_id === relacaoProdPropMacroatividade.relacaoProdPropMacroatividade_id) {
                            return {...resUpdateRelacaoProdPropMacroatividade.data[0]}
                          }
                          return arpm
                        })
                      } else {
                        const resInsertRelacaoProdPropMacroatividade = await oikosApi.post("/", {
                          action: "insert",
                          table: "relacaoProdPropMacroatividade",
                          data: {
                            prodProp_id: finded.prodProp_id,
                            macroatividade_id: macroatividade.macroatividade_id,
                            relacaoServicoProdProp_id: resInsertRelacaoServicoProdProp.data[0].relacaoServicoProdProp_id,
                            relacaoServicoMacroatividade_id: macroatividade.relacaoServicoMacroatividade_id,
                          },
                        });

                        arrayRelacaoProdPropMacroatividade.push(resInsertRelacaoProdPropMacroatividade.data[0]);

                      }
                    }
                  }

                  if (finded.eventosPagamento?.length > 0) {
                    for (let index = 0; index < finded.eventosPagamento.length; index++) {
                      const eventoPagamento = finded.eventosPagamento[index];
                      const relacaoProdPropEventoPagamentoProp = arrayRelacaoProdPropEventoPagamentoProp.find(aprm => aprm.eventoPagamentoProp_id === eventoPagamento.eventoPagamentoProp_id && aprm.prodProp_id === finded.prodProp_id)

                      if (relacaoProdPropEventoPagamentoProp?.relacaoProdPropEventoPagamentoProp_id) {
                        const resUpdateRelacaoProdPropEventoPagamentoProp = await oikosApi.post("/", {
                          action: "update",
                          table: "relacaoProdPropEventoPagamentoProp",
                          data: {
                            relacaoProdPropEventoPagamentoProp_id: relacaoProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id,
                            prodProp_id: finded.prodProp_id,
                            eventoPagamentoProp_id: eventoPagamento.eventoPagamentoProp_id,
                            relacaoServicoProdProp_id: resInsertRelacaoServicoProdProp.data[0].relacaoServicoProdProp_id,
                            relacaoServicoEventoPagamentoProp_id: eventoPagamento.relacaoServicoEventoPagamentoProp_id,
                          },
                        });

                        arrayRelacaoProdPropEventoPagamentoProp = arrayRelacaoProdPropEventoPagamentoProp.map(arpm => {
                          if (arpm.relacaoProdPropEventoPagamentoProp_id === relacaoProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id) {
                            return {...resUpdateRelacaoProdPropEventoPagamentoProp.data[0]}
                          }
                          return arpm
                        })
                      } else {
                        const resInsertRelacaoProdPropEventoPagamentoProp = await oikosApi.post("/", {
                          action: "insert",
                          table: "relacaoProdPropEventoPagamentoProp",
                          data: {
                            prodProp_id: finded.prodProp_id,
                            eventoPagamentoProp_id: eventoPagamento.eventoPagamentoProp_id,
                            relacaoServicoProdProp_id: resInsertRelacaoServicoProdProp.data[0].relacaoServicoProdProp_id,
                            relacaoServicoEventoPagamentoProp_id: eventoPagamento.relacaoServicoEventoPagamentoProp_id,
                          },
                        });

                        arrayRelacaoProdPropEventoPagamentoProp.push(resInsertRelacaoProdPropEventoPagamentoProp.data[0]);
                      }
                    }
                  }

                  selectedProdsPropFromModeloServico.push({...finded, macroatividades: arrayRelacaoProdPropMacroatividade, eventosPagamento: arrayRelacaoProdPropEventoPagamentoProp})

                }

                //adding eventos de pagamento:
                for (const sp of eventosPagamentoToAdd) {
                  const finded = modeloServicoData.eventosPagamento?.find(
                    p => p.eventoPagamentoProp_id === sp.eventoPagamentoProp_id
                  );

                  if (!finded) continue;

                  const resInsertRelacaoServicoEventoPagamentoProp = await oikosApi.post("/", {
                    action: "insert",
                    table: "relacaoServicoEventoPagamentoProp",
                    data: {
                      eventoPagamentoProp_id: finded.eventoPagamentoProp_id,
                      modeloServico_id: modeloServicoData.modeloServico_id,
                      servico_id: modeloServicoData.servico_id,
                      relacaoServicoEventoPagamentoProp_vlr: finded.relacaoServicoEventoPagamentoProp_vlr
                    },
                  });

                  if (finded.macroatividades?.length > 0) {
                    for (let index = 0; index < finded.macroatividades.length; index++) {
                      const macroatividade = finded.macroatividades[index];

                      const relacaoEventoPagamentoPropMacroatividade = arrayRelacaoEventoPagamentoPropMacroatividade.find(aprm => aprm.macroatividade_id === macroatividade.macroatividade_id && aprm.eventoPagamentoProp_id === finded.eventoPagamentoProp_id)

                      if (relacaoEventoPagamentoPropMacroatividade?.relacaoEventoPagamentoPropMacroatividade_id) {
                        const resUpdateRelacaoEventoPagamentoPropMacroatividade = await oikosApi.post("/", {
                          action: "update",
                          table: "relacaoEventoPagamentoPropMacroatividade",
                          data: {
                            relacaoEventoPagamentoPropMacroatividade_id: relacaoEventoPagamentoPropMacroatividade.relacaoEventoPagamentoPropMacroatividade_id,
                            prodProp_id: finded.prodProp_id,
                            eventoPagamentoProp_id: macroatividade.eventoPagamentoProp_id,
                            relacaoServicoEventoPagamentoProp_id: resInsertRelacaoServicoEventoPagamentoProp.data[0].relacaoServicoEventoPagamentoProp_id,
                            relacaoServicoMacroatividade_id: macroatividade.relacaoServicoMacroatividade_id
                          }
                        })

                        arrayRelacaoEventoPagamentoPropMacroatividade = arrayRelacaoEventoPagamentoPropMacroatividade.map(arpm => {
                          if (arpm.relacaoEventoPagamentoPropMacroatividade_id === resUpdateRelacaoEventoPagamentoPropMacroatividade.data[0].relacaoEventoPagamentoPropMacroatividade_id) {
                            return {...resUpdateRelacaoEventoPagamentoPropMacroatividade.data[0]}
                          }
                          return arpm
                        })

                        selectedMacroatividadesFromModeloServico = selectedMacroatividadesFromModeloServico.map(smfs => {
                          if (smfs.relacaoServicoMacroatividade_id === macroatividade.relacaoServicoMacroatividade_id) {
                            return {
                              ...smfs,
                              eventosPagamento: arrayRelacaoEventoPagamentoPropMacroatividade
                            }
                          } else {
                            return smfs;
                          }
                        })
                      } else {
                        const resInsertRelacaoEventoPagamentoPropMacroatividade = await oikosApi.post("/", {
                          action: "insert",
                          table: "relacaoEventoPagamentoPropMacroatividade",
                          data: {
                            prodProp_id: finded.prodProp_id,
                            macroatividade_id: macroatividade.macroatividade_id,
                            relacaoServicoEventoPagamentoProp_id: resInsertRelacaoServicoEventoPagamentoProp.data[0].relacaoServicoEventoPagamentoProp_id,
                            relacaoServicoMacroatividade_id: macroatividade.relacaoServicoMacroatividade_id,
                          },
                        });

                        arrayRelacaoEventoPagamentoPropMacroatividade.push(resInsertRelacaoEventoPagamentoPropMacroatividade.data[0]);
                      }
                    }
                  }

                  if (finded.produtos?.length > 0) {
                    for (let index = 0; index < finded.produtos.length; index++) {
                      const produto = finded.produtos[index];
                      const relacaoProdPropEventoPagamentoProp = arrayRelacaoProdPropEventoPagamentoProp.find(aprm => aprm.prodProp_id === produto.prodProp_id && aprm.eventoPagamentoProp_id === finded.eventoPagamentoProp_id)

                      if (relacaoProdPropEventoPagamentoProp?.relacaoProdPropEventoPagamentoProp_id) {
                        const resUpdateRelacaoProdPropEventoPagamentoProp = await oikosApi.post("/", {
                          action: "update",
                          table: "relacaoProdPropEventoPagamentoProp",
                          data: {
                            relacaoProdPropEventoPagamentoProp_id: relacaoProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id,
                            eventoPagamentoProp_id: finded.eventoPagamentoProp_id,
                            prodProp_id: produto.prodProp_id,
                            relacaoServicoEventoPagamentoProp_id: resInsertRelacaoServicoEventoPagamentoProp.data[0].relacaoServicoEventoPagamentoProp_id,
                            relacaoServicoProdProp_id: produto.relacaoServicoProdProp_id
                          }
                        })

                        arrayRelacaoProdPropEventoPagamentoProp = arrayRelacaoProdPropEventoPagamentoProp.map(arpep => {
                          if (arpep.relacaoProdPropEventoPagamentoProp_id === relacaoProdPropEventoPagamentoProp.relacaoProdPropEventoPagamentoProp_id) {
                            return {...resUpdateRelacaoProdPropEventoPagamentoProp.data[0]}
                          }
                          return arpep
                        })

                        selectedProdsPropFromModeloServico = selectedProdsPropFromModeloServico.map(smfs => {
                          if (smfs.relacaoServicoProdProp_id === produto.relacaoServicoProdProp_id) {
                            return {
                              ...smfs,
                              eventosPagamento: arrayRelacaoProdPropEventoPagamentoProp
                            }
                          } else {
                            return smfs;
                          }
                        })
                      } else {
                        const resInsertRelacaoProdPropEventoPagamentoProp = await oikosApi.post("/", {
                          action: "insert",
                          table: "relacaoProdPropEventoPagamentoProp",
                          data: {
                            prodProp_id: produto.prodProp_id,
                            eventoPagamentoProp_id: finded.eventoPagamentoProp_id,
                            relacaoServicoEventoPagamentoProp_id: resInsertRelacaoServicoEventoPagamentoProp.data[0].relacaoServicoEventoPagamentoProp_id,
                            relacaoServicoProdProp_id: produto.relacaoServicoProdProp_id,
                          },
                        });

                        arrayRelacaoProdPropEventoPagamentoProp.push(resInsertRelacaoProdPropEventoPagamentoProp.data[0]);
                      }
                    }
                  }

                  selectedEpsPropFromModeloServico.push({...finded, macroatividades: arrayRelacaoProdPropMacroatividade, produtos: arrayRelacaoProdPropEventoPagamentoProp})

                }

                //removing macroatividades:
                for (const sm of macroatividadesToRemove) {
                  if (sm.relacaoServicoMacroatividade_id) {
                    const finded = modeloServicoOriginal.macroatividades.find(
                      m => m.relacaoServicoMacroatividade_id === sm.relacaoServicoMacroatividade_id
                    );

                    console.log('finded', finded);

                    if (!finded) continue;

                    const resUpdate = await oikosApi.post("/", {
                      action: "update",
                      table: "relacaoServicoMacroatividade",
                      data: {
                        relacaoServicoMacroatividade_id: sm.relacaoServicoMacroatividade_id,
                        relacaoServicoMacroatividade_ativo: 0,
                      },
                    });

                    console.log('resUpdate', resUpdate);

                    if (finded.propItens?.length) {

                      for (let index = 0; index < finded.propItens.length; index++) {
                        const propItem = finded.propItens[index];

                        const resUpdate = await oikosApi.post("/", {
                          action: "update",
                          table: "relacaoMacroatividadePropItem",
                          data: {
                            relacaoMacroatividadePropItem_id: propItem.relacaoMacroatividadePropItem_id,
                            relacaoMacroatividadePropItem_ativo: 0,
                          },
                        });
                      }
                    }

                    if (finded.produtos?.length) {
                      for (const produto of finded.produtos) {
                        await oikosApi.post("/", {
                          action: "update",
                          table: "relacaoProdPropMacroatividade",
                          data: {
                            relacaoProdPropMacroatividade_id: produto.relacaoProdPropMacroatividade_id,
                            relacaoProdPropMacroatividade_ativo: 0,
                          },
                        });

                        arrayRelacaoProdPropMacroatividade = arrayRelacaoProdPropMacroatividade.filter(aprm => aprm.relacaoProdPropMacroatividade_id !== produto.relacaoProdPropMacroatividade_id)

                        selectedProdsPropFromModeloServico = selectedProdsPropFromModeloServico.map(smfs => {
                          if (smfs.relacaoServicoProdProp_id === produto.relacaoServicoProdProp_id) {
                            return {
                              ...smfs,
                              macroatividades: arrayRelacaoProdPropMacroatividade.filter(aprm => produto.relacaoServicoProdProp_id === aprm.relacaoServicoProdProp_id)
                            }
                          } else {
                            return smfs;
                          }
                        })
                      }
                    }

                    if (finded.eventosPagamento?.length) {
                      for (const eventoPagamento of finded.eventosPagamento) {
                        await oikosApi.post("/", {
                          action: "update",
                          table: "relacaoEventoPagamentoPropMacroatividade",
                          data: {
                            relacaoEventoPagamentoPropMacroatividade_id:
                            eventoPagamento.relacaoEventoPagamentoPropMacroatividade_id,
                            relacaoEventoPagamentoPropMacroatividade_ativo: 0,
                          },
                        });

                        arrayRelacaoEventoPagamentoPropMacroatividade = arrayRelacaoEventoPagamentoPropMacroatividade.filter(aepm => aepm.relacaoEventoPagamentoPropMacroatividade_id !== eventoPagamento.relacaoEventoPagamentoPropMacroatividade_id)

                        selectedEpsPropFromModeloServico = selectedEpsPropFromModeloServico.map(smfs => {
                          if (smfs.relacaoServicoEventoPagamentoProp_id === eventoPagamento.relacaoServicoEventoPagamentoProp_id) {
                            return {
                              ...smfs,
                              macroatividades: arrayRelacaoEventoPagamentoPropMacroatividade.filter(aprm => eventoPagamento.relacaoServicoEventoPagamentoProp_id === aprm.relacaoServicoEventoPagamentoProp_id)
                            }
                          } else {
                            return smfs;
                          }
                        })
                      }
                    }

                    selectedMacroatividadesFromModeloServico = selectedMacroatividadesFromModeloServico.filter(smfs => smfs.relacaoServicoMacroatividade_id !== sm.relacaoServicoMacroatividade_id)
                  }
                }

                //removing produtos:
                for (const sp of produtosToRemove) {
                  const finded = modeloServicoOriginal.produtos.find(
                    m => m.prodProp_id === sp.prodProp_id
                  );

                  if (!finded) continue;

                  await oikosApi.post("/", {
                    action: "update",
                    table: "relacaoServicoProdProp",
                    data: {
                      relacaoServicoProdProp_id: sp.relacaoServicoProdProp_id,
                      relacaoServicoProdProp_ativo: 0,
                    },
                  });

                  if (finded.macroatividades?.length) {
                    for (const macroatividade of finded.macroatividades) {
                      await oikosApi.post("/", {
                        action: "update",
                        table: "relacaoProdPropMacroatividade",
                        data: {
                          relacaoProdPropMacroatividade_id: macroatividade.relacaoProdPropMacroatividade_id,
                          relacaoProdPropMacroatividade_ativo: 0,
                        },
                      });

                      arrayRelacaoProdPropMacroatividade = arrayRelacaoProdPropMacroatividade.filter(aprm => aprm.relacaoProdPropMacroatividade_id !== macroatividade.relacaoProdPropMacroatividade_id);

                      selectedMacroatividadesFromModeloServico = selectedMacroatividadesFromModeloServico.map(smfs => {
                        if (smfs.relacaoServicoProdProp_id === finded.relacaoServicoProdProp_id) {
                          return {
                            ...smfs,
                            macroatividades: arrayRelacaoProdPropMacroatividade.filter(aprm => macroatividade.relacaoServicoMacroatividade_id === aprm.relacaoServicoMacroatividade_id)
                          }
                        } else {
                          return smfs;
                        }
                      });
                    }
                  }

                  if (finded.eventosPagamento?.length) {
                    for (const eventoPagamento of finded.eventosPagamento) {
                      await oikosApi.post("/", {
                        action: "update",
                        table: "relacaoProdPropEventoPagamentoProp",
                        data: {
                          relacaoProdPropEventoPagamentoProp_id:
                          eventoPagamento.relacaoProdPropEventoPagamentoProp_id,
                          relacaoProdPropEventoPagamentoProp_ativo: 0,
                        },
                      });

                      arrayRelacaoProdPropEventoPagamentoProp = arrayRelacaoProdPropEventoPagamentoProp.filter(aprm => aprm.relacaoProdPropEventoPagamentoProp_id !== eventoPagamento.relacaoProdPropEventoPagamentoProp_id);

                      selectedEpsPropFromModeloServico = selectedEpsPropFromModeloServico.map(smfs => {
                        if (smfs.relacaoServicoProdProp_id === finded.relacaoServicoProdProp_id) {
                          return {
                            ...smfs,
                            eventosPagamento: arrayRelacaoProdPropEventoPagamentoProp.filter(aprm => aprm.relacaoServicoEventoPagamentoProp_id === eventoPagamento.relacaoServicoEventoPagamentoProp_id)
                          }
                        } else {
                          return smfs;
                        }
                      });
                    }
                  }

                  selectedProdsPropFromModeloServico = selectedProdsPropFromModeloServico.filter(smfs => smfs.relacaoServicoProdProp_id !== sp.relacaoServicoProdProp_id)
                }

                //removing eventos de pagamento:
                for (const sep of eventosPagamentoToRemove) {
                  const finded = modeloServicoOriginal.eventosPagamento.find(
                    m => m.eventoPagamentoProp_id === sep.eventoPagamentoProp_id
                  );

                  if (!finded) continue;

                  await oikosApi.post("/", {
                    action: "update",
                    table: "relacaoServicoEventoPagamentoProp",
                    data: {
                      relacaoServicoEventoPagamentoProp_id: sep.relacaoServicoEventoPagamentoProp_id,
                      relacaoServicoEventoPagamentoProp_ativo: 0,
                    },
                  });

                  if (finded.macroatividades?.length) {
                    for (const macroatividade of finded.macroatividades) {
                      await oikosApi.post("/", {
                        action: "update",
                        table: "relacaoEventoPagamentoPropMacroatividade",
                        data: {
                          relacaoEventoPagamentoPropMacroatividade_id: macroatividade.relacaoEventoPagamentoPropMacroatividade_id,
                          relacaoEventoPagamentoPropMacroatividade_ativo: 0,
                        },
                      });

                      arrayRelacaoEventoPagamentoPropMacroatividade = arrayRelacaoEventoPagamentoPropMacroatividade.filter(aprm => aprm.relacaoEventoPagamentoPropMacroatividade_id !== macroatividade.relacaoEventoPagamentoPropMacroatividade_id);

                      selectedMacroatividadesFromModeloServico = selectedMacroatividadesFromModeloServico.map(smfs => {
                        if (smfs.relacaoServicoEventoPagamentoProp_id === finded.relacaoServicoEventoPagamentoProp_id) {
                          return {
                            ...smfs,
                            macroatividades: arrayRelacaoEventoPagamentoPropMacroatividade.filter(aprm => macroatividade.relacaoServicoMacroatividade_id === aprm.relacaoServicoMacroatividade_id)
                          }
                        } else {
                          return smfs;
                        }
                      });
                    }
                  }

                  if (finded.produtos?.length) {
                    for (const produto of finded.produtos) {
                      await oikosApi.post("/", {
                        action: "update",
                        table: "relacaoProdPropEventoPagamentoProp",
                        data: {
                          relacaoProdPropEventoPagamentoProp_id:
                          produto.relacaoProdPropEventoPagamentoProp_id,
                          relacaoProdPropEventoPagamentoProp_ativo: 0,
                        },
                      });

                      arrayRelacaoProdPropEventoPagamentoProp = arrayRelacaoProdPropEventoPagamentoProp.filter(aprm => aprm.relacaoProdPropEventoPagamentoProp_id !== produto.relacaoProdPropEventoPagamentoProp_id);

                      selectedMacroatividadesFromModeloServico = selectedMacroatividadesFromModeloServico.map(smfs => {
                        if (smfs.relacaoServicoEventoPagamentoProp_id === finded.relacaoServicoEventoPagamentoProp_id) {
                          return {
                            ...smfs,
                            macroatividades: arrayRelacaoProdPropEventoPagamentoProp.filter(aprm => produto.relacaoServicoProdProp_id === aprm.relacaoServicoProdProp_id)
                          }
                        } else {
                          return smfs;
                        }
                      });
                    }
                  }
                }

                //changed macroatividades:
                if (changedMacroatividades.length > 0) {
                  for (const sm of changedMacroatividades) {
                    const finded = modeloServicoData.macroatividades.find(
                      m => m.relacaoServicoMacroatividade_id === sm.relacaoServicoMacroatividade_id
                    );

                    if (!finded) continue;

                    let selectedMacroatividadesFromModeloServicoSemAMacroatividadeQueMudou = selectedMacroatividadesFromModeloServico.filter(smfms => smfms.relacaoServicoMacroatividade_id !== finded.relacaoServicoMacroatividade_id);

                    await oikosApi.post("/", {
                      action: "update",
                      table: "relacaoServicoMacroatividade",
                      data: {
                        relacaoServicoMacroatividade_id: finded.relacaoServicoMacroatividade_id,
                        relacaoServicoMacroatividade_ativo: 1,
                        relacaoServicoMacroatividade_tempoEstimadoExecucaoDias: finded.relacaoServicoMacroatividade_tempoEstimadoExecucaoDias
                      },
                    });

                    //add and update propItens
                    if (finded.propItens?.length > 0) {
                      for (let index = 0; index < finded.propItens.length; index++) {
                        const propItem = finded.propItens[index];
                        console.log('finded', finded);
                        console.log('propItem', propItem);
                        const resRelacaoMacroatividadePropItem = await oikosApi.get(`/?${qs.stringify({
                          action: 'get',
                          table: 'relacaoMacroatividadePropItem',
                          data: {
                            macroatividade_id: finded.macroatividade_id,
                            propItem_id: propItem.propItem_id,
                            relacaoServicoMacroatividade_id: finded.relacaoServicoMacroatividade_id,
                            relacaoMacroatividadePropItem_ativo: 1
                          }
                        })}`)

                        resRelacaoMacroatividadePropItem.data = resRelacaoMacroatividadePropItem.data.filter( rmpi => rmpi.relacaoServicoMacroatividade_id)

                        console.log('resRelacaoMacroatividadePropItem', resRelacaoMacroatividadePropItem);

                        if (resRelacaoMacroatividadePropItem.data.length > 0) {

                          for (let index = 0; index < resRelacaoMacroatividadePropItem.data.length; index++) {
                            const relacaoMacroatividadePropItem = resRelacaoMacroatividadePropItem.data[index];

                            const resUpdatePropItem = await oikosApi.post("/", {
                              action: "update",
                              table: "relacaoMacroatividadePropItem",
                              data: {
                                relacaoMacroatividadePropItem_id: relacaoMacroatividadePropItem.relacaoMacroatividadePropItem_id,
                                relacaoMacroatividadePropItem_ativo: 1,
                                relacaoMacroatividadePropItem_propItemQtd: propItem.relacaoMacroatividadePropItem_propItemQtd,
                                relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: propItem.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias,
                                relacaoServicoMacroatividade_id: relacaoMacroatividadePropItem.relacaoServicoMacroatividade_id
                              },
                            });

                            console.log('resUpdatePropItem', resUpdatePropItem);

                            finded.propItens[index] = {...finded.propItens[index], ...resUpdatePropItem.data[0]}
                          }
                        } else {
                          const resInsertPropItem = await oikosApi.post("/", {
                            action: "insert",
                            table: "relacaoMacroatividadePropItem",
                            data: {
                              relacaoMacroatividadePropItem_propItemQtd: propItem.relacaoMacroatividadePropItem_propItemQtd,
                              propItem_id: propItem.propItem_id,
                              macroatividade_id: finded.macroatividade_id,
                              relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: propItem.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias,
                              relacaoServicoMacroatividade_id: finded.relacaoServicoMacroatividade_id
                            },
                          });

                            console.log('resInsertPropItem', resInsertPropItem);

                          finded.propItens[index] = {...finded.propItens[index], ...resInsertPropItem.data[0]}
                        }
                      }
                    }

                    //deactivate propItens
                    const resRelacaoMacroatividadePropItem = await oikosApi.get(`/?${qs.stringify({
                      action: 'get',
                      table: 'relacaoMacroatividadePropItem',
                      data: {
                        macroatividade_id: finded.macroatividade_id,
                        relacaoServicoMacroatividade_id: finded.relacaoServicoMacroatividade_id,
                        relacaoMacroatividadePropItem_ativo: 1
                      }
                    })}`)

                    const idsToExclude = new Set(
                      finded.propItens.map(item => item.relacaoMacroatividadePropItem_id)
                    );

                    const filteredArray = resRelacaoMacroatividadePropItem.data.filter(
                      item => !idsToExclude.has(item.relacaoMacroatividadePropItem_id)
                    );

                    console.log('filteredArray', filteredArray);

                    if (filteredArray.length > 0) {
                      for (let index = 0; index < filteredArray.length; index++) {
                        const relacaoMacroatividadePropItem = filteredArray[index];

                        const resDeactivateRelMacroatividadePropItem = await oikosApi.post("/", {
                          action: "update",
                          table: "relacaoMacroatividadePropItem",
                          data: {
                            relacaoMacroatividadePropItem_id: relacaoMacroatividadePropItem.relacaoMacroatividadePropItem_id,
                            relacaoMacroatividadePropItem_ativo: 0,
                          },
                        });

                        console.log('resDeactivateRelMacroatividadePropItem', resDeactivateRelMacroatividadePropItem);
                      }
                    }

                    if (finded.produtos?.length > 0) {

                      for (let index = 0; index < finded.produtos.length; index++) {
                        const produto = finded.produtos[index];
                        console.log('produto', produto);

                        if (!produto.relacaoProdPropMacroatividade_id && produto.relacaoServicoProdProp_id) {
                          const resInsertRelacaoProdPropMacroatividade = await oikosApi.post("/", {
                            action: "insert",
                            table: "relacaoProdPropMacroatividade",
                            data: {
                              macroatividade_id: finded.macroatividade_id,
                              prodProp_id: produto.prodProp_id,
                              relacaoServicoMacroatividade_id: finded.relacaoServicoMacroatividade_id,
                              relacaoServicoProdProp_id: produto.relacaoServicoProdProp_id,
                            },
                          });
                          console.log('resInsertRelacaoProdPropMacroatividade', resInsertRelacaoProdPropMacroatividade);

                          arrayRelacaoProdPropMacroatividade = [...arrayRelacaoProdPropMacroatividade, resInsertRelacaoProdPropMacroatividade.data[0]];

                          selectedProdsPropFromModeloServico = selectedProdsPropFromModeloServico.map(smfs => {
                            if (smfs.relacaoServicoProdProp_id === produto.relacaoServicoProdProp_id) {
                              return {
                                ...smfs,
                                macroatividades: arrayRelacaoProdPropMacroatividade.filter(aprm => produto.relacaoServicoProdProp_id === aprm.relacaoServicoProdProp_id)
                              }
                            } else {
                              return smfs;
                            }
                          })
                        };
                      }
                    }

                    if (finded.eventosPagamento?.length > 0) {
                      for (let index = 0; index < finded.eventosPagamento.length; index++) {
                        const eventoPagamento = finded.eventosPagamento[index];

                        if (!eventoPagamento.relacaoEventoPagamentoPropMacroatividade_id && eventoPagamento.relacaoServicoEventoPagamentoProp_id) {
                          const resInsertEventoPagamentoProp = await oikosApi.post("/", {
                            action: "insert",
                            table: "relacaoEventoPagamentoPropMacroatividade",
                            data: {
                              macroatividade_id: finded.macroatividade_id,
                              eventoPagamentoProp_id: eventoPagamento.eventoPagamentoProp_id,
                              relacaoServicoMacroatividade_id: finded.relacaoServicoMacroatividade_id,
                              relacaoServicoEventoPagamentoProp_id: eventoPagamento.relacaoServicoEventoPagamentoProp_id,
                            },
                          });

                          console.log('resInsertEventoPagamentoProp', resInsertEventoPagamentoProp)

                          arrayRelacaoEventoPagamentoPropMacroatividade = [...arrayRelacaoEventoPagamentoPropMacroatividade, resInsertEventoPagamentoProp.data[0]];

                          selectedEpsPropFromModeloServico = selectedEpsPropFromModeloServico.map(smfs => {
                            if (smfs.relacaoServicoEventoPagamentoProp_id === eventoPagamento.relacaoServicoEventoPagamentoProp_id) {
                              return {
                                ...smfs,
                                macroatividades: arrayRelacaoEventoPagamentoPropMacroatividade.filter(aprm => aprm.relacaoServicoEventoPagamentoProp_id === eventoPagamento.relacaoServicoEventoPagamentoProp_id)
                              }
                            } else {
                              return smfs;
                            }
                          })
                        };

                        const resRelacaoEventoPagementoPropMacroatividade = await oikosApi.get(`/?${qs.stringify({
                          action: 'get',
                          table: 'relacaoEventoPagamentoPropMacroatividade',
                          data: {
                            macroatividade_id: finded.macroatividade_id,
                            eventoPagamentoProp_id: eventoPagamento.eventoPagamentoProp_id,
                            relacaoServicoMacroatividade_id: finded.relacaoServicoMacroatividade_id,
                          }
                        })}`)

                        if (resRelacaoEventoPagementoPropMacroatividade.data.length > 0) {
                          for (let index = 0; index < resRelacaoEventoPagementoPropMacroatividade.data.length; index++) {
                            const relacaoEventoPagamentoPropMacroatividade = resRelacaoEventoPagementoPropMacroatividade.data[index];

                            if (Number(relacaoEventoPagamentoPropMacroatividade.relacaoEventoPagamentoPropMacroatividade_ativo) === 0) {
                              const resUpdateEventoPagamentoProp = await oikosApi.post("/", {
                                action: "update",
                                table: "relacaoEventoPagamentoPropMacroatividade",
                                data: {
                                  relacaoEventoPagamentoPropMacroatividade_id:
                                  relacaoEventoPagamentoPropMacroatividade.relacaoEventoPagamentoPropMacroatividade_id,
                                  relacaoEventoPagamentoPropMacroatividade_ativo: 1,
                                },
                              });

                              console.log('resUpdateEventoPagamentoProp', resUpdateEventoPagamentoProp)

                              finded.eventosPagamento[index] = {...finded.eventosPagamento[index], ...resUpdateEventoPagamentoProp.data[0]}
                              arrayRelacaoEventoPagamentoPropMacroatividade = [...arrayRelacaoEventoPagamentoPropMacroatividade, resUpdateEventoPagamentoProp.data[0]];
                            }
                          }
                        } else {

                        }
                      }
                    }

                    const findedOriginalMacroatividades = modeloServicoOriginal.macroatividades.find(
                      m => m.relacaoServicoMacroatividade_id === sm.relacaoServicoMacroatividade_id
                    );

                    if (findedOriginalMacroatividades.produtos && findedOriginalMacroatividades.produtos.length > 0) {
                      for (let index = 0; index < findedOriginalMacroatividades.produtos.length; index++) {
                        const originalProduto = findedOriginalMacroatividades.produtos[index];

                        if (!JSON.stringify(finded.produtos).includes(JSON.stringify(originalProduto))) {
                          await oikosApi.post("/", {
                            action: "update",
                            table: "relacaoProdPropMacroatividade",
                            data: {
                              relacaoProdPropMacroatividade_id: originalProduto.relacaoProdPropMacroatividade_id,
                              relacaoProdPropMacroatividade_ativo: 0,
                            },
                          });

                          arrayRelacaoProdPropMacroatividade = arrayRelacaoProdPropMacroatividade.filter(aprm => aprm.relacaoProdPropMacroatividade_id !== originalProduto.relacaoProdPropMacroatividade_id);
                          selectedProdsPropFromModeloServico = selectedProdsPropFromModeloServico.map(smfs => {
                            if (smfs.relacaoServicoProdProp_id === originalProduto.relacaoServicoProdProp_id) {
                              return {
                                ...smfs,
                                macroatividades: arrayRelacaoProdPropMacroatividade.filter(aprm => originalProduto.relacaoServicoProdProp_id === aprm.relacaoServicoProdProp_id)
                              }
                            } else {
                              return smfs;
                            }
                          })
                        }
                      }
                    }

                    if (findedOriginalMacroatividades.eventosPagamento && findedOriginalMacroatividades.eventosPagamento.length > 0) {
                      for (let index = 0; index < findedOriginalMacroatividades.eventosPagamento.length; index++) {
                        const originalEventoPagamento = findedOriginalMacroatividades.eventosPagamento[index];

                        if (!JSON.stringify(finded.eventosPagamento).includes(JSON.stringify(originalEventoPagamento))) {
                          console.log()
                          await oikosApi.post("/", {
                            action: "update",
                            table: "relacaoEventoPagamentoPropMacroatividade",
                            data: {
                              relacaoEventoPagamentoPropMacroatividade_id: originalEventoPagamento.relacaoEventoPagamentoPropMacroatividade_id,
                              relacaoEventoPagamentoPropMacroatividade_ativo: 0,
                            },
                          });
                        }

                        arrayRelacaoEventoPagamentoPropMacroatividade = arrayRelacaoEventoPagamentoPropMacroatividade.filter(aepm => aepm.relacaoEventoPagamentoPropMacroatividade_id !== originalEventoPagamento.relacaoEventoPagamentoPropMacroatividade_id)

                        selectedEpsPropFromModeloServico = selectedEpsPropFromModeloServico.map(smfs => {
                          if (smfs.relacaoServicoEventoPagamentoProp_id === originalEventoPagamento.relacaoServicoEventoPagamentoProp_id) {
                            return {
                              ...smfs,
                              macroatividades: arrayRelacaoEventoPagamentoPropMacroatividade.filter(aepm => originalEventoPagamento.relacaoServicoEventoPagamentoProp_id === aepm.relacaoServicoEventoPagamentoProp_id)
                            }
                          } else {
                            return smfs;
                          }
                        })
                      }
                    }

                    selectedMacroatividadesFromModeloServico = [
                      ...selectedMacroatividadesFromModeloServicoSemAMacroatividadeQueMudou,
                      {
                        ...finded,
                        produtos: arrayRelacaoProdPropMacroatividade.filter(aprm => aprm.relacaoServicoMacroatividade_id === finded.relacaoServicoMacroatividade_id) || [],
                        eventosPagamento: arrayRelacaoEventoPagamentoPropMacroatividade.filter(aepm => aepm.relacaoServicoMacroatividade_id === finded.relacaoServicoMacroatividade_id) || []
                      }
                    ];

                  }
                }

                //changed produtos:
                if (changedProdutos.length > 0) {
                  for (const sm of changedProdutos) {
                    const finded = modeloServicoData.produtos.find(
                      m => m.relacaoServicoProdProp_id === sm.relacaoServicoProdProp_id
                    );

                    if (!finded) continue;

                    let selectedProdsPropFromModeloServicoSemOProdPropQueMudou = selectedProdsPropFromModeloServico.filter(smfms => smfms.relacaoServicoProdProp_id !== finded.relacaoServicoProdProp_id);

                    const resUpdateRelacaoServicoProdProp = await oikosApi.post("/", {
                      action: "update",
                      table: "relacaoServicoProdProp",
                      data: {
                        relacaoServicoProdProp_id: finded.relacaoServicoProdProp_id,
                        relacaoServicoProdProp_ativo: 1,
                      },
                    });

                    if (finded.macroatividades?.length > 0) {
                      for (let index = 0; index < finded.macroatividades.length; index++) {
                        const macroatividade = finded.macroatividades[index];

                        if (!macroatividade.relacaoServicoMacroatividade_id) {
                          const resInsertRelacaoProdPropMacroatividade = await oikosApi.post("/", {
                            action: "insert",
                            table: "relacaoProdPropMacroatividade",
                            data: {
                              prodProp_id: finded.prodProp_id,
                              macroatividade_id: macroatividade.macroatividade_id,
                              relacaoServicoProdProp_id: finded.relacaoServicoProdProp_id,
                              relacaoServicoMacroatividade_id: macroatividade.relacaoServicoMacroatividade_id,
                            },
                          });
                          arrayRelacaoProdPropMacroatividade = [...arrayRelacaoProdPropMacroatividade, resInsertRelacaoProdPropMacroatividade.data[0]];

                          selectedMacroatividadesFromModeloServico = selectedMacroatividadesFromModeloServico.map(smfs => {
                            if (smfs.relacaoServicoMacroatividade_id === macroatividade.relacaoServicoMacroatividade_id) {
                              return {
                                ...smfs,
                                produtos: arrayRelacaoProdPropMacroatividade.filter(aprm => macroatividade.relacaoServicoMacroatividade_id === aprm.relacaoServicoMacroatividade_id)
                              }
                            } else {
                              return smfs;
                            }
                          })
                        }
                      }
                    }

                    if (finded.eventosPagamento?.length > 0) {
                      for (let index = 0; index < finded.eventosPagamento.length; index++) {
                        const eventoPagamento = finded.eventosPagamento[index];

                        const resInsertEventoPagamentoProp = await oikosApi.post("/", {
                          action: "insert",
                          table: "relacaoProdPropEventoPagamentoProp",
                          data: {
                            prodProp_id: finded.prodProp_id,
                            eventoPagamentoProp_id: eventoPagamento.eventoPagamentoProp_id,
                            relacaoServicoProdProp_id: finded.relacaoServicoProdProp_id,
                            relacaoServicoEventoPagamentoProp_id: eventoPagamento.relacaoServicoEventoPagamentoProp_id,
                          },
                        });

                        arrayRelacaoProdPropEventoPagamentoProp = [...arrayRelacaoProdPropEventoPagamentoProp, resInsertEventoPagamentoProp.data[0]];

                        selectedEpsPropFromModeloServico = selectedEpsPropFromModeloServico.map(smfs => {
                          if (smfs.relacaoServicoEventoPagamentoProp_id === eventoPagamento.relacaoServicoEventoPagamentoProp_id) {
                            return {
                              ...smfs,
                              eventosPagamento: arrayRelacaoProdPropEventoPagamentoProp.filter(aprm => aprm.relacaoServicoEventoPagamentoProp_id === smfs.relacaoServicoEventoPagamentoProp_id)
                            }
                          } else {
                            return smfs;
                          }
                        })
                      }
                    }

                    const findedOriginalProdutos = modeloServicoOriginal.produtos.find(
                      m => m.relacaoServicoProdProp_id === sm.relacaoServicoProdProp_id
                    );

                    if (findedOriginalProdutos.eventosPagamento && findedOriginalProdutos.eventosPagamento.length > 0) {
                      for (let index = 0; index < findedOriginalProdutos.eventosPagamento.length; index++) {
                        const originalEventoPagamento = findedOriginalProdutos.eventosPagamento[index];

                        if (!JSON.stringify(finded.eventosPagamento).includes(JSON.stringify(originalEventoPagamento))) {
                          await oikosApi.post("/", {
                            action: "update",
                            table: "relacaoProdPropEventoPagamentoProp",
                            data: {
                              relacaoProdPropEventoPagamentoProp_id: originalEventoPagamento.relacaoProdPropEventoPagamentoProp_id,
                              relacaoProdPropEventoPagamentoProp_ativo: 0,
                            },
                          });

                          arrayRelacaoEventoPagamentoPropMacroatividade = arrayRelacaoEventoPagamentoPropMacroatividade.filter(aprm => aprm.relacaoEventoPagamentoPropMacroatividade_id !== originalEventoPagamento.relacaoEventoPagamentoPropMacroatividade_id);
                          selectedEpsPropFromModeloServico = selectedEpsPropFromModeloServico.map(smfs => {
                            if (smfs.relacaoServicoEventoPagamentoProp_id === originalEventoPagamento.relacaoServicoEventoPagamentoProp_id) {
                              return {
                                ...smfs,
                                produtos: arrayRelacaoEventoPagamentoPropMacroatividade.filter(aprm => originalEventoPagamento.relacaoServicoEventoPagamentoProp_id === aprm.relacaoServicoEventoPagamentoProp_id)
                              }
                            } else {
                              return smfs;
                            }
                          })
                        }
                      }
                    }

                    if (findedOriginalProdutos.macroatividades && findedOriginalProdutos.macroatividades.length > 0) {
                      for (let index = 0; index < findedOriginalProdutos.macroatividades.length; index++) {
                        const originalMacroatividade = findedOriginalProdutos.macroatividades[index];

                        if (!JSON.stringify(finded.macroatividades).includes(JSON.stringify(originalMacroatividade))) {
                          await oikosApi.post("/", {
                            action: "update",
                            table: "relacaoProdPropMacroatividadeProp",
                            data: {
                              relacaoProdPropMacroatividadeProp_id: originalMacroatividade.relacaoProdPropMacroatividadeProp_id,
                              relacaoProdPropMacroatividadeProp_ativo: 0,
                            },
                          });

                          arrayRelacaoProdPropMacroatividade = arrayRelacaoProdPropMacroatividade.filter(aprm => aprm.relacaoProdPropMacroatividade_id !== originalMacroatividade.relacaoProdPropMacroatividade_id);
                          selectedMacroatividadesFromModeloServico = selectedMacroatividadesFromModeloServico.map(smfs => {
                            if (smfs.relacaoServicoMacroatividade_id === originalMacroatividade.relacaoServicoMacroatividade_id) {
                              return {
                                ...smfs,
                                produtos: arrayRelacaoProdPropMacroatividade.filter(aprm => originalMacroatividade.relacaoServicoMacroatividade_id === aprm.relacaoServicoMacroatividade_id)
                              }
                            } else {
                              return smfs;
                            }
                          })
                        }
                      }
                    }

                    selectedProdsPropFromModeloServico = [...selectedProdsPropFromModeloServicoSemOProdPropQueMudou, finded]

                  }
                }

                //changed eventos de pagamento:
                if (changedEventosPagamento.length > 0) {
                  for (const sm of changedEventosPagamento) {
                    const finded = modeloServicoData.eventosPagamento.find(
                      m => m.relacaoServicoEventoPagamentoProp_id === sm.relacaoServicoEventoPagamentoProp_id
                    );

                    if (!finded) continue;

                    let selectedEpsPropFromModeloServicoSemOProdPropQueMudou = selectedEpsPropFromModeloServico.filter(smfms => smfms.relacaoServicoEventoPagamentoProp_id !== finded.relacaoServicoEventoPagamentoProp_id);

                    await oikosApi.post("/", {
                      action: "update",
                      table: "relacaoServicoEventoPagamentoProp",
                      data: {
                        relacaoServicoEventoPagamentoProp_id: finded.relacaoServicoEventoPagamentoProp_id,
                        relacaoServicoEventoPagamentoProp_ativo: 1,
                        relacaoServicoEventoPagamentoProp_vlr: finded.relacaoServicoEventoPagamentoProp_vlr
                      },
                    });

                    selectedEpsPropFromModeloServico = [...selectedEpsPropFromModeloServicoSemOProdPropQueMudou, finded]

                  }
                }

                setSelectedEpsProp([...selectedEpsPropCopy, ...selectedEpsPropFromModeloServico]);

                setSelectedMacroatividades([...selectedMacroatividadesCopy, ...selectedMacroatividadesFromModeloServico]);

                setSelectedProdsProp([...selectedProdsPropCopy, ...selectedProdsPropFromModeloServico]);

                setIsSubmitEntityLoading(false);
                setModalEditServicoOpen(false);
              }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal
        centered={false}
        isOpen={modalPropItemOpen}
        toggle={() => setModalPropItemOpen(false)}
      >
        <ModalHeader>Adicionar {propItemData.propItemGr_label}</ModalHeader>

        <ModalBody>

          <FormGroup>
            <span>
              Selecione o item orçamentário
            </span>
            <Select
              className="basic-single"
              classNamePrefix="select"
              isClearable={true}
              isSearchable={true}
              value={propItens.find(pi => pi.value === propItemData.value)}
              options={propItens.filter(pi => pi.propItemGr_id === propItemData.propItemGr_id && propostaData.propItens.filter(pi2 => pi2.propItem_id === pi.propItem_id).length === 0)}
              onChange={async (e) => {
                if (e) {
                  setPropItemData({ ...e })
                } else {
                  setPropItemData({})
                }
              }}
            />
          </FormGroup>

          <FormGroup>
            <span>
              Valor unitário
            </span>
            <MaskedInput
              disabled={true}
              unmask
              mask="R$ num"
              blocks={{
                num: {
                  mask: Number,
                  scale: 2, // digits after point 0 for integers
                  signed: false, // disallow negative
                  thousandsSeparator: '.', // any single char
                  padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                  normalizeZeros: false, // appends or removes zeros at ends
                  radix: ',', // fractional delimiter
                  min: 0,
                  max: 1000000000,
                },
              }}
              lazy={false}
              value={String(propItemData.propItem_refVlr)}
              onAccept={value => setPropItemData({...propItemData, propItem_refVlr: value})}
            />
          </FormGroup>

          <FormGroup>
            <span>
              Quantidade
            </span>
            <Input
              value={propItemData.relacaoMacroatividadePropItem_propItemQtd}
              onChange={async (e) => {
                if (propItemData.propItem_id) {
                  let total = 0;
                  for (let index = 0; index < selectedMacroatividades.filter(sm => sm.propItens.filter(pi2 => propItemData.propItem_id === pi2.propItem_id).length > 0).length; index++) {
                    const element = selectedMacroatividades.filter(sm => {return sm.propItens.filter(pi2 => propItemData.propItem_id === pi2.propItem_id).length > 0})[index].propItens.find(pi2 => propItemData.propItem_id === pi2.propItem_id).relacaoMacroatividadePropItem_propItemQtd;
                    total = total + Number(element);
                  }
                  if (propostaData.propItens.find(pi2 => pi2.propItem_id === propItemData.propItem_id)) {
                    if (
                      e.target.value &&
                      e.target.value !== '' &&
                      !isNaN(Number(e.target.value)) &&
                      Number(e.target.value) + total <= propostaData.propItens.find(pi2 => pi2.propItem_id === propItemData.propItem_id).relacaoPropPropItem_propItemQtd
                    ) {
                      setPropItemData({
                        ...propItemData,
                        relacaoPropPropItem_propItemQtd: Number(e.target.value)
                      })
                    }
                    else {
                      setPropItemData({
                        ...propItemData,
                        relacaoPropPropItem_propItemQtd: Number(e.target.value) + total
                      })
                    }
                  } else {
                    if (
                      e.target.value &&
                      e.target.value !== '' &&
                      !isNaN(Number(e.target.value))
                    ) {
                      setPropItemData({
                        ...propItemData,
                        relacaoPropPropItem_propItemQtd: Number(e.target.value)
                      })
                    }
                  }
                }
              }}
            />
          </FormGroup>

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => setModalPropItemOpen(false)}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => {
                setIsSubmitEntityLoading(true);
                const finded = propostaData.propItens.find(pi => pi.propItem_id === propItemData.value);
                if (finded) {
                  setPropostaData(
                    {
                      ...propostaData,
                      propItens: [
                        ...propostaData.propItens.filter(pi => pi.propItem_id !== propItemData.propItem_id),
                        {
                          ...propItemData,
                          propItem_id: finded.propItem_id,
                          relacaoPropPropItem_id: finded.relacaoPropPropItem_id,
                          relacaoPropPropItem_propItemQtd: propItemData.relacaoPropPropItem_propItemQtd,
                          prop_id: finded.prop_id,
                        }
                      ]
                    }
                  );
                } else {
                  setPropostaData({...propostaData, propItens: [...propostaData.propItens, propItemData]});
                }
                setIsSubmitEntityLoading(false);
                setModalPropItemOpen(false)
              }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      {propostaData.propItens && propostaData.propItens.length > 0 && macroatividadeData && macroatividadeData.macroatividade_id && (
        <Modal
          centered={false}
          isOpen={modalPropItemToMacroatividadeOpen}
          toggle={() => setModalPropItemToMacroatividadeOpen(false)}
        >
          <ModalHeader>Adicionar {propItemData.propItemGr_label}</ModalHeader>

          <ModalBody>

            <FormGroup>
              <span>
                Selecione o item orçamentário
              </span>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={propItens.filter((pi) => {
                  const findedPropItem = propostaData.propItens.find(pi2 => pi2.propItem_id === pi.propItem_id);
                  let total = 0;
                  for (let index = 0; index < selectedMacroatividades.filter(sm => sm.propItens.filter(pi2 => pi.propItem_id === pi2.propItem_id).length > 0).length; index++) {
                    const element = selectedMacroatividades.filter(sm => {return sm.propItens.filter(pi2 => pi.propItem_id === pi2.propItem_id).length > 0})[index].propItens.find(pi2 => pi.propItem_id === pi2.propItem_id).relacaoMacroatividadePropItem_propItemQtd;
                    total = total + Number(element);
                  }
                  return pi.propItemGr_id === propItemData.propItemGr_id && findedPropItem && findedPropItem.relacaoPropPropItem_propItemQtd > total;
                })}
                onChange={async (e) => {
                  if (e) {
                    setPropItemData({
                      ...e,
                      relacaoMacroatividadePropItem_propItemQtd: 0,
                    })
                  } else {
                    setPropItemData({})
                  }
                }}
              />
            </FormGroup>

            <FormGroup>
              <span>
                Valor unitário
              </span>
              <MaskedInput
                unmask
                mask="R$ num"
                blocks={{
                  num: {
                    mask: Number,
                    scale: 2, // digits after point 0 for integers
                    signed: false, // disallow negative
                    thousandsSeparator: '.', // any single char
                    padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                    normalizeZeros: false, // appends or removes zeros at ends
                    radix: ',', // fractional delimiter
                    min: 0,
                    max: 1000000000,
                  },
                }}
                lazy={false}
                value={String(propItemData.relacaoMacroatividadePropItem_vlr)}
                onAccept={value => setPropItemData({...propItemData, relacaoMacroatividadePropItem_vlr: value})}
              />
            </FormGroup>

            <FormGroup>
              <span>
                Quantidade
              </span>
              <Input
              value={propItemData.relacaoMacroatividadePropItem_propItemQtd}
                onChange={async (e) => {
                  if (propItemData.propItem_id) {
                    let total = 0;
                    for (let index = 0; index < selectedMacroatividades.filter(sm => sm.propItens.filter(pi2 => propItemData.propItem_id === pi2.propItem_id).length > 0).length; index++) {
                      const element = selectedMacroatividades.filter(sm => {return sm.propItens.filter(pi2 => propItemData.propItem_id === pi2.propItem_id).length > 0})[index].propItens.find(pi2 => propItemData.propItem_id === pi2.propItem_id).relacaoMacroatividadePropItem_propItemQtd;
                      total = total + Number(element);
                    }
                    if (e.target.value && e.target.value !== '' && !isNaN(Number(e.target.value)) && Number(e.target.value) + total <= propostaData.propItens.find(pi2 => pi2.propItem_id === propItemData.propItem_id).relacaoPropPropItem_propItemQtd) {
                      setPropItemData({
                        ...propItemData,
                        relacaoMacroatividadePropItem_propItemQtd: Number(e.target.value)
                      })
                    }
                    else {
                      setPropItemData({
                        ...propItemData,
                        relacaoMacroatividadePropItem_propItemQtd: 0
                      })
                    }
                  }
                }}
              />
            </FormGroup>

          </ModalBody>

          <ModalFooter>
            <Button
              type="button"
              onClick={() => setModalPropItemToMacroatividadeOpen(false)}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Button>

            {isSubmitEntityLoading ? (
              <Button type="button" disabled>
                <Spinner />
              </Button>
            ) : (
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={()=>{
                  setIsSubmitEntityLoading(true);
                  setSelectedMacroatividades(selectedMacroatividades.map(macro => {
                    if (macroatividadeData.macroatividade_id === macro.macroatividade_id) {
                      return {...macro, propItens: [...macro.propItens, propItemData]};
                    } else {
                      return macro;
                    }
                  }));
                  setIsSubmitEntityLoading(false);
                  setModalPropItemToMacroatividadeOpen(false)}}
              >
                Salvar
              </Button>
            )}
          </ModalFooter>
        </Modal>
      )}

      {
        Object.keys(propostaData).length > 0 && Object.keys(propItemData).length > 0 &&
        <Modal
          centered={false}
          isOpen={modalPropItemEditOpen}
          toggle={() => setModalPropItemEditOpen(false)}
        >
          <ModalHeader>Edição {propItemData.propItemGr_label}</ModalHeader>

          <ModalBody>
            <FormGroup>
              <span>
                Selecione o item orçamentário
              </span>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isDisabled={true}
                value={propItens.find((pi) => {
                  return pi.propItem_id === propItemData.propItem_id;
                })}
              />
            </FormGroup>

            <FormGroup>
              <span>
                Valor unitário
              </span>
              <MaskedInput
                unmask
                disabled={true}
                mask="R$ num"
                blocks={{
                  num: {
                    mask: Number,
                    scale: 2, // digits after point 0 for integers
                    signed: false, // disallow negative
                    thousandsSeparator: '.', // any single char
                    padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                    normalizeZeros: false, // appends or removes zeros at ends
                    radix: ',', // fractional delimiter
                    min: 0,
                    max: 1000000000,
                  },
                }}
                lazy={false}
                value={String(propItemData.propItem_refVlr)}
                onAccept={value => setPropItemData({...propItemData, propItem_refVlr: value})}
              />
            </FormGroup>

            <FormGroup>
              <span>
                Quantidade
              </span>
              <Input
              value={propItemData.relacaoPropPropItem_propItemQtd}
                onChange={async (e) => {
                  if (propItemData.propItem_id) {
                    if (e.target.value && e.target.value !== '' && !isNaN(Number(e.target.value))) {
                      setPropItemData({
                        ...propItemData,
                        relacaoPropPropItem_propItemQtd: Number(e.target.value)
                      })
                    }
                    else {
                      setPropItemData({
                        ...propItemData,
                        relacaoPropPropItem_propItemQtd: 0
                      })
                    }
                  }
                }}
              />
            </FormGroup>

          </ModalBody>

          <ModalFooter>
            <Button
              type="button"
              onClick={() => setModalPropItemEditOpen(false)}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Button>

            {isSubmitEntityLoading ? (
              <Button type="button" disabled>
                <Spinner />
              </Button>
            ) : (
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={()=>{
                  setIsSubmitEntityLoading(true);
                  setPropostaData({...propostaData, propItens: propostaData.propItens.map(pi => {
                    if (pi.propItem_id === propItemData.propItem_id) {
                      return propItemData;
                    } else {
                      return pi;
                    }
                  })});
                  setPropItemData({});
                  setIsSubmitEntityLoading(false);
                  setModalPropItemEditOpen(false);
                }}
              >
                Salvar
              </Button>
            )}
          </ModalFooter>
        </Modal>
      }

      <Modal
        centered={false}
        isOpen={modalEditPropItemMacroatividadeOpen}
        toggle={() => setModalEditPropItemMacroatividadeOpen(false)}
      >
        <ModalHeader>Editar {propItemData.propItem_desc}</ModalHeader>

        <ModalBody>

          <FormGroup>
            <span>
              Quantidade
            </span>
            <Input
              value={Number(propItemData.relacaoMacroatividadePropItem_propItemQtd)}
              onChange={async (e) => {
                if (propItemData.propItem_id) {
                  if (e) {
                    if (
                      e.target.value &&
                      e.target.value !== '' &&
                      !isNaN(Number(e.target.value))
                    ) {
                      setPropItemData({
                        ...propItemData,
                        relacaoMacroatividadePropItem_propItemQtd: Number(e.target.value)
                      })
                    }
                    else {
                      setPropItemData({
                        ...propItemData,
                        relacaoMacroatividadePropItem_propItemQtd: 0
                      })
                    }
                  } else {
                    if (
                      e.target.value &&
                      e.target.value !== '' &&
                      !isNaN(Number(e.target.value))
                    ) {
                      setPropItemData({
                        ...propItemData,
                        relacaoMacroatividadePropItem_propItemQtd: Number(e.target.value)
                      })
                    }
                  }
                }
              }}
            />
          </FormGroup>

          <FormGroup>
            <span>
              Tempo estimado de execução (dias)
            </span>
            <Input
              value={propItemData.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias}
              onChange={async (e) => {
                if (propItemData.propItem_id) {
                  if (e) {
                    if (
                      e.target.value &&
                      e.target.value !== '' &&
                      !isNaN(Number(e.target.value))
                    ) {
                      setPropItemData({
                        ...propItemData,
                        relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: Number(e.target.value)
                      })
                    }
                    else {
                      setPropItemData({
                        ...propItemData,
                        relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: 0
                      })
                    }
                  } else {
                    if (
                      e.target.value &&
                      e.target.value !== '' &&
                      !isNaN(Number(e.target.value))
                    ) {
                      setPropItemData({
                        ...propItemData,
                        relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: Number(e.target.value)
                      })
                    }
                  }
                }
              }}
            />
          </FormGroup>

          {/* <FormGroup>
            <span>
              Valor para essa proposta
            </span>
            <MaskedInput
              unmask
              mask="R$ num"
              blocks={{
                num: {
                  mask: Number,
                  scale: 2, // digits after point 0 for integers
                  signed: false, // disallow negative
                  thousandsSeparator: '.', // any single char
                  padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                  normalizeZeros: false, // appends or removes zeros at ends
                  radix: ',', // fractional delimiter
                  min: 0,
                  max: 1000000000,
                },
              }}
              lazy={false}
              value={String(propItemData.relacaoMacroatividadePropItem_vlr)}
              onAccept={value => setPropItemData({...propItemData, relacaoMacroatividadePropItem_vlr: value})}
            />
          </FormGroup> */}

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => setModalEditPropItemMacroatividadeOpen(false)}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={async () => {
                handleUpdatePropItem();

                /*
                setIsSubmitEntityLoading(true);
                const formattedSelectedMacroatividades = selectedMacroatividades.map( (sm) => {
                  if (sm.macroatividade_id === macroatividadeData.macroatividade_id) {
                    return {...macroatividadeData, propItens: macroatividadeData.propItens.map(pi => {
                      if (pi.propItem_id === propItemData.propItem_id) {
                        return propItemData;
                      } else {
                        return pi;
                      }
                    })}
                  } else {
                    return sm;
                  }
                });

                const findedMacroatividade = formattedSelectedMacroatividades.find((sm) => sm.macroatividade_id === macroatividadeData.macroatividade_id)

                if (findedMacroatividade) {
                  setMacroatividadeData(findedMacroatividade);
                  setSelectedMacroatividades(formattedSelectedMacroatividades);
                } else {
                  setMacroatividadeData({...macroatividadeData, propItens: macroatividadeData.propItens.map(pi => {
                    if (pi.propItem_id === propItemData.propItem_id) {
                      return propItemData;
                    } else {
                      return pi;
                    }
                  })});
                  setSelectedMacroatividades([...formattedSelectedMacroatividades, macroatividadeData]);
                }


                console.log('findedMacroatividade', findedMacroatividade);
                console.log('formattedSelectedMacroatividades', formattedSelectedMacroatividades);
                console.log('macroatividadeData', macroatividadeData);

                if (propItemData.relacaoMacroatividadePropItem_id) {
                  await oikosApi.post(
                    '/',
                    {
                      action: 'update',
                      table: 'relacaoMacroatividadePropItem',
                      data: {
                        relacaoMacroatividadePropItem_id: propItemData.relacaoMacroatividadePropItem_id,
                        relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: propItemData.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias,
                        relacaoMacroatividadePropItem_propItemQtd: propItemData.relacaoMacroatividadePropItem_propItemQtd,
                        relacaoMacroatividadePropItem_ativo: 1,
                      }
                    }
                  )
                } else {
                  if (macroatividadeData.relacaoServicoMacroatividade_id) {
                    await oikosApi.post(
                      '/',
                      {
                        action: 'insert',
                        table: 'relacaoMacroatividadePropItem',
                        data: {
                          propItem_id: propItemData.propItem_id,
                          macroatividade_id: macroatividadeData.macroatividade_id,
                          relacaoServicoMacroatividade_id: macroatividadeData.relacaoServicoMacroatividade_id,
                          relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias: propItemData.relacaoMacroatividadePropItem_tempoEstimadoExecucaoDias,
                          relacaoMacroatividadePropItem_propItemQtd: propItemData.relacaoMacroatividadePropItem_propItemQtd,
                        }
                      }
                    )
                  }
                } */

                setModalEditPropItemMacroatividadeOpen(false);
                setIsSubmitEntityLoading(false)
              }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <ModalConfirmacao
        openModal={modalPropItemDeleteOpen}
        onClosed={()=>setModalPropItemDeleteOpen(false)}
        title={'Tem certeza que deseja deletar o recurso?'}
        subtitle={`Deletar o recurso "${propItemData.propItem_desc}" da proposta?`}
        confirmButtonText='Deletar'
        onConfirm={()=>{
          setPropostaData({...propostaData, propItens: propostaData.propItens.filter(pi => pi.propItem_id !== propItemData.propItem_id)});
          setModalPropItemDeleteOpen(false);
        }}
      />

    </Container>
  )
}

export default Orcamentacao
